/** @format */

import React, { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
// import { DownloadTableExcel } from 'react-export-table-to-excel';
import usePermission from "../../../config/permissions";
import {
  RenderSelectField,
  RenderInputField,
  RenderDateInputField,
  RenderInputTextareaField,
  DocumentSection,
  toTitleCase,
} from "../../../components/FormdataComponent";
import {
  AddTrackRecordDetails,
  DeleteTrackAndLetterDetails,
  UpdateTrackRecordDetails,
  DocumentModel,
  AssociatedLetters,
} from "../../../components/SiteManagement/ProjectDetailsCrudButtons";
import { formattedDateLong } from "../../../components/Date";
import axios from "axios";
import { BASE_URL } from "../../../config/axios";
import { axiosInstance2 } from "../../../config/axiosInstance";
import Dashboardnavbar from "../../../layout/Dashboardnavbar";
import {
  handleErrorToast,
  sortProjects,
  uploadFileInChunks,
  FileDataReader,
  CustomModel,
  CSSForSelect,
  DateRangePicker,
  CSSForSelectSmallWidth,
  calculateNextDate,
  CSSForFilterDropdown,
  CSSForSelectModern
} from "../../../components/CustomFunctions";
import {
  CircularGrid,
  SearchBig,
  SearchSmall,
  AddwithWhiteCircle,
  DropdownArrow,
  // SubCompany,
  ExchangeTypee,
  Status,
  Authority,
  DownloadIcon,
  CrosswithRedCircle,
  UpdatePencil,
  Eye,
  Year,
} from "../../../components/AllSvg";
import { ContractorFilter, CoordinatorFilter, LetterNumberFilter, LetterStatus, LetterType, SubCompany } from "../../../components/FilterDropdown";
import { Projects } from "../../../components/FilterDropdown";
import { UploadLetterBulk } from "../../../components/SiteManagement/BulkModals";
import Modal from "react-bootstrap/Modal";
import SkeletonLoader from "../../../components/Skeletonloader";
// import SkeletonLoader from "../../components/Skeletonloader";
import Select from "react-select";
import { useLocation } from "react-router-dom";

import TableWithPagination from "./Tablewithpagination";
import { DownloadTableExcel } from "react-export-table-to-excel";

import DateRangePickerComponent from "../componets/DateRangePickerComponent";
import dayjs from "dayjs";

import StatusBar from "../../../components/StatusBar/StatusBar";
import Advancedstats from "../../../components/StatusBar/Advancedstats";

import SortingTable from "../componets/SortingTable";
import LetterTable from "./LetterStatsGrid";

import * as XLSX from "xlsx";
import { DownloadLetters } from "./DownloadData";
import { BulkLetterDelete } from "../../../components/SiteManagement/BulkDeleteButtons";
import DownloadAllLetters from "./LetterDownload";
import LetterTrackingDashboard from "../../../components/csmsdashboards/LetterTrackingDashboard";
import { Activity, AlertCircle, Briefcase, Building2, Calendar, ChevronRight, Clock, FileText, Hash, Link2, Loader, Mail, MapPin, Paperclip, Save, Users, X } from "lucide-react";

// const AddLetterLinked = ({
//   getProjects,
//   projectList,
//   projectId,
//   contractor,
//   contractorlist,
//   lettertype,
//   letterfor,
//   letterData,
//   LetterTypeOptions,
//   siteCode,
//   projectName,
//   letterTypeList,
//   LetterName,
//   title,
// }) => {
//   const [oldestYear, setOldestYear] = useState("");
//   const [previousprogressdata, setPreviousProgressData] = useState([]);
//   const [show, setShow] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [inputState, setInputState] = useState({});
//   const [fileNames, setFileNames] = useState([]);
//   const [trackRecordList, setTrackRecordList] = useState([]);
//   const [buffer, setBuffering] = useState(true);
//   const [siteDepartmentList, setSiteDepartmentList] = useState([]);
//   const [contractorlists, setContractorLists] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0); // For upload progress
//   const [eotinputState, seteotInputState] = useState({});
//   const [cosinputState, setcosInputState] = useState({});
//   const [eotList, setEotList] = useState([]);
//   const [mileStoneinputState, setmileStoneInputState] = useState({});
//   const [progressInputState, setprogressInputState] = useState({});
//   const [mileStoneList, setmileStoneList] = useState([]);
//   const [progressList, setprogressList] = useState([]);
//   const [mileStoneID, setmileStoneId] = useState("null");
//   const [progressID, setprogressID] = useState("null");
//   const [cosList, setCosList] = useState([]);
//   const [eotID, setEotId] = useState("null");
//   const [cosID, setCosId] = useState("null");
//   const [contractorData, setContractorData] = useState({});
//   const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
//   const [LetterId, setletterId] = useState("null");

//   const months = [
//     { text: "January", value: 1 },
//     { text: "February", value: 2 },
//     { text: "March", value: 3 },
//     { text: "April", value: 4 },
//     { text: "May", value: 5 },
//     { text: "June", value: 6 },
//     { text: "July", value: 7 },
//     { text: "August", value: 8 },
//     { text: "September", value: 9 },
//     { text: "October", value: 10 },
//     { text: "November", value: 11 },
//     { text: "December", value: 12 },
//   ];

//   const handleShow = () => {
//     setShow(true);
//     getSiteDepartment();
//   };

//   const handleClose = () => {
//     setFileNames("");
//     setErrors("");
//     setShow(false);
//     setFormData({
//       project: projectId ? projectId : "null",
//       letter_num: "",
//       reply_by: "",
//       other_type_name: "",
//       other_letter_to: "",
//       other_letter_from: "",
//       subject: "",
//       division: "59408e4e-a455-46b6-b3db-8deaa0ae4475",
//       letter_date: "null",
//       status: "pending",
//       workperformedby: letterfor ? letterfor : "null",
//       lettertype: lettertype ? lettertype : "null",
//       letterExchange:
//         sessionStorage.getItem("sitemanagement_role") === "SiteManagement"
//           ? "receive"
//           : "send",
//       is_timebound: false,
//       associated_letters: [],
//       associated_letters_status: "pending",
//       letterdepartment: "",
//       letter_from: "null",
//       letter_to: "",
//       documents: [{ document_name: "", document_file: "" }],
//       contractor: contractor ? contractor : "",
//       remarks: "",
//       select: "",
//       tat_duration: 0,
//       end_date: null,
//     });

//     setEOTFormData({
//       project: formData.project ? formData.project : "null",
//       eot_code: "",
//       workperformedby: formData.workperformedby ? formData.workperformedby : "",
//       approved_days: "",
//       approved_date: "",
//       close_letter: "",
//       letter: "",
//       contractor: "",
//       process_initiate_date: "",
//       eot_status: "pending",
//       days: "",
//     });

//     setCOSFormData({
//       project: formData.project ? formData.project : "null",
//       cos_code: "",
//       approval_date: "",
//       contractor: "",
//       process_initiate_date: "",
//       cos_status: "pending",
//       amount: "",
//       workperformedby: formData.workperformedby ? formData.workperformedby : "",
//       letter: "",
//       approved_amount: "",
//       close_letter: "",
//       cos_type: "",
//       negativeamount: "",
//     });

//     setmileStoneFormData({
//       name: "",
//       milestone_date: "",
//       milestone_as_per_reschedule: "",
//       milestone_as_per_actual: "",
//       day: "",
//       rescedule_gap_days: "",
//       actual_gap_days: "",
//       workperformedby: "contractor",
//       project: formData.project ? formData.project : "null",
//       reschedule_letter: "",
//       contractor: "",
//       actual_letter: "",
//     });

//     setProgressErrors("");
//   };

//   const [formData, setFormData] = useState({
//     project: projectId ? projectId : "null",
//     letter_num: "",
//     reply_by: "",
//     subject: "",
//     division: "59408e4e-a455-46b6-b3db-8deaa0ae4475",
//     letter_date: "null",
//     status: "pending",
//     workperformedby: letterfor
//       ? letterfor
//       : sessionStorage.getItem("sitemanagement_role") === "SiteManagement"
//         ? "contractor"
//         : "consultant",
//     lettertype: lettertype ? lettertype : "null",
//     letterExchange:
//       "receive",

//     associated_letters: [],
//     associated_letters_status: "pending",
//     letterdepartment: "",
//     letter_from: "",
//     letter_to: "",
//     other_letter_from: "",
//     other_letter_to: "",
//     documents: [{ document_name: "", document_file: "", original_filename: "", }],
//     contractor: contractor ? contractor : "",
//     remarks: "",
//     select: "",
//     tat_duration: 0,
//     end_date: null,
//     other_type_name: "",
//     is_timebound: false,
//   });

//   // const filteredData = eotList.filter(i => i.id === eotID);
//   const [filteredData, setFilteredData] = useState([]);
//   const [cosFilteredData, setcosFilteredData] = useState([]);
//   const [mileStoneFilteredData, setmileStoneFilteredData] = useState([]);
//   const [progressfilterData, setprogressfilterData] = useState([]);

//   console.log("EOTcoDE");
//   console.log(filteredData[0]?.eot_code);
//   console.log(filteredData);

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       project: projectId,
//     }));
//   }, [projectId]);

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       workperformedby: letterfor,
//     }));
//   }, [letterfor]);

//   const [eotFormData, setEOTFormData] = useState({
//     project: formData.project ? formData.project : "null",
//     eot_code: "",
//     workperformedby: "",
//     approved_days: "",
//     approved_date: "",
//     close_letter: "",
//     letter: "",
//     contractor: "",
//     process_initiate_date: "",
//     eot_status: "pending",
//     days: "",
//   });

//   const [cosFormData, setCOSFormData] = useState({
//     project: formData.project ? formData.project : "null",
//     cos_code: "",
//     approval_date: "",
//     contractor: "",
//     process_initiate_date: "",
//     cos_status: "pending",
//     amount: "",
//     workperformedby: "",
//     letter: "",
//     approved_amount: "",
//     close_letter: "",
//     cos_type: "",
//     negativeamount: "",
//   });
//   const [mileStoneFormData, setmileStoneFormData] = useState({
//     name: "",
//     milestone_date: "",
//     milestone_as_per_reschedule: "",
//     milestone_as_per_actual: "",
//     day: "",
//     rescedule_gap_days: "",
//     actual_gap_days: "",
//     workperformedby: "",
//     project: formData.project ? formData.project : "null",
//     reschedule_letter: "",
//     contractor: "",
//     actual_letter: "",
//     mile_stone_type: "null",
//   });

//   const [progressData, setProgressData] = useState({
//     project: formData.project ? formData.project : "null",
//     submitted_financial_progress: "0",
//     submitted_physical_progress: "0",
//     month: "",
//     year: "",
//     submitted_letter: "",
//     contractor,
//     financial_progress: "0",
//     approved_letter: "",
//     physical_progress: "0",
//     date: "null",
//   });

//   const calculateActualDays = (commencementDate, letterDate) => {
//     if (!commencementDate || !letterDate) return null;
//     const startDate = new Date(commencementDate);
//     const endDate = new Date(letterDate);
//     const timeDifference = endDate - startDate;
//     const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
//     return daysDifference;
//   };

//   useEffect(() => {
//     setEotId("null");
//     seteotInputState({});
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       letter_date: "null",
//     }));
//     setErrors("");
//     setEOTFormData({
//       project: formData.project || "",
//       eot_code: "",
//       workperformedby: "",
//       approved_days: "",
//       approved_date: "",
//       close_letter: "",
//       letter: "",
//       contractor: "",
//       process_initiate_date: "",
//       eot_status: "pending",
//       days: "",
//     });

//     setCosId("null");
//     setcosInputState({});

//     setCOSFormData({
//       project: formData.project || "",
//       cos_code: "",
//       approval_date: "",
//       contractor: "",
//       process_initiate_date: "",
//       cos_status: "pending",
//       amount: "",
//       workperformedby: "",
//       letter: "",
//       approved_amount: "",
//       close_letter: "",
//       cos_type: "",
//       negativeamount: "",
//     });

//     setmileStoneId("null");
//     setmileStoneInputState({});
//     setmileStoneFormData({
//       name: "",
//       milestone_date: "",
//       milestone_as_per_reschedule: "",
//       milestone_as_per_actual: "",
//       day: "",
//       rescedule_gap_days: "",
//       actual_gap_days: "",
//       workperformedby: "",
//       project: formData.project || "",
//       reschedule_letter: "",
//       contractor: "",
//       actual_letter: "",
//     });
//     setprogressID("null");
//     setprogressInputState({});
//     setProgressData({
//       project: formData.project || "",
//       submitted_financial_progress: "0",
//       submitted_physical_progress: "0",
//       month: "",
//       year: "",
//       submitted_letter: "",
//       contractor,
//       financial_progress: "0",
//       approved_letter: "",
//       physical_progress: "0",
//     });
//   }, [
//     formData.workperformedby,
//     formData.contractor,
//     formData.project,
//     formData.select,
//     formData.lettertype,
//   ]);

//   useEffect(() => {
//     setEOTFormData({
//       approved_days: "",
//       eot_status: "",
//     });
//     setCOSFormData({
//       approved_amount: "",
//       cos_status: "",
//     });
//     setProgressData((prev) => ({
//       ...prev,
//       month: "",
//       year: "",
//     }));
//     setmileStoneFormData({
//       mile_stone_type: "null",
//     });
//     setFormData((prev) => ({
//       ...prev,
//       letter_date: "null",
//     }));
//   }, [eotID, cosID, mileStoneID, progressID]);

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       lettertype: "null",
//     }));
//   }, [formData.workperformedby, formData.division]);

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       other_type_name: "",
//     }));
//   }, [formData.lettertype]);

//   useEffect(() => {
//     if (
//       (Array.isArray(contractorlist) && contractorlist.length < 0) ||
//       (Array.isArray(contractorlists) && contractorlists.length < 0)
//     ) {
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         workperformedby: "consultant",
//         contractor: contractor ? contractor : "",
//       }));
//     } else {
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         workperformedby: letterfor ? letterfor : "null",
//         contractor: contractor ? contractor : "",
//       }));
//     }
//   }, [formData.project]);


//   console.log("formData")
//   console.log(formData)

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       letter_from: null,
//       letter_to: null,
//       other_letter_from: "",
//       other_letter_to: "",
//     }));
//   }, [formData.letterExchange]);
//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       other_letter_from: "",
//       other_letter_to: "",
//     }));
//   }, [formData.letter_from, formData.letter_to]);

//   useEffect(() => {
//     if (eotID !== "null") {
//       const data = eotList.filter((i) => i.id === eotID);
//       setFilteredData(data);
//     } else if (cosID !== "null") {
//       const data = cosList.filter((i) => i.id === cosID);
//       setcosFilteredData(data);
//     } else if (mileStoneID !== "null") {
//       const data = mileStoneList.filter((i) => i.id === mileStoneID);
//       setmileStoneFilteredData(data);
//     } else if (progressID !== "null") {
//       const data = progressList.filter((i) => i.id === progressID);
//       setprogressfilterData(data);
//     } else {
//       setFilteredData([]);
//       setcosFilteredData([]);
//       setmileStoneFilteredData([]);
//       setprogressfilterData([]);
//     }
//   }, [
//     eotID,
//     eotList,
//     cosID,
//     cosList,
//     mileStoneID,
//     mileStoneList,
//     progressID,
//     progressList,
//   ]);




//   useEffect(() => {
//     const days = calculateActualDays(
//       contractorData.commencement_date,
//       formData.letter_date
//     );
//     if (eotID !== "null") {
//       if (filteredData.length > 0) {
//         const data = filteredData[0];
//         setEOTFormData((prev) => ({
//           ...prev,
//           project: formData.project,
//           workperformedby: formData.workperformedby,
//           contractor: formData.contractor,
//           approved_date: formData.letter_date,
//           process_initiate_date: data?.process_initiate_date,
//           eot_code: data?.eot_code,
//           letter: data?.letter,
//           days: data?.days,
//           close_letter: data.close_letter
//             ? data?.close_letter
//             : formData?.letter,
//         }));
//       }
//     }
//     if (cosID !== "null") {
//       if (cosFilteredData.length > 0) {
//         const data = cosFilteredData[0];
//         setCOSFormData((prev) => ({
//           ...prev,
//           project: formData.project,
//           workperformedby: formData.workperformedby,
//           contractor: formData.contractor,
//           approval_date: formData.letter_date,
//           amount: data?.amount,
//           process_initiate_date: data?.process_initiate_date,
//           cos_code: data?.cos_code,
//           letter: data?.letter,
//           cos_type: data?.cos_type,
//           negativeamount: data?.negativeamount,
//           close_letter: data?.close_letter
//             ? data?.close_letter
//             : formData?.letter,
//         }));
//       }
//     }
//     if (progressID !== "null") {
//       if (progressfilterData.length > 0) {
//         const data = progressfilterData[0];
//         setProgressData((prev) => ({
//           ...prev,
//           project: formData.project,
//           submitted_physical_progress: data?.submitted_physical_progress,
//           submitted_financial_progress: data?.submitted_financial_progress,
//           month: data?.month,
//           year: data?.year,
//           submitted_letter: data?.submitted_letter,
//           approved_letter: formData?.letter,
//           contractor: formData.contractor,
//           date: formData.date,
//         }));
//       }
//     }
//     if (
//       mileStoneID !== "null" &&
//       mileStoneFormData.mile_stone_type === "actual"
//     ) {
//       if (mileStoneFilteredData.length > 0) {
//         const data = mileStoneFilteredData[0];
//         setmileStoneFormData((prev) => ({
//           ...prev,
//           project: formData.project,
//           workperformedby: formData.workperformedby,
//           contractor: formData.contractor,
//           milestone_as_per_actual: formData.letter_date,
//           milestone_as_per_reschedule: null,
//           rescedule_gap_days: "",
//           actual_gap_days: days,
//           milestone_date: data?.milestone_date,
//           name: data?.name,
//           day: data?.day,
//           // close_letter: formData?.letter,
//         }));
//       }
//     }
//     if (
//       mileStoneID !== "null" &&
//       mileStoneFormData.mile_stone_type === "reschedule"
//     ) {
//       if (mileStoneFilteredData.length > 0) {
//         const data = mileStoneFilteredData[0];
//         setmileStoneFormData((prev) => ({
//           ...prev,
//           project: formData.project,
//           workperformedby: formData.workperformedby,
//           contractor: formData.contractor,
//           milestone_as_per_reschedule: formData.letter_date,
//           milestone_date: data?.milestone_date,
//           rescedule_gap_days: days,
//           day: data?.day,
//           milestone_as_per_actual: null,
//           actual_gap_days: "",
//           // close_letter: formData?.letter,
//         }));
//       }
//     }
//     if (cosFormData.cos_status === "rejected") {
//       setCOSFormData((prev) => ({
//         ...prev,
//         approved_amount: "",
//       }));
//     }
//     if (formData.lettertype === "eot" && eotID === "null") {
//       setEOTFormData((prev) => ({
//         ...prev,
//         contractor: formData.contractor,
//         project: formData.project,
//         workperformedby: formData.workperformedby,
//         process_initiate_date: formData.letter_date,
//         approved_date: null,
//         eot_code: "",
//         letter: "",
//         days: "",
//       }));
//     }
//     if (formData.lettertype === "cos" && cosID === "null") {
//       setCOSFormData((prev) => ({
//         ...prev,
//         contractor: formData.contractor,
//         project: formData.project,
//         workperformedby: formData.workperformedby,
//         process_initiate_date: formData.letter_date,
//         approval_date: null,
//         cos_code: "",
//         letter: "",
//         amount: "",
//         negativeamount: "",
//         cos_type: "",
//       }));
//     }
//     if (formData.lettertype === "SiteProgress" && progressID === "null") {
//       setProgressData((prev) => ({
//         ...prev,
//         contractor: formData.contractor,
//         project: formData.project,
//         submitted_letter: "",
//         financial_progress: "",
//         physical_progress: "",
//         month: "",
//         year: "",
//         submitted_physical_progress: "",
//         submitted_financial_progress: "",
//       }));
//     }
//   }, [
//     formData.project,
//     formData.workperformedby,
//     formData.contractor,
//     formData.letter_date,
//     formData.select,
//     formData.lettertype,
//     eotID,
//     eotFormData.eot_status,
//     cosID,
//     cosFormData.cos_status,
//     mileStoneID,
//     mileStoneFormData.mile_stone_type,
//     contractorData.commencement_date,
//     progressID,
//   ]);

//   function addDaysToLetterDate(letterDate, daysToAdd) {
//     const date = new Date(letterDate);
//     date.setDate(date.getDate() + daysToAdd);

//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const day = String(date.getDate()).padStart(2, "0");

//     return `${year}-${month}-${day}`;
//   }

//   useEffect(() => {
//     if (cosFormData.cos_type === "positivecos") {
//       setCOSFormData((prev) => ({
//         ...prev,
//         negativeamount: "",
//       }));
//     }
//     if (cosFormData.cos_type === "negativecos") {
//       setCOSFormData((prev) => ({
//         ...prev,
//         amount: "",
//       }));
//     } else {
//       setCOSFormData((prev) => ({
//         ...prev,
//         amount: "",
//         negativeamount: "",
//       }));
//     }
//   }, [cosFormData.cos_type]);

//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       letter_date: "null",
//     }));

//     setmileStoneFormData((prev) => ({
//       ...prev,
//       actual_gap_days: "",
//       rescedule_gap_days: "",
//     }));
//   }, [mileStoneFormData.mile_stone_type]);

//   useEffect(() => {
//     setFormData((prevData) => ({
//       ...prevData,
//       select: "",
//       is_timebound: false,
//     }));
//   }, [formData.lettertype]);

//   useEffect(() => {
//     const letter_tat = letterData?.find(item => item?.letter_type_data?.name === formData?.lettertype);
//     if (letter_tat) {
//       setFormData((prev) => ({
//         ...prev,
//         tat_duration: Number(letter_tat.tat_duration),
//         end_date: addDaysToLetterDate(formData.letter_date, letter_tat.tat_duration),
//       }));
//     }
//   }, [formData.lettertype, formData.letter_date, letterData, formData.is_timebound]);

//   useEffect(() => {
//     if (formData.is_timebound === false) {
//       setFormData((prev) => ({
//         ...prev,
//         end_date: null,
//       }));
//     }



//   }, [formData.is_timebound])




//   useEffect(() => {
//     if (formData.tat_duration) {
//       setFormData((prev) => ({
//         ...prev,
//         end_date: addDaysToLetterDate(
//           formData.letter_date,
//           Number(formData.tat_duration)
//         ),
//       }));
//     }

//   }, [formData.tat_duration, formData.letter_date]);




//   const validateForm = () => {
//     const requiredFields = [
//       "letter_num",
//       "project",
//       "subject",
//       "letter_date",
//       "status",
//       "lettertype",

//       "workperformedby",
//       // 'letterdepartment',
//       // 'letter_from',
//       // 'letter_to',
//     ];
//     const newErrors = requiredFields.reduce((acc, field) => {
//       if (
//         !formData[field] ||
//         formData[field] === "null" ||
//         (Array.isArray(formData[field]) && formData[field].length === 0)
//       ) {
//         acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
//           } is required!`;
//       }
//       return acc;
//     }, {});
//     if (formData.workperformedby === "contractor" && !formData.contractor) {
//       newErrors["contractor"] = "Contractor Name is required!";
//     }
//     if (
//       formData.lettertype === "other" &&
//       (!formData.other_type_name || formData.other_type_name.trim() === "")
//     ) {
//       newErrors["other_type_name"] = `Other Letter Name is required!`;
//     }
//     if (
//       formData.is_timebound === true &&
//       (formData.tat_duration === null ||
//         formData.tat_duration === "" ||
//         formData.tat_duration === undefined)
//     ) {
//       newErrors["tat_duration"] = "Letter TAT Duration is required!";
//     }

//     if (
//       formData.letter_from === "other" &&
//       formData.letterExchange === "receive" &&
//       (!formData.other_letter_from || formData.other_letter_from.trim() === "")
//     ) {
//       newErrors["other_letter_from"] = `Other Letter From is required!`;
//     }
//     if (
//       formData.letter_to === "other" &&
//       formData.letterExchange === "send" &&
//       (!formData.other_letter_to || formData.other_letter_to.trim() === "")
//     ) {
//       newErrors["other_letter_to"] = `Other Letter To is required!`;
//     }
//     // if (
//     //   (formData.lettertype === "eot" ||
//     //     formData.lettertype === "cos" ||
//     //     formData.lettertype === "Milestone" ||
//     //     formData.lettertype === "SiteProgress") &&
//     //   (!formData.select || formData.select.trim() === "")
//     // ) {
//     //   newErrors["select"] = `Select ${formData.lettertype} is required`;
//     // }
//     if (formData.select === "new") {
//       if (
//         formData.lettertype === "eot" &&
//         (!eotFormData.eot_code || eotFormData.eot_code.trim() === "")
//       ) {
//         newErrors["eot_code"] = `eot_code is required`;
//       }
//       if (
//         formData.lettertype === "eot" &&
//         (!eotFormData.days || eotFormData.days.trim() === "")
//       ) {
//         newErrors["days"] = `Initiate days are required`;
//       }
//       if (
//         formData.lettertype === "cos" &&
//         (!cosFormData.cos_code || cosFormData.cos_code.trim() === "")
//       ) {
//         newErrors["cos_code"] = `cos_code is required`;
//       }
//       if (
//         formData.lettertype === "cos" &&
//         (!cosFormData.cos_type || cosFormData.cos_type.trim() === "")
//       ) {
//         newErrors["cos_type"] = `COS Type is required`;
//       }
//       if (
//         formData.lettertype === "cos" &&
//         cosFormData.cos_type === "negativecos" &&
//         (!cosFormData.negativeamount ||
//           cosFormData.negativeamount.trim() === "")
//       ) {
//         newErrors["negativeamount"] = `Negative Amount is required`;
//       }
//       if (
//         formData.lettertype === "cos" &&
//         cosFormData.cos_type === "negativecos" &&
//         (!cosFormData.amount || cosFormData.amount.trim() === "")
//       ) {
//         newErrors["amount"] = `Positive Amount is required`;
//       }
//       if (
//         formData.lettertype === "SiteProgress" &&
//         (!progressData.month || progressData.month.trim() === "")
//       ) {
//         newErrors["month"] = `Month is required`;
//       }
//       if (
//         formData.lettertype === "SiteProgress" &&
//         (!progressData.year || progressData.year.trim() === "")
//       ) {
//         newErrors["year"] = `Year is required`;
//       }
//     }

//     if (formData.select === "existing") {
//       if (formData.lettertype === "eot" && eotID === "null") {
//         newErrors["eotID"] = `Existing Eot is required`;
//       }
//       if (
//         formData.lettertype === "eot" &&
//         eotID !== "null" &&
//         (!eotFormData.eot_status || eotFormData.eot_status.trim() === "")
//       ) {
//         newErrors["eot_status"] = `Eot Status is required`;
//       }
//       if (
//         formData.lettertype === "eot" &&
//         eotID !== "null" &&
//         eotFormData.eot_status === "Approved" &&
//         (!eotFormData.approved_days || eotFormData.approved_days.trim() === "")
//       ) {
//         newErrors["approved_days"] = `Approved Days is required`;
//       }
//       if (
//         formData.lettertype === "eot" &&
//         eotID !== "null" &&
//         (!formData.associated_letters ||
//           formData.associated_letters.length === 0)
//       ) {
//         newErrors["associated_letters"] = `Associated Letter  is required`;
//       }
//       if (formData.lettertype === "cos" && cosID === "null") {
//         newErrors["cosID"] = `Existing COS is required`;
//       }
//       if (
//         formData.lettertype === "cos" &&
//         cosID !== "null" &&
//         (!cosFormData.cos_status || cosFormData.cos_status.trim() === "")
//       ) {
//         newErrors["cos_status"] = `COS Status is required`;
//       }
//       if (
//         formData.lettertype === "cos" &&
//         cosID !== "null" &&
//         cosFormData.cos_status === "Approved" &&
//         (!cosFormData.approved_amount ||
//           cosFormData.approved_amount.trim() === "")
//       ) {
//         newErrors["approved_amount"] = `Approved Amount is required`;
//       }
//       if (
//         formData.lettertype === "cos" &&
//         cosID !== "null" &&
//         (!formData.associated_letters ||
//           formData.associated_letters.length === 0)
//       ) {
//         newErrors["associated_letters"] = `Associated Letter  is required`;
//       }
//       if (formData.lettertype === "Milestone" && mileStoneID === "null") {
//         newErrors["mileStoneID"] = `Existing Milestone is required`;
//       }
//       if (
//         formData.lettertype === "Milestone" &&
//         mileStoneID !== "null" &&
//         (!mileStoneFormData.mile_stone_type ||
//           mileStoneFormData.mile_stone_type.trim() === "null")
//       ) {
//         newErrors["mile_stone_type"] = `MileStone Type is required`;
//       }
//       if (formData.lettertype === "SiteProgress" && progressID === "null") {
//         newErrors["progressID"] = `Existing Site Progress is required`;
//       }
//     }

//     if (
//       formData.associated_letters &&
//       formData.associated_letters.length > 0 &&
//       !formData.associated_letters_status
//     ) {
//       newErrors["associated_letters_status"] =
//         "Status for associated letters is required!";
//     }

//     // Validate documents array
//     formData.documents.forEach((doc, index) => {
//       if (!doc.document_name || doc.document_name.trim() === "") {
//         newErrors[`document_name_${index}`] = `Letter Name  ${index + 1
//           } is required for document ${index + 1}`;
//       }
//       if (!doc.document_file) {
//         newErrors[`document_file_${index}`] = `Document File ${index + 1
//           } is required for document ${index + 1}`;
//       }
//     });

//     setErrors(newErrors);
//     setIsSubmitted(true);
//     return Object.keys(newErrors).length === 0;
//   };

//   console.log("errors");
//   console.log(errors);

//   const getContractorData = async () => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/siteproject/contractor/${formData.contractor}/`
//       );
//       setContractorData(res.data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (formData.contractor) {
//       getContractorData();
//     }
//   }, [formData.contractor]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked, options } = e.target;

//     let newValue;
//     if (type === "checkbox") {
//       newValue = checked;
//     } else if (type === "select-multiple") {
//       newValue = Array.from(options)
//         .filter((option) => option.selected)
//         .map((option) => option.value);
//     } else {
//       newValue = value;
//     }

//     if (name === "letter_date") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();

//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);

//       if (selectedDate > todayDate) {
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return; // stop updating invalid value
//       } else {
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           [name]: "",
//         }));
//       }
//     }

//     // === Word limit for other_type_name ===
//     if (name === "other_type_name") {
//       const charCount = value.trim().length;

//       if (charCount > 15) {
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           other_type_name: "Maximum 15 characters allowed.",
//         }));
//         return;
//       } else {
//         setErrors((prevErrors) => ({
//           ...prevErrors,
//           other_type_name: "",
//         }));
//       }
//     }


//     // === Update input state for validation feedback ===
//     setInputState((prevState) => ({
//       ...prevState,
//       [name]:
//         newValue && (Array.isArray(newValue) ? newValue.length > 0 : newValue)
//           ? "success"
//           : "",
//     }));

//     // === Update form data with additional logic ===
//     setFormData((prevFormData) => {
//       const updatedFormData = {
//         ...prevFormData,
//         [name]: newValue,

//         ...(name === "reply_by" &&
//           prevFormData.letterExchange === "send" && {
//           letter_from: value,
//         }),

//         ...(name === "workperformedby" &&
//           value === "consultant" && {
//           contractor: "",
//         }),
//       };

//       return updatedFormData;
//     });
//   };


//   const ProjectListOption = projectList
//     ?.sort((a, b) => a.site_prcode.localeCompare(b.site_prcode))
//     .map((i) => ({
//       value: i.id,
//       label: `${i.site_prcode} - ${i.project_short_name}`,
//     }));
//   const ContractorListOption = contractorlists
//     ?.sort((a, b) => a.name.localeCompare(b.name))
//     .map((i) => ({
//       value: i.name,
//       label: `${i.name}`,
//     }));

//   const extendedLetterOptions = [
//     ...ContractorListOption,
//     { label: "Other", value: "other" },
//   ];

//   const handleProjectChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         project: "",
//       });
//     } else {
//       setFormData({
//         ...formData,
//         project: selectedOption.value,
//       });
//     }

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.project;
//       return updatedErrors;
//     });
//   };
//   const handleContractorInputChange = (selectedOption) => {
//     if (!selectedOption) {
//       if (formData.letterExchange === "receive") {
//         setFormData({
//           ...formData,
//           letter_from: "",
//         });
//       } else if (formData.letterExchange === "send") {
//         setFormData({
//           ...formData,
//           letter_to: "",
//         });
//       }
//     } else {
//       if (formData.letterExchange === "receive") {
//         setFormData({
//           ...formData,
//           letter_from: selectedOption.value,
//           letter_to: "",
//         });
//       } else if (formData.letterExchange === "send") {
//         setFormData({
//           ...formData,
//           letter_to: selectedOption.value,
//           letter_from: "",
//         });
//       }
//     }

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.project;
//       return updatedErrors;
//     });
//   };

//   // *******************************Letter Type And Division Functionality*****************************//
//   const handleLetterTypeOption = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         lettertype: "null",
//       });
//     } else {
//       setFormData({
//         ...formData,
//         lettertype: selectedOption.value,
//       });
//     }

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.lettertype;
//       return updatedErrors;
//     });
//   };

//   // **************************End of Functionality*************************//

//   const handleEotInputChange = (e) => {
//     const { name, value } = e.target;
//     seteotInputState({
//       ...eotinputState,
//       [name]: value.trim() ? "green" : "",
//     });
//     setEOTFormData({
//       ...eotFormData,
//       [name]: value,
//     });
//   };
//   const handleCOSInputChange = (e) => {
//     const { name, value } = e.target;
//     setcosInputState({
//       ...cosinputState,
//       [name]: value.trim() ? "green" : "",
//     });
//     setCOSFormData({
//       ...cosFormData,
//       [name]: value,
//     });
//   };
//   const handleMilestoneChange = (e) => {
//     const { name, value } = e.target;
//     setmileStoneInputState({
//       ...mileStoneinputState,
//       [name]: value.trim() ? "green" : "",
//     });
//     setmileStoneFormData({
//       ...mileStoneFormData,
//       [name]: value,
//     });
//   };

//   const [progresserrors, setProgressErrors] = useState({
//     submitted_physical_progress: "",
//     submitted_financial_progress: "",
//   });

//   const handleProgressData = (e) => {
//     const { name, value } = e.target;
//     let errorMessage = "";

//     if (name === "submitted_physical_progress") {
//       if (
//         Number(value) < previousprogressdata.physical_progress ||
//         Number(value) > 100
//       ) {
//         errorMessage = `Value must be between ${previousprogressdata.physical_progress}% - 100%`;
//       }
//     }
//     if (name === "physical_progress") {
//       if (
//         Number(value) < previousprogressdata.physical_progress ||
//         Number(value) > 100
//       ) {
//         errorMessage = `Value must be between ${previousprogressdata.physical_progress}% - 100%`;
//       }
//     }

//     if (name === "financial_progress") {
//       if (
//         Number(value) < previousprogressdata.financial_progress ||
//         Number(value) > 100
//       ) {
//         errorMessage = `Value must be between ${previousprogressdata.financial_progress}% - 100%`;
//       }
//     }
//     if (name === "submitted_financial_progress") {
//       if (
//         Number(value) < previousprogressdata.financial_progress ||
//         Number(value) > 100
//       ) {
//         errorMessage = `Value must be between ${previousprogressdata.financial_progress}% - 100%`;
//       }
//     }
//     setprogressInputState({
//       ...progressInputState,
//       [name]: value.trim() ? "green" : "",
//     });

//     setProgressData({
//       ...progressData,
//       [name]: value,
//     });

//     setProgressErrors((prevErrors) => ({
//       ...prevErrors,
//       [name]: errorMessage,
//     }));
//   };

//   const [projectNAmeCode, setProjectNameCode] = useState([]);

//   useEffect(() => {
//     const projectData = projectList?.filter(i => i.id === formData.project);

//     const projectName = projectData?.map((i) => ({
//       code: i.site_prcode,
//       name: i.project_short_name,
//     }));

//     setProjectNameCode(projectName)


//   }, [formData.project, projectList]);




//   const handleDocInputChange = (index, e) => {
//     const { name, value, files } = e.target;

//     setFormData((prevFormData) => {
//       const newDocuments = [...prevFormData.documents];

//       // if it's a file input
//       if (files && files[0]) {
//         const file = files[0];

//         // ✅ Allowed file types
//         const allowedTypes = [
//           "application/pdf",
//           "application/zip", "application/x-zip-compressed",
//           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//           "application/vnd.ms-excel",
//           "image/png",
//           "image/gif"
//         ];

//         if (!allowedTypes.includes(file.type) && !file.name.match(/\.(zip|pdf|xls|xlsx|png|gif)$/i)) {
//           toast.error("Only ZIP, PDF, PNG, GIF and Excel files are allowed!");
//           return prevFormData;
//         }

//         // ✅ Generate Aimantra filename
//         const symbols = "!@#$%^&*()_-+=";
//         const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
//         const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
//         const numbers = "0123456789";
//         const now = new Date();
//         const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-"); // YYYY-MM-DD
//         const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-"); // HH-MM-SS
//         const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;

//         let randomCode = "";
//         for (let i = 0; i < 8; i++) {
//           const randomIndex = Math.floor(Math.random() * allChars.length);
//           randomCode += allChars[randomIndex];
//         }

//         const projectPart = projectNAmeCode?.map(i => `${i.code}-${i.name}`)
//           .join("_");


//         console.log(projectPart, "projectPart")
//         const aimantraFileName = `${projectName ? `${siteCode}-${projectName}` : projectPart}  ${file.name} ${date} ${time}_${randomCode}`;
//         const customFile = new File([file], aimantraFileName, { type: file.type });

//         // ✅ Update document data
//         newDocuments[index] = {
//           ...newDocuments[index],
//           document_file: customFile,
//           original_filename: aimantraFileName, // store Aimantra name here
//           // document_name stays untouched
//         };

//         // ✅ Update fileNames for display
//         setFileNames((prevFileNames) => {
//           const newFileNames = [...prevFileNames];
//           newFileNames[index] = aimantraFileName;
//           return newFileNames;
//         });
//       }
//       // if it's a normal text input
//       else {
//         newDocuments[index] = {
//           ...newDocuments[index],
//           [name]: value,
//         };
//       }

//       return { ...prevFormData, documents: newDocuments };
//     });

//     // ✅ Handle validation errors
//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       const fieldKey = `${name}_${index}`;
//       const isValid =
//         name === "document_name" ? value.trim() !== "" : files && files[0];
//       if (isValid) {
//         delete newErrors[fieldKey];
//       }
//       return newErrors;
//     });
//   };


//   const handleAddDocuments = () => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       documents: [
//         ...prevFormData.documents,
//         { document_name: "", document_file: null },
//       ],
//     }));
//   };

//   const handleRemoveDocument = (index) => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       documents: prevFormData.documents?.filter((_, i) => i !== index),
//     }));
//     setFileNames((prevFileNames) => {
//       if (!Array.isArray(prevFileNames)) return [];
//       return prevFileNames.filter((_, i) => i !== index);
//     });
//   };

//   const createCustomFile = (originalFile) => {
//     const randomCode = generateRandomString();
//     const now = new Date();
//     const date = now.toISOString().split("T")[0];
//     const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
//     const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
//     return new File([originalFile], customFileName, {
//       type: originalFile.type,
//     });
//   };

//   const generateRandomString = () => {
//     const chars =
//       "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
//     return Array.from(
//       { length: 8 },
//       () => chars[Math.floor(Math.random() * chars.length)]
//     ).join("");
//   };



//   const fetchAssociatedLetters = async () => {
//     try {
//       let url = "";

//       if (eotID !== "null") {
//         const letterId = eotFormData?.close_letter
//           ? eotFormData.close_letter
//           : eotFormData?.letter;
//         url = `${BASE_URL}/siteproject/letterrecordsbyid/${letterId}/`;
//       } else if (progressID !== "null") {
//         url = `${BASE_URL}/siteproject/letterrecordsbyid/${progressData?.submitted_letter}/`;
//       } else if (cosID !== "null") {
//         const letterId = cosFormData?.close_letter
//           ? cosFormData.close_letter
//           : cosFormData?.letter;
//         url = `${BASE_URL}/siteproject/letterrecordsbyid/${letterId}/`;
//       } else {
//         url = `${BASE_URL}/siteproject/letterrecordbclosestatus/${formData.project || "null"
//           }/${formData.workperformedby || "null"}/${formData.lettertype || "null"
//           }/`;
//       }

//       const res = await axios.get(url);
//       setTrackRecordList(res.data);
//     } catch (err) {
//       console.error("Error fetching letters.", err);
//     }
//   };

//   const trackrecordfilter = trackRecordList?.filter(i => i.letter_date <= formData.letter_date);

//   const options = trackrecordfilter
//     .sort((a, b) => parseInt(a.letter_num) - parseInt(b.letter_num))
//     .map((e) => ({
//       value: e.id,
//       label: `${e.letter_num} - ${e.letter_date}`,
//     }));

//   const handleChangecc = (selected) => {
//     const associated_letters =
//       selected.length > 0 ? selected.map((item) => item.value) : "";
//     setFormData((prevState) => ({
//       ...prevState,
//       associated_letters,
//     }));
//   };

//   console.log("eotid");
//   console.log(eotID);
//   const getSiteDepartment = async () => {
//     setBuffering(true); //buffering logic // Start Buffering
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/department/`);
//       setSiteDepartmentList(res.data);
//     } catch (err) {
//       //toast Logic
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false); //buffering logic // End Buffering
//     }
//   };
//   const getProjectContractorDetails = async () => {
//     try {
//       const contractordetails = await axios.get(
//         `${BASE_URL}/siteproject/contractorbyproject/${formData.project}/null/`
//       );
//       setContractorLists(contractordetails.data);
//     } catch (err) {
//       // handleErrorToast(err);
//     } finally {
//     }
//   };



//   const getEot = async () => {
//     try {
//       // let eot = await axios.get(`${BASE_URL}/siteproject/eot/`);
//       let eot = await axios.get(
//         `${BASE_URL}/siteproject/eotfilter/${formData.project}/${formData.workperformedby
//         }/${formData.contractor ? formData.contractor : null}/pending/`
//       );
//       setEotList(eot.data);
//     } catch (err) {
//       //toast Logic
//       handleErrorToast(err);
//     } finally {
//     }
//   };
//   const getMilestone = async () => {
//     try {
//       let milestone = await axios.get(
//         `${BASE_URL}/siteproject/milestonebycontractor/${formData.contractor}/`
//       );
//       setmileStoneList(milestone.data);
//     } catch (err) {
//       //toast Logic
//       handleErrorToast(err);
//     } finally {
//     }
//   };
//   const getCOS = async () => {
//     try {
//       // let eot = await axios.get(`${BASE_URL}/siteproject/eot/`);
//       let cos = await axios.get(
//         `${BASE_URL}/siteproject/cosfilter/${formData.project}/${formData.workperformedby
//         }/${formData.contractor ? formData.contractor : null}/pending/`
//       );
//       setCosList(cos.data);
//     } catch (err) {
//       //toast Logic
//       handleErrorToast(err);
//     } finally {
//     }
//   };
//   const { month, year } = progressData;

//   useEffect(() => {
//     if (
//       (formData.project && formData.workperformedby) ||
//       eotID !== "null" ||
//       cosID !== "null" ||
//       progressID !== "null"
//     ) {
//       fetchAssociatedLetters();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     formData.project,
//     formData.workperformedby,
//     formData.lettertype,
//     formData.select,
//     eotID,
//     eotFormData.letter,
//     cosFormData.letter,
//     progressID,
//     progressData.submitted_letter,
//     eotFormData.eot_status,
//     eotFormData.close_letter,
//     cosFormData.close_letter,
//   ]);

//   useEffect(() => {
//     if (!progressData.submitted_letter) {
//       if (!progressData.month || !progressData.year) {
//         console.error(
//           "Both month and year are required to fetch progress data."
//         );
//         return;
//       }
//     }

//     const fetchProgressData = async () => {
//       try {
//         if (year < oldestYear) {
//           console.warn(
//             `Skipping loop: Year (${year}) is not greater than oldestYear (${oldestYear}).`
//           );
//           return;
//         }
//         let currentMonth = month - 1 === 0 ? 12 : month - 1; // Start with the previous month
//         let currentYear = month - 1 === 0 ? year - 1 : year; // Adjust year if previous month is December
//         let dataFound = false; // Flag to check if data is found

//         while (!dataFound) {
//           const response = await axios.get(
//             `${BASE_URL}/siteproject/progressbyproject/${formData.project}/${formData.contractor}/${currentMonth}/${currentYear}/`
//           );

//           const progressData = response.data;

//           if (progressData.length > 0) {
//             // Assuming progressData is an array
//             const { financial_progress, physical_progress } = progressData[0]; // Take the first item

//             // Set the values
//             setPreviousProgressData({
//               financial_progress,
//               physical_progress,
//             });

//             console.log("Financial Progress:", financial_progress);
//             console.log("Physical Progress:", physical_progress);

//             dataFound = true; // Exit the loop
//           } else {
//             console.warn(
//               `No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`
//             );

//             // Move to the previous month
//             currentMonth -= 1;
//             if (currentMonth === 0) {
//               currentMonth = 12;
//               currentYear -= 1; // Move to the previous year
//             }

//             // Stop the loop if we reach an unrealistic limit (e.g., 10 years back)
//             if (currentYear < year - 1) {
//               console.error("No data found for the past year.");
//               break;
//             }
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching progress data:", error);
//       }
//     };

//     fetchProgressData();
//   }, [month, year]);

//   const getProgress = async () => {
//     setBuffering(true); // Start buffering

//     try {
//       const response = await axios.get(
//         `${BASE_URL}/siteproject/progressbyproject/${formData.project}/${formData.contractor}/`
//       );

//       setprogressList(response.data);

//       // Extract and process year field
//       const yearField = response.data.map((item) => ({
//         ...item,
//         year: item.year || 0, // Default to 0 if missing
//       }));

//       // Find the oldest year
//       const oldestYear = yearField.reduce(
//         (min, item) => (item.year && item.year < min ? item.year : min),
//         Infinity
//       );
//       setOldestYear(oldestYear);

//       console.log("Oldest Year:", oldestYear);
//     } catch (err) {
//       console.log("Error fetching progress:", err);
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false); // End buffering
//     }
//   };

//   useEffect(() => {
//     // Check if conditions are met before calling getEot
//     if (formData.project !== "null") {
//       if (formData.lettertype === "eot") {
//         getEot();
//       }
//       if (formData.lettertype === "cos") {
//         getCOS();
//       }
//       if (formData.contractor !== "" && formData.lettertype === "Milestone") {
//         getMilestone();
//       }

//       if (
//         formData.contractor !== "" &&
//         formData.lettertype === "SiteProgress"
//       ) {
//         getProgress();
//       }
//     }
//   }, [
//     formData.project,
//     formData.workperformedby,
//     formData.contractor,
//     formData.lettertype,
//     formData.select,
//     eotID,
//     cosID,
//     mileStoneID,
//     progressID,
//   ]);


//   // *******************************************************************Contractor Linking*************************************************************************

//   const [ContractorDataList, setContractorDataList] = useState({
//     schedule_construction_completion_date_with_eot: null,
//     EOT_Days: "null"
//   });


//   const [contractorList, setContractorList] = useState({});

//   const getContractorDataa = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/EOTCOSContractorbyid/${formData.contractor}/`);
//       setContractorList(res.data);
//       return res.data; // Return the latest contractor data
//     } catch (error) {
//       console.error(error);
//       return null;
//     }
//   };
//   const [letterNumberList, setLetterNumberList] = useState([]);


//   const handleFormSubmit = async (e) => {
//     e.preventDefault();


//     const filterNum = letterNumberList.filter(
//       (i) => i.letter_num === formData.letter_num
//     );
//     if (filterNum.length > 0) {
//       toast.error(`Letter number ${formData.letter_num} already exists. Please use a different number.`);
//       return;
//     }

//     if (validateForm()) {
//       setLoading(true);

//       try {
//         const formDataToSend = new FormData();

//         Object.keys(formData).forEach((key) => {
//           if (key !== "documents" && formData[key]) {
//             if (key === "associated_letters") {
//               formDataToSend.append(key, JSON.stringify(formData[key]));
//             } else {
//               formDataToSend.append(key, formData[key]);
//             }
//           }
//         });

//         let fileIndex = 0;
//         for (let doc of formData.documents) {
//           if (doc.document_file) {
//             const fileId = await uploadFileInChunks(
//               doc.document_file,
//               doc.document_name,
//               setUploadProgress
//             );
//             if (!fileId) {
//               console.error(`❌ Failed to upload file: ${doc.document_name}`);
//               continue;
//             }
//             console.log(doc, "documents");
//             formDataToSend.append("file_ids", fileId);
//             formDataToSend.append(
//               `documents[${fileIndex}][document_name]`,
//               doc.document_name
//             );
//             formDataToSend.append(
//               `documents[${fileIndex}][original_filename]`,
//               doc.document_file.name
//             );
//             formDataToSend.append(
//               `documents[${fileIndex}][file]`,
//               doc.document_file
//             );
//             fileIndex++;
//           }
//         }

//         if (!formDataToSend.has("file_ids")) {
//           console.error("❌ No valid files were uploaded.");
//           setLoading(false);
//           return;
//         }

//         // 🚀 Continue with upload logic
//         const res = await axiosInstance2.post(
//           `/siteproject/documentbulkwithletter-new/`,
//           formDataToSend,
//           {
//             onUploadProgress: (progressEvent) => {
//               const percentCompleted = Math.round(
//                 (progressEvent.loaded * 100) / progressEvent.total
//               );
//               setUploadProgress(percentCompleted);
//             },
//           }
//         );
//         if (res.status === 200) {
//           // if (res.data.letter.id) {
//           //   const generatedId = res.data.letter.id;

//           //   if (formData.lettertype === "eot") {
//           //     if (eotID === "null") {
//           //       setEOTFormData((prev) => ({
//           //         ...prev,
//           //         letter: generatedId,
//           //         eot_code: eotFormData.eot_code,
//           //         days: eotFormData.days,
//           //       }));
//           //       const updatedEotData = {
//           //         ...eotFormData,
//           //         letter: generatedId,
//           //         eot_code: eotFormData.eot_code,
//           //         days: eotFormData.days,
//           //       };
//           //       const eotpost = await axios.post(
//           //         `${BASE_URL}/siteproject/eot/`,
//           //         updatedEotData
//           //       );

//           //       if (eotpost.status === 200) {
//           //         await getEot();
//           //       }
//           //     } else if (eotID !== "null") {
//           //       setEOTFormData((prev) => ({
//           //         ...prev,
//           //         close_letter: generatedId,
//           //       }));
//           //       const updatedEotData = {
//           //         ...eotFormData,
//           //         close_letter: generatedId,
//           //       };
//           //       const eotUpdate = await axios.put(
//           //         `${BASE_URL}/siteproject/eot/${eotID}/`,
//           //         updatedEotData
//           //       );

//           //       if (eotUpdate.status === 200) {
//           //         await getEot();
//           //         await new Promise(resolve => setTimeout(resolve, 500));

//           //         const contractorData = await getContractorDataa();
//           //         if (!contractorData) throw new Error("Failed to fetch contractor data.");

//           //         const gettotaldays = contractorData.linked_eots.total_approved_days;

//           //         await new Promise(resolve => setTimeout(resolve, 500));

//           //         if (formData.workperformedby === "contractor") {
//           //           const updatedContractorData = {
//           //             ...ContractorDataList,
//           //             EOT_Days: gettotaldays,
//           //             schedule_construction_completion_date_with_eot: calculateNextDate(contractorData.schedule_construction_completion_date, Number(gettotaldays)),
//           //           };

//           //           await axios.put(`${BASE_URL}/siteproject/contractor/${formData.contractor}/`, updatedContractorData);
//           //         }

//           //       }
//           //     }
//           //   }
//           //   if (formData.lettertype === "cos") {
//           //     if (cosID === "null") {
//           //       setCOSFormData((prev) => ({
//           //         ...prev,
//           //         letter: generatedId,
//           //         cos_code: cosFormData.cos_code,
//           //         cos_type: cosFormData.cos_type,
//           //         negativeamount: cosFormData.negativeamount,
//           //         amount: cosFormData.amount,
//           //       }));
//           //       const updatedCOSData = {
//           //         ...cosFormData,
//           //         letter: generatedId,
//           //         cos_code: cosFormData.cos_code,
//           //         cos_type: cosFormData.cos_type,
//           //         amount: cosFormData.amount,
//           //         negativeamount: cosFormData.negativeamount,
//           //       };
//           //       const cospost = await axios.post(
//           //         `${BASE_URL}/siteproject/cos/`,
//           //         updatedCOSData
//           //       );

//           //       if (cospost.status === 200) {
//           //         await getCOS();
//           //       }
//           //     } else if (cosID !== "null") {
//           //       setCOSFormData((prev) => ({
//           //         ...prev,
//           //         close_letter: generatedId,
//           //       }));
//           //       const updatedCOSData = {
//           //         ...cosFormData,
//           //         close_letter: generatedId,
//           //       };
//           //       const cosUpdate = await axios.put(
//           //         `${BASE_URL}/siteproject/cos/${cosID}/`,
//           //         updatedCOSData
//           //       );

//           //       if (cosUpdate.status === 200) {
//           //         await getCOS();
//           //       }
//           //     }
//           //   }
//           //   if (formData.lettertype === "SiteProgress") {
//           //     if (progressID === "null") {
//           //       setProgressData((prev) => ({
//           //         ...prev,
//           //         submitted_letter: generatedId,
//           //         month: progressData.month,
//           //       }));
//           //       const updateProgressData = {
//           //         ...progressData,
//           //         submitted_letter: generatedId,
//           //         month: progressData.month,
//           //       };
//           //       const progressPost = await axios.post(
//           //         `${BASE_URL}/siteproject/progressget/`,
//           //         updateProgressData
//           //       );

//           //       if (progressPost.status === 200) {
//           //         await getProgress();
//           //       }
//           //     } else if (progressID !== "null") {
//           //       setProgressData((prev) => ({
//           //         ...prev,
//           //         approved_letter: generatedId,
//           //       }));
//           //       const UpdatedProgressData = {
//           //         ...progressData,
//           //         approved_letter: generatedId,
//           //       };
//           //       const progressUpdate = await axios.put(
//           //         `${BASE_URL}/siteproject/progressupdate/${progressID}/`,
//           //         UpdatedProgressData
//           //       );

//           //       if (progressUpdate.status === 200) {
//           //         await getProgress();
//           //       }
//           //     }
//           //   }
//           //   if (formData.lettertype === "Milestone") {
//           //     if (mileStoneFormData.mile_stone_type === "actual") {
//           //       setmileStoneFormData((prev) => ({
//           //         ...prev,
//           //         actual_letter: generatedId,
//           //       }));
//           //       const updatedactualMilestone = {
//           //         ...mileStoneFormData,
//           //         actual_letter: generatedId,
//           //       };
//           //       const milestoneactual = await axios.put(
//           //         `${BASE_URL}/siteproject/milestone/${mileStoneID}/`,
//           //         updatedactualMilestone
//           //       );

//           //       if (milestoneactual.status === 200) {
//           //         await getMilestone();
//           //       }
//           //     } else if (mileStoneFormData.mile_stone_type === "reschedule") {
//           //       setmileStoneFormData((prev) => ({
//           //         ...prev,
//           //         reschedule_letter: generatedId,
//           //       }));
//           //       const updatedRescheduleMilestone = {
//           //         ...mileStoneFormData,
//           //         reschedule_letter: generatedId,
//           //       };
//           //       const milestoneUpdate = await axios.put(
//           //         `${BASE_URL}/siteproject/milestone/${mileStoneID}/`,
//           //         updatedRescheduleMilestone
//           //       );

//           //       if (milestoneUpdate.status === 200) {
//           //         await getMilestone();
//           //       }
//           //     }
//           //   }
//           // }
//           const generatedId = res.data.letter.id;
//           setletterId(generatedId);
//           try {
//             const letteremail = await axios.post(
//               `${BASE_URL}/siteproject/sendletternotificationtoauthorityengineeronNewLetter/`,
//               { letter_id: generatedId }
//             );

//             if (letteremail.status === 200) {
//               await getProjects();
//               toast.success("Letter Documents uploaded successfully!");
//               handleClose();
//             }
//           } catch (error) {
//             console.error(error);
//           }

//         } else {
//           throw new Error("Document upload failed");
//         }
//       } catch (err) {
//         toast.error("Error uploading documents");
//         console.error("Error uploading documents", err);
//       } finally {
//         setLoading(false);
//         setUploadProgress(0);
//       }
//     }
//   };


//   useEffect(() => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       contractor: letterfor === "contractor" ? contractor : "",
//     }));
//   }, [contractor]);
//   useEffect(() => {
//     if (formData.project !== "null") {
//       getProjectContractorDetails();
//     }
//   }, [formData.project]);


//   const [isLetterNumLoaded, setIsLetterNumLoaded] = useState(false);



//   const fetchLetterNumber = async () => {
//     try {
//       setIsLetterNumLoaded(false);

//       const res = await axios.get(
//         `${BASE_URL}/siteproject/letterrecordfilterletter/${formData.project}/null/null/null/null/null/`
//       );

//       if (res.status === 200) {
//         setLetterNumberList(res.data);
//         setIsLetterNumLoaded(true);
//       }
//     } catch (error) {
//       console.error(error);
//       setIsLetterNumLoaded(false);
//     }
//   };


//   useEffect(() => {
//     if (show === true && formData.project !== "null") {
//       fetchLetterNumber();


//     }
//   }, [formData.project, show]);

//   useEffect(() => {
//     const filterNum = letterNumberList.filter(i => i.letter_num === formData.letter_num);
//     if (filterNum.length > 0) {
//       toast.warning(`Letter already exist change letter number ${formData.letter_num}`)
//     }
//   }, [formData.letter_num, letterNumberList])


//   const [lettertypeList, setlettertype] = useState([])

//   useEffect(() => {
//     if (letterfor === "contractor") {
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         workperformedby: "contractor",
//       }));
//     }
//   }, [letterfor])

//   useEffect(() => {
//     if (formData.workperformedby === 'consultant') {
//       const lettertypeOptionss = LetterTypeOptions.filter(i => i.work_performed_by === 'consultant' || i.work_performed_by === "For Both")
//       setlettertype(lettertypeOptionss)
//     }
//     else if (formData.workperformedby === 'contractor') {
//       const lettertypeOptionss = LetterTypeOptions.filter(i => i.work_performed_by === 'contractor' || i.work_performed_by === "For Both")
//       setlettertype(lettertypeOptionss)

//     }


//   }, [formData.workperformedby, LetterTypeOptions])

//   const sityeProjectCode = sessionStorage.getItem("sitemanagement_project_site_prcode");
//   const siteProjectName = sessionStorage.getItem("sitemanagement_project_short_name");


//   return (
//     <>
//       <button
//         className="clearbutton"
//         title={`Add ${title} Details`}

//         onClick={handleShow}
//         style={{ padding: title === "Bulk Documents" && "7px" }}
//       >
//         <span className="transition"></span>
//         <span className="gradient"></span>
//         <span className="label">
//           <AddwithWhiteCircle />{""} {title}
//         </span>
//       </button>

//       <Modal
//         show={show}
//         onHide={handleClose}
//         dialogClassName="ourcompany-model">
//         <Modal.Header
//           closeButton
//           className="justify-center task-Tab-heading font-weight500 font-size-heading">
//           <Modal.Title>Add  {title}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <form className="register-form">
//             <div className="form-flex-wrap">

//               <>

//                 <div className="form-group">
//                   <label
//                     htmlFor="project"
//                     className="form-labels font-weight500 font-size-subheading"
//                   >
//                     Site Project <span className="required">{projectId !== "null" ? "(Read-Only)" : "*"}</span>
//                   </label>

//                   <Select
//                     options={ProjectListOption}
//                     onChange={handleProjectChange}
//                     value={
//                       formData.project === "null" || formData.project === undefined
//                         ? null
//                         : ProjectListOption?.find(
//                           (option) => option.value === formData.project
//                         )
//                     }
//                     placeholder={siteCode ? `${siteCode}-${projectName}` : siteProjectName ? `${sityeProjectCode}-${siteProjectName}` : "Select a Project"}
//                     isSearchable
//                     isClearable
//                     noOptionsMessage={() => "No other options"}
//                     styles={CSSForSelect}
//                     isDisabled={projectId !== "null" ? true : false}   // ✅ Corrected here
//                   />

//                   {errors.project && (
//                     <div className="error-message col">{errors.project}</div>
//                   )}
//                 </div>


//               </>


//               <div className="form-group">
//                 <RenderSelectField
//                   title="Letter Exchange"
//                   name="letterExchange"
//                   required={true}
//                   options={[
//                     { value: "receive", label: "Received" },

//                     { value: "send", label: "Send" },
//                   ]}
//                   formData={formData}
//                   errors={errors}
//                   inputState={inputState}
//                   handleInputChange={handleInputChange}
//                   placeholderneed="NO"
//                 />
//                 {errors.letterExchange && (
//                   <div className="error-message col">
//                     {errors.letterExchange}
//                   </div>
//                 )}
//               </div>

//               {formData.letterExchange === "send" && (
//                 <div className="form-group">
//                   <RenderSelectField
//                     title="Reply By"
//                     name="reply_by"
//                     required={true}
//                     options={[
//                       { value: "HO", label: "Head Office" },
//                       { value: "SO", label: "Site Office" },
//                     ]}
//                     placeholder="Select a Reply By"
//                     formData={formData}
//                     errors={errors}
//                     inputState={inputState}
//                     handleInputChange={handleInputChange}
//                     placeholderneed="NO"
//                   />
//                   {errors.reply_by && (
//                     <div className="error-message col">{errors.reply_by}</div>
//                   )}
//                 </div>
//               )}
//               {!isLetterNumLoaded ?
//                 <div class="spinner center">
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                   <div class="spinner-blade"></div>
//                 </div> :
//                 (
//                   <div className="form-group">
//                     <RenderInputField
//                       title={`${formData.letterExchange === "null"
//                         ? ""
//                         : toTitleCase(formData.letterExchange)
//                         } Letter Number`}
//                       name="letter_num"
//                       required={true}
//                       placeholder="Enter Letter Number"
//                       formData={formData}
//                       errors={errors}
//                       inputState={inputState}
//                       handleInputChange={handleInputChange}
//                     />

//                     {errors.letter_num && (
//                       <div className="error-message col">{errors.letter_num}</div>
//                     )}
//                   </div>
//                 )}


//               {letterfor ? (
//                 <></>
//               ) : (
//                 <div className="form-group">
//                   <RenderSelectField
//                     title="Matter Related To"
//                     name="workperformedby"
//                     required={true}
//                     options={[
//                       ...(formData.project &&
//                         ((Array.isArray(contractorlist) &&
//                           contractorlist.length > 0) ||
//                           (Array.isArray(contractorlists) &&
//                             contractorlists.length > 0))
//                         ? [{ value: "contractor", label: "Contractor" }]
//                         : []),
//                       { value: "consultant", label: "Consultant" },
//                     ]}
//                     placeholder="Select Option"
//                     formData={formData}
//                     errors={errors}
//                     inputState={inputState}
//                     handleInputChange={handleInputChange}
//                   />
//                   {errors.workperformedby && (
//                     <div className="error-message col">
//                       {errors.workperformedby}
//                     </div>
//                   )}
//                 </div>
//               )}

//               {formData.workperformedby === "contractor" ? (
//                 <div className="form-group">
//                   <div
//                     title=" Contractor Name"
//                     className="flex-column form-group-selectt">
//                     <label
//                       htmlFor="project"
//                       className="form-labels  font-weight500    font-size-subheading">
//                       Contractor Name<span className="required">*</span>
//                     </label>
//                     <br />
//                     <select
//                       id="contractor"
//                       name="contractor"
//                       value={formData.contractor}
//                       onChange={handleInputChange}
//                       disabled={!!contractor}
//                       className={`form-input form-group-selection ${errors.contractor
//                         ? "error"
//                         : inputState.contractor
//                           ? "success"
//                           : ""
//                         }`}>
//                       <option value="">Select a Contractor</option>
//                       {contractorlists
//                         ?.sort((a, b) =>
//                           a.name?.localeCompare(b.name, "en", {
//                             ignorePunctuation: true,
//                           })
//                         )
//                         .map((i, index) => (
//                           <>
//                             <option value={i.id}>{i.name}</option>
//                           </>
//                         ))}
//                     </select>
//                   </div>

//                   {errors.contractor && (
//                     <div className="error-message col">{errors.contractor}</div>
//                   )}
//                 </div>
//               ) : (
//                 ""
//               )}

//               {lettertype ? (
//                 <></>
//               ) : (
//                 <>
//                   {formData.division !== "null" && (
//                     <div className="form-group">
//                       <div className="flex-column">
//                         <div
//                           className="flex-row justify-between"
//                           style={{ height: "25px" }}>
//                           <label
//                             htmlFor="lettertype"
//                             className="form-labels font-weight500 font-size-subheading">
//                             Select LetterType{" "}
//                             <span className="required">*</span>
//                           </label>
//                           {formData.lettertype !== "null" && (
//                             <div className="checkbox-wrapper">
//                               <label className="custom-checkbox  font-weight500 font-size-subheading">
//                                 <input
//                                   type="checkbox"
//                                   name="is_timebound"
//                                   checked={formData.is_timebound || false}
//                                   onChange={handleInputChange}
//                                 />
//                                 <span className="checkmark"></span>
//                                 Time Bound
//                               </label>
//                             </div>
//                           )}
//                         </div>
//                         <Select
//                           options={lettertypeList}
//                           onChange={handleLetterTypeOption}
//                           value={
//                             formData.lettertype === "null" ||
//                               formData.lettertype === undefined
//                               ? "null"
//                               : lettertypeList.find(
//                                 (option) =>
//                                   option.value === formData.lettertype
//                               )
//                           }
//                           placeholder="Select Letter-Type"
//                           isSearchable
//                           isClearable
//                           noOptionsMessage={() => "No other options"}
//                           styles={CSSForSelect}
//                         />
//                       </div>
//                       {errors.lettertype && (
//                         <div className="error-message col">
//                           {errors.lettertype}
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </>
//               )}
//               {formData.lettertype === "other" && (
//                 <div className="flex-column">
//                   <label className="form-labels">
//                     Other Letter Type Name{" "}
//                     <span className="required">* (only 15 Character Allowed)</span>
//                   </label>
//                   <input
//                     type="text"
//                     name="other_type_name"
//                     placeholder="Use Short Form"
//                     value={formData.other_type_name}
//                     onChange={handleInputChange}
//                     className={`form-input input-form ${errors.other_type_name
//                       ? "error"
//                       : inputState.other_type_name
//                         ? "success"
//                         : ""
//                       }`}
//                   />

//                   {errors.other_type_name && (
//                     <div style={{ color: "red", marginTop: "4px" }}>
//                       {errors.other_type_name}
//                     </div>
//                   )}
//                 </div>
//               )}



//               {/* {(formData.lettertype === "eot" ||
//                 formData.lettertype === "cos" ||
//                 formData.lettertype === "Milestone" ||
//                 formData.lettertype === "SiteProgress") &&
//                 formData.workperformedby !== "null" && (
//                   <div className="form-group">
//                     <div className="flex-column form-group-selectt">
//                       <label
//                         htmlFor="select"
//                         className="form-labels font-weight500 font-size-subheading">
//                         <span>
//                           Select {formData.lettertype}
//                           <span className="required">*</span>
//                         </span>
//                       </label>
//                       <br />
//                       <select
//                         id="select"
//                         name="select"
//                         placeholder="select"
//                         value={formData.select}
//                         onChange={handleInputChange}
//                         className={`form-input form-group-selection ${errors.select
//                           ? "error"
//                           : inputState.select
//                             ? "success"
//                             : ""
//                           }`}>
//                         <option value="">Select</option>

//                         {formData.lettertype !== "Milestone" && (
//                           <option value="new">New {formData.lettertype}</option>
//                         )}
//                         <option value="existing">
//                           Existing {formData.lettertype}
//                         </option>


//                       </select>
//                     </div>

//                     {errors.select && (
//                       <div className="error-message col">{errors.select}</div>
//                     )}
//                   </div>
//                 )} */}

//               {formData.select === "new" ? (
//                 <>
//                   {formData.lettertype === "eot" ? (
//                     <>
//                       <div className="form-group">
//                         <RenderDateInputField
//                           title={`${formData.letterExchange === "null"
//                             ? ""
//                             : toTitleCase(formData.letterExchange)
//                             } Letter Date`}
//                           name="letter_date"
//                           type="date"
//                           max={today}
//                           required={true}
//                           formData={formData}
//                           errors={errors}
//                           inputState={inputState}
//                           handleInputChange={handleInputChange}
//                         />
//                         {errors.letter_date && (
//                           <div className="error-message col">
//                             {errors.letter_date}
//                           </div>
//                         )}
//                       </div>
//                       <div className="flex-column">
//                         <label
//                           className="form-labels font-weight500 font-size-subheading"
//                           title="EOT Code">
//                           EOT Code<span className="required">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           name="eot_code"
//                           placeholder="EOT Code"
//                           title="EOT Code"
//                           value={eotFormData.eot_code}
//                           onChange={handleEotInputChange}
//                           className={`form-input ${errors.eot_code
//                             ? "error"
//                             : eotinputState.eot_code
//                               ? "success"
//                               : ""
//                             }`}
//                         />
//                         {errors.eot_code && (
//                           <span className="error-message font-size-text">
//                             {errors.eot_code}
//                           </span>
//                         )}
//                       </div>
//                       <div className="flex-column">
//                         <label
//                           className="form-labels font-weight500 font-size-subheading"
//                           title="Initiate Days">
//                           Initiate Days
//                         </label>
//                         <input
//                           type="number"
//                           name="days"
//                           title="Initiate Days"
//                           placeholder="Enter Number of Days.."
//                           value={eotFormData.days}
//                           onChange={handleEotInputChange}
//                           className={`form-input ${errors.days
//                             ? "error"
//                             : inputState.days
//                               ? "success"
//                               : ""
//                             }`}
//                         />
//                         {errors.days && (
//                           <span className="error-message font-size-text">
//                             {errors.days}
//                           </span>
//                         )}
//                       </div>
//                     </>
//                   ) : (
//                     ""
//                   )}
//                   {formData.lettertype === "cos" ? (
//                     <>
//                       <div className="form-group">
//                         <RenderInputField
//                           title={`${formData.letterExchange === "null"
//                             ? ""
//                             : toTitleCase(formData.letterExchange)
//                             } Letter Date`}
//                           name="letter_date"
//                           type="date"
//                           required={true}
//                           formData={formData}
//                           max={today}
//                           errors={errors}
//                           inputState={inputState}
//                           handleInputChange={handleInputChange}
//                         />
//                         {errors.letter_date && (
//                           <div className="error-message col">
//                             {errors.letter_date}
//                           </div>
//                         )}
//                       </div>
//                       <div className="flex-column">
//                         <label
//                           className="form-labels font-weight500 font-size-subheading"
//                           title="COS Code">
//                           COS Code<span className="required">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           name="cos_code"
//                           placeholder="COS Code"
//                           title="COS Code"
//                           value={cosFormData.cos_code}
//                           onChange={handleCOSInputChange}
//                           className={`form-input ${errors.cos_code
//                             ? "error"
//                             : eotinputState.cos_code
//                               ? "success"
//                               : ""
//                             }`}
//                         />
//                         {errors.cos_code && (
//                           <span className="error-message font-size-text">
//                             {errors.cos_code}
//                           </span>
//                         )}
//                       </div>
//                       <div className="flex-column form-group-selectt">
//                         <label
//                           className="form-labels font-weight500 font-size-subheading"
//                           title="COS Type">
//                           COS Type <span className="required">*</span>
//                         </label>
//                         <br />
//                         <select
//                           name="cos_type"
//                           title="COS Type"
//                           value={cosFormData.cos_type}
//                           onChange={handleCOSInputChange}
//                           className={`form-input form-group-selection`}>
//                           <option value="">Select COS Type</option>
//                           <option value="negativecos">Negative COS</option>
//                           <option value="positivecos">Positive COS</option>
//                         </select>
//                         <div className="form-group-selection-arrow">
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="20"
//                             height="25"
//                             fill="currentColor"
//                             className="bi bi-caret-down-fill"
//                             viewBox="0 0 16 16">
//                             <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
//                           </svg>
//                         </div>
//                         {errors.cos_type && (
//                           <div className="error-message font-size-text">
//                             {errors.cos_type}
//                           </div>
//                         )}
//                       </div>
//                       {cosFormData.cos_type === "positivecos" ? (
//                         <div className="flex-column">
//                           <label
//                             className="form-labels font-weight500 font-size-subheading"
//                             title="Positive COS Amount">
//                             Positive COS Amount(Write Full Amount)
//                             <span className="required">*</span>
//                           </label>
//                           <input
//                             type="number"
//                             name="amount"
//                             placeholder="Positive COS Amount"
//                             title="Positive COS Amount"
//                             value={cosFormData.amount}
//                             onChange={handleCOSInputChange}
//                             className={`form-input ${errors.amount
//                               ? "error"
//                               : eotinputState.amount
//                                 ? "success"
//                                 : ""
//                               }`}
//                           />
//                           {errors.amount && (
//                             <span className="error-message font-size-text">
//                               {errors.amount}
//                             </span>
//                           )}
//                         </div>
//                       ) : cosFormData.cos_type === "negativecos" ? (
//                         <div className="flex-column">
//                           <label
//                             className="form-labels font-weight500 font-size-subheading"
//                             title="Negative COS Amount">
//                             Negative COS Amount(Write Full Amount)
//                             <span className="required">*</span>
//                           </label>
//                           <input
//                             type="number"
//                             name="negativeamount"
//                             placeholder="Negative COS Amount"
//                             title="Negative COS Amount"
//                             value={cosFormData.negativeamount}
//                             onChange={handleCOSInputChange}
//                             className={`form-input ${errors.negativeamount
//                               ? "error"
//                               : eotinputState.negativeamount
//                                 ? "success"
//                                 : ""
//                               }`}
//                           />
//                           {errors.negativeamount && (
//                             <span className="error-message font-size-text">
//                               {errors.negativeamount}
//                             </span>
//                           )}
//                         </div>
//                       ) : (
//                         ""
//                       )}
//                     </>
//                   ) : (
//                     ""
//                   )}
//                   {formData.lettertype === "SiteProgress" && (
//                     <>
//                       <div className="form-group">
//                         <RenderInputField
//                           title={`${formData.letterExchange === "null"
//                             ? ""
//                             : toTitleCase(formData.letterExchange)
//                             } Letter Date`}
//                           name="letter_date"
//                           type="date"
//                           required={true}
//                           max={today}
//                           formData={formData}
//                           errors={errors}
//                           inputState={inputState}
//                           handleInputChange={handleInputChange}
//                         />
//                         {errors.letter_date && (
//                           <div className="error-message col">
//                             {errors.letter_date}
//                           </div>
//                         )}
//                       </div>
//                       <div className="flex-column">
//                         <label className="form-labels font-weight500 font-size-subheading">
//                           Month<span className="required">*</span>
//                         </label>
//                         <select
//                           name="month"
//                           value={progressData.month}
//                           className="form-input"
//                           onChange={handleProgressData}>
//                           <option value="">Select Month</option>
//                           {months.map((month) => (
//                             <option
//                               key={month.value}
//                               value={month.value}
//                               disabled={progressList.some(
//                                 (data) =>
//                                   data.month === String(month.value) &&
//                                   data.year === String(progressData.year)
//                               )}>
//                               {month.text}
//                             </option>
//                           ))}
//                         </select>
//                         {errors.month && (
//                           <span className="error-message font-size-text">
//                             {errors.month}
//                           </span>
//                         )}
//                       </div>

//                       {/* Frozen Year Field */}
//                       <div className="flex-column">
//                         <label className="form-labels font-weight500 font-size-subheading">
//                           Year<span className="required">*</span>
//                         </label>
//                         <select
//                           name="year"
//                           value={progressData.year}
//                           className="form-input"
//                           onChange={handleProgressData}>
//                           <option value="">Select Year</option>

//                           {[...Array(10)].map((_, index) => {
//                             const year = new Date().getFullYear() - index;
//                             return (
//                               <option
//                                 key={year}
//                                 value={year}
//                                 disabled={progressList.some(
//                                   (data) =>
//                                     data.year === String(year) &&
//                                     data.month === String(progressData.month)
//                                 )}>
//                                 {year}
//                               </option>
//                             );
//                           })}
//                         </select>
//                         {errors.year && (
//                           <span className="error-message font-size-text">
//                             {errors.year}
//                           </span>
//                         )}
//                       </div>
//                       <>
//                         {progressData.month && progressData.year && (
//                           <>
//                             <div className="flex-column">
//                               <label className="form-labels font-weight500 font-size-subheading">
//                                 Submitted Physical Progress (%)
//                                 <span className="required">*</span>
//                               </label>
//                               <input
//                                 type="number"
//                                 min={previousprogressdata.physical_progress}
//                                 placeholder={
//                                   previousprogressdata.physical_progress || 0
//                                 }
//                                 name="submitted_physical_progress"
//                                 onChange={handleProgressData}
//                                 className={`form-input ${progresserrors.submitted_physical_progress
//                                   ? "input-error"
//                                   : ""
//                                   }`}
//                               />
//                               {progresserrors.submitted_physical_progress && (
//                                 <span className="error-message">
//                                   {progresserrors.submitted_physical_progress}
//                                 </span>
//                               )}
//                             </div>

//                             {/* Submitted Financial Progress */}
//                             <div className="flex-column">
//                               <label className="form-labels font-weight500 font-size-subheading">
//                                 Submitted Financial Progress (%)
//                                 <span className="required">*</span>
//                               </label>
//                               <input
//                                 type="number"
//                                 min={previousprogressdata.financial_progress}
//                                 placeholder={
//                                   previousprogressdata.financial_progress || 0
//                                 }
//                                 name="submitted_financial_progress"
//                                 onChange={handleProgressData}
//                                 className={`form-input ${progresserrors.submitted_financial_progress
//                                   ? "input-error"
//                                   : ""
//                                   }`}
//                               />
//                               {progresserrors.submitted_financial_progress && (
//                                 <span className="error-message">
//                                   {progresserrors.submitted_financial_progress}
//                                 </span>
//                               )}
//                             </div>
//                           </>
//                         )}
//                       </>
//                     </>
//                   )}
//                 </>
//               ) : formData.select === "existing" ? (
//                 <>
//                   {formData.lettertype === "eot" ? (
//                     <div className="form-group">
//                       <div className="flex-column form-group-selectt">
//                         <label
//                           htmlFor="select"
//                           className="form-labels  font-weight500    font-size-subheading">
//                           Existing EOT<span className="required">*</span>
//                         </label>
//                         <br />
//                         <select
//                           value={eotID}
//                           onChange={(e) => setEotId(e.target.value)}
//                           className={`form-input form-group-selection`}>
//                           <option value="">Select Existing Eot</option>
//                           {eotList
//                             ?.sort((a, b) =>
//                               a.eot_code?.localeCompare(b.eot_code, "en", {
//                                 ignorePunctuation: true,
//                               })
//                             )
//                             .map((i, index) => (
//                               <>
//                                 <option value={i.id}>{i.eot_code}</option>
//                               </>
//                             ))}
//                         </select>
//                       </div>
//                       {errors.eotID && (
//                         <div className="error-message col">{errors.eotID}</div>
//                       )}
//                     </div>
//                   ) : (
//                     ""
//                   )}
//                   {formData.lettertype === "cos" ? (
//                     <div className="form-group">
//                       <div className="flex-column form-group-selectt">
//                         <label
//                           htmlFor="select"
//                           className="form-labels  font-weight500    font-size-subheading">
//                           Existing COS<span className="required">*</span>
//                         </label>
//                         <br />
//                         <select
//                           value={cosID}
//                           onChange={(e) => setCosId(e.target.value)}
//                           className={`form-input form-group-selection`}>
//                           <option value="">Select Existing Cos</option>
//                           {cosList
//                             ?.sort((a, b) =>
//                               a.cos_code?.localeCompare(b.cos_code, "en", {
//                                 ignorePunctuation: true,
//                               })
//                             )
//                             .map((i, index) => (
//                               <>
//                                 <option value={i.id}>{i.cos_code}</option>
//                               </>
//                             ))}
//                         </select>
//                       </div>
//                       {errors.cosID && (
//                         <div className="error-message col">{errors.cosID}</div>
//                       )}
//                     </div>
//                   ) : (
//                     ""
//                   )}
//                   {formData.lettertype === "SiteProgress" ? (
//                     <div className="form-group">
//                       <div className="flex-column form-group-selectt">
//                         <label
//                           htmlFor="select"
//                           className="form-labels  font-weight500    font-size-subheading">
//                           Existing Site Progress
//                           <span className="required">*</span>
//                         </label>
//                         <br />
//                         <select
//                           value={progressID}
//                           onChange={(e) => setprogressID(e.target.value)}
//                           className={`form-input form-group-selection`}>
//                           <option value="">
//                             Select Existing Site Progress
//                           </option>
//                           {progressList
//                             ?.filter(
//                               (item) => !item.approved_letter // Exclude items with either actualLetter or rescheduleLetter
//                             )
//                             .sort((a, b) =>
//                               a.year?.localeCompare(b.year, "en", {
//                                 ignorePunctuation: true,
//                               })
//                             )
//                             .map((i, index) => (
//                               <>
//                                 <option value={i.id}>
//                                   {i.month}-{i.year}
//                                 </option>
//                               </>
//                             ))}
//                         </select>
//                       </div>
//                       {errors.progressID && (
//                         <div className="error-message col">
//                           {errors.progressID}
//                         </div>
//                       )}
//                     </div>
//                   ) : (
//                     ""
//                   )}
//                   {formData.lettertype === "Milestone" ? (
//                     <>
//                       <div className="form-group">
//                         <div className="flex-column form-group-selectt">
//                           <label
//                             htmlFor="select"
//                             className="form-labels  font-weight500    font-size-subheading">
//                             Existing Milestone
//                             <span className="required">*</span>
//                           </label>
//                           <br />
//                           <select
//                             value={mileStoneID}
//                             onChange={(e) => setmileStoneId(e.target.value)}
//                             className={`form-input form-group-selection`}>
//                             <option value="">Select Existing Milestone</option>
//                             {mileStoneList
//                               ?.filter(
//                                 (item) =>
//                                   !item.reschedule_letter && !item.actual_letter // Exclude items with either actualLetter or rescheduleLetter
//                               )
//                               .sort((a, b) =>
//                                 a.name?.localeCompare(b.name, "en", {
//                                   ignorePunctuation: true,
//                                 })
//                               )
//                               .map((i) => (
//                                 <option key={i.id} value={i.id}>
//                                   {i.name}
//                                 </option>
//                               ))}
//                           </select>
//                         </div>
//                         {errors.mileStoneID && (
//                           <div className="error-message col">
//                             {errors.mileStoneID}
//                           </div>
//                         )}
//                       </div>
//                       <div className="form-group">
//                         <div className="flex-column form-group-selectt">
//                           <label
//                             htmlFor="mile_stone_type"
//                             className="form-labels  font-weight500    font-size-subheading">
//                             Milestone Type
//                             <span className="required">*</span>
//                           </label>
//                           <br />
//                           <select
//                             id="mile_stone_type"
//                             name="mile_stone_type"
//                             placeholder="Select"
//                             value={mileStoneFormData.mile_stone_type}
//                             onChange={handleMilestoneChange}
//                             className={`form-input form-group-selection ${errors.select
//                               ? "error"
//                               : inputState.select
//                                 ? "success"
//                                 : ""
//                               }`}>
//                             <option value="null">Select Milestone Type</option>
//                             <option value="actual">
//                               Actual {formData.lettertype}
//                             </option>
//                             <option value="reschedule">
//                               Reschedule {formData.lettertype}
//                             </option>
//                           </select>
//                         </div>
//                         {errors.mile_stone_type && (
//                           <div className="error-message col">
//                             {errors.mile_stone_type}
//                           </div>
//                         )}
//                       </div>
//                     </>
//                   ) : (
//                     ""
//                   )}
//                 </>
//               ) : (
//                 ""
//               )}

//               {formData.select !== "new" && (
//                 <div className="form-group">
//                   <RenderInputField
//                     title={`${formData.letterExchange === "null"
//                       ? ""
//                       : toTitleCase(formData.letterExchange)
//                       } Letter Date`}
//                     name="letter_date"
//                     type="date"
//                     required={true}
//                     max={today}
//                     formData={formData}
//                     errors={errors}
//                     inputState={inputState}
//                     handleInputChange={handleInputChange}
//                   />
//                   {errors.letter_date && (
//                     <div className="error-message col">
//                       {errors.letter_date}
//                     </div>
//                   )}
//                 </div>
//               )}


//               <div className="flex-column">
//                 <label className="form-labels">
//                   Tat Duration <span className="required">{formData.is_timebound === false ? "(Read-Only)" : "*"}</span>
//                 </label>
//                 <input
//                   type="number"
//                   name="tat_duration"
//                   placeholder="Enter Tat Duration"
//                   value={formData.tat_duration}
//                   onChange={handleInputChange}
//                   disabled={formData.is_timebound === false}
//                   className={`form-input input-form ${errors.tat_duration
//                     ? "error"
//                     : inputState.tat_duration
//                       ? "success"
//                       : ""
//                     }`}
//                 />

//                 {errors.tat_duration && (
//                   <div style={{ color: "red", marginTop: "4px" }}>
//                     {errors.tat_duration}
//                   </div>
//                 )}
//               </div>


//               {eotID !== "null" ? (
//                 <>
//                   <div className="form-group">
//                     <div className="flex-column form-group-selectt">
//                       <label
//                         className="form-labels font-weight500 font-size-subheading"
//                         title="EOT Status">
//                         EOT Status
//                       </label>
//                       <br />
//                       <select
//                         name="eot_status"
//                         title="EOT status"
//                         value={eotFormData.eot_status}
//                         onChange={handleEotInputChange}
//                         className={`form-input form-group-selection`}>
//                         <option value="">Select Status</option>
//                         <option value="pending">Pending</option>
//                         <option value="Approved">Approved</option>
//                         <option value="rejected">Rejected</option>
//                       </select>
//                     </div>
//                     {errors.eot_status && (
//                       <div className="error-message font-size-text">
//                         {errors.eot_status}
//                       </div>
//                     )}
//                   </div>

//                   {eotFormData.eot_status === "Approved" && (
//                     <div className="flex-column">
//                       <label
//                         className="form-labels font-weight500 font-size-subheading"
//                         title="Approved Days">
//                         Approved Days
//                       </label>
//                       <input
//                         type="number"
//                         name="approved_days"
//                         title="Approved Days"
//                         placeholder="Approved Days"
//                         value={eotFormData.approved_days}
//                         onChange={handleEotInputChange}
//                         className={`form-input ${errors.approved_days
//                           ? "error"
//                           : inputState.approved_days
//                             ? "success"
//                             : ""
//                           }`}
//                       />
//                       {errors.approved_days && (
//                         <span className="error-message font-size-text">
//                           {errors.approved_days}
//                         </span>
//                       )}
//                     </div>
//                   )}
//                 </>
//               ) : (
//                 <></>
//               )}
//               {cosID !== "null" ? (
//                 <>
//                   <div className="form-group">
//                     <div className="flex-column form-group-selectt">
//                       <label
//                         className="form-labels font-weight500 font-size-subheading"
//                         title="Cos Status">
//                         Cos Status
//                       </label>
//                       <br />
//                       <select
//                         name="cos_status"
//                         title="Cos status"
//                         value={cosFormData.cos_status}
//                         onChange={handleCOSInputChange}
//                         className={`form-input form-group-selection`}>
//                         <option value="">Select Status</option>
//                         <option value="pending">Pending</option>
//                         <option value="Approved">Approved</option>
//                         <option value="rejected">Rejected</option>
//                       </select>
//                     </div>
//                     {errors.cos_status && (
//                       <div className="error-message font-size-text">
//                         {errors.cos_status}
//                       </div>
//                     )}
//                   </div>

//                   {cosFormData.cos_status === "Approved" && (
//                     <div className="flex-column">
//                       <label
//                         className="form-labels font-weight500 font-size-subheading"
//                         title="Approved Amount">
//                         Approved Amount
//                       </label>
//                       <input
//                         type="number"
//                         name="approved_amount"
//                         title="Approved Amount"
//                         placeholder="Approved Amount"
//                         value={cosFormData.approved_amount}
//                         onChange={handleCOSInputChange}
//                         className={`form-input ${errors.approved_amount
//                           ? "error"
//                           : cosinputState.approved_amount
//                             ? "success"
//                             : ""
//                           }`}
//                       />
//                       {errors.approved_amount && (
//                         <span className="error-message font-size-text">
//                           {errors.approved_amount}
//                         </span>
//                       )}
//                     </div>
//                   )}
//                 </>
//               ) : (
//                 <></>
//               )}
//               {progressID !== "null" && formData.letter_date !== "null" ? (
//                 <>
//                   <div className="flex-column">
//                     <label className="form-labels font-weight500 font-size-subheading">
//                       Actual Physical Progress (%)
//                       <span className="required">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       min={previousprogressdata.physical_progress}
//                       placeholder={previousprogressdata.physical_progress || 0}
//                       name="physical_progress"
//                       onChange={handleProgressData}
//                       className={`form-input ${progresserrors.physical_progress ? "input-error" : ""
//                         }`}
//                     />
//                     {progresserrors.physical_progress && (
//                       <span className="error-message">
//                         {progresserrors.physical_progress}
//                       </span>
//                     )}
//                   </div>

//                   {/* Submitted Financial Progress */}
//                   <div className="flex-column">
//                     <label className="form-labels font-weight500 font-size-subheading">
//                       Actual Financial Progress (%)
//                       <span className="required">*</span>
//                     </label>
//                     <input
//                       type="number"
//                       min={previousprogressdata.financial_progress}
//                       placeholder={previousprogressdata.financial_progress || 0}
//                       name="financial_progress"
//                       onChange={handleProgressData}
//                       className={`form-input ${progresserrors.financial_progress ? "input-error" : ""
//                         }`}
//                     />
//                     {progresserrors.financial_progress && (
//                       <span className="error-message">
//                         {progresserrors.financial_progress}
//                       </span>
//                     )}
//                   </div>
//                 </>
//               ) : (
//                 <></>
//               )}
//               {mileStoneID !== "null" ? (
//                 <>
//                   {mileStoneFormData.mile_stone_type === "actual" && (
//                     <div className="flex-column">
//                       <label
//                         className="form-labels font-weight500 font-size-subheading"
//                         title="Actual Gap Days">
//                         Actual Gap Days
//                         <span className="required">(Read-Only)*</span>
//                       </label>
//                       <input
//                         type="number"
//                         name="actual_gap_days"
//                         title="Actual Gap Days"
//                         placeholder="Actual Gap Days"
//                         value={mileStoneFormData.actual_gap_days}
//                         onChange={handleMilestoneChange}
//                         className={`form-input ${errors.actual_gap_days
//                           ? "error"
//                           : mileStoneinputState.actual_gap_days
//                             ? "success"
//                             : ""
//                           }`}
//                       />
//                       {errors.actual_gap_days && (
//                         <span className="error-message font-size-text">
//                           {errors.actual_gap_days}
//                         </span>
//                       )}
//                     </div>
//                   )}
//                   {mileStoneFormData.mile_stone_type === "reschedule" && (
//                     <div className="flex-column">
//                       <label
//                         className="form-labels font-weight500 font-size-subheading"
//                         title="Reschedule Gap Days">
//                         Reschedule Gap Days
//                         <span className="required">(Read-Only)*</span>
//                       </label>
//                       <input
//                         type="number"
//                         name="rescedule_gap_days"
//                         title="Reschedule Gap Days"
//                         placeholder="Reschedule Gap Days"
//                         value={mileStoneFormData.rescedule_gap_days}
//                         onChange={handleMilestoneChange}
//                         className={`form-input ${errors.rescedule_gap_days
//                           ? "error"
//                           : mileStoneinputState.rescedule_gap_days
//                             ? "success"
//                             : ""
//                           }`}
//                       />
//                       {errors.rescedule_gap_days && (
//                         <span className="error-message font-size-text">
//                           {errors.rescedule_gap_days}
//                         </span>
//                       )}
//                     </div>
//                   )}
//                 </>
//               ) : (
//                 <></>
//               )}
//               <div className="form-group">
//                 <label
//                   htmlFor={
//                     formData.letterExchange === "receive"
//                       ? "letter_from"
//                       : "letter_to"
//                   }
//                   className="form-labels  font-weight500    font-size-subheading">
//                   Letter {formData.letterExchange === "send" ? "To" : "From"}{" "}
//                   <span className="required">*</span>
//                 </label>
//                 <Select
//                   options={extendedLetterOptions}
//                   onChange={handleContractorInputChange}
//                   value={
//                     formData.letterExchange === "receive"
//                       ? formData.letter_from === "null" || !formData.letter_from
//                         ? null
//                         : extendedLetterOptions.find(
//                           (option) => option.value === formData.letter_from
//                         )
//                       : formData.letter_to === "null" || !formData.letter_to
//                         ? null
//                         : extendedLetterOptions.find(
//                           (option) => option.value === formData.letter_to
//                         )
//                   }
//                   placeholder={
//                     formData.letterExchange === "send"
//                       ? "Select Letter To"
//                       : "Select Letter From"
//                   }
//                   isSearchable
//                   isClearable
//                   noOptionsMessage={() => "No other options"}
//                   styles={CSSForSelect}
//                 />

//                 {formData.letterExchange === "send"
//                   ? errors.letter_to
//                   : errors.letter_from && (
//                     <div className="error-message col">
//                       {formData.letterExchange === "send"
//                         ? errors.letter_to
//                         : errors.letter_from}
//                     </div>
//                   )}
//               </div>
//               {formData.letterExchange === "receive" &&
//                 formData.letter_from === "other" ? (
//                 <div className="flex-column">
//                   <label className="form-labels">
//                     Other Letter From <span className="required">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     name="other_letter_from"
//                     placeholder="Enter Other Letter From"
//                     value={formData.other_letter_from}
//                     onChange={handleInputChange}
//                     className={`form-input input-form ${errors.other_letter_from
//                       ? "error"
//                       : inputState.other_letter_from
//                         ? "success"
//                         : ""
//                       }`}
//                   />

//                   {errors.other_letter_from && (
//                     <div style={{ color: "red", marginTop: "4px" }}>
//                       {errors.other_letter_from}
//                     </div>
//                   )}
//                 </div>
//               ) : formData.letterExchange === "send" &&
//                 formData.letter_to === "other" ? (
//                 <div className="flex-column">
//                   <label className="form-labels">
//                     Other Letter To <span className="required">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     name="other_letter_to"
//                     placeholder="Enter Other Letter To"
//                     value={formData.other_letter_to}
//                     onChange={handleInputChange}
//                     className={`form-input input-form ${errors.other_letter_to
//                       ? "error"
//                       : inputState.other_letter_to
//                         ? "success"
//                         : ""
//                       }`}
//                   />

//                   {errors.other_letter_to && (
//                     <div style={{ color: "red", marginTop: "4px" }}>
//                       {errors.other_letter_to}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 ""
//               )}

//               <div className="form-group">
//                 <RenderInputField
//                   title="Subject"
//                   name="subject"
//                   placeholder="Write only the bold part in the subject of the letter...."
//                   rows={5}
//                   cols={50}
//                   formData={formData}
//                   errors={errors}
//                   required={true}
//                   inputState={inputState}
//                   handleInputChange={handleInputChange}
//                 />
//                 {errors.subject && (
//                   <div className="error-message col">{errors.subject}</div>
//                 )}
//               </div>
//               <div className="form-group">
//                 <div title="Status" className="flex-column form-group-selectt">
//                   <label
//                     htmlFor="status"
//                     className="form-labels  font-weight500    font-size-subheading">
//                     Status<span className="required">*</span>
//                   </label>
//                   <br />
//                   <select
//                     id="status"
//                     name="status"
//                     placeholder="Status"
//                     value={formData.status}
//                     onChange={handleInputChange}
//                     className={`form-input form-group-selection ${errors.status
//                       ? "error"
//                       : inputState.status
//                         ? "success"
//                         : ""
//                       }`}>
//                     <option value="pending">Pending</option>
//                     {formData.letterExchange === "receive" ? (
//                       ""
//                     ) : (
//                       <option value="close">Close</option>
//                     )}
//                   </select>
//                   {/*  */}
//                 </div>
//                 {errors.status && (
//                   <div className="error-message col">{errors.status}</div>
//                 )}
//               </div>
//               <div className="form-group">
//                 <RenderInputField
//                   title="Remarks"
//                   name="remarks"
//                   placeholder="Write only 5 words"
//                   max={100}
//                   required={true}
//                   formData={formData}
//                   errors={errors}
//                   inputState={inputState}
//                   handleInputChange={handleInputChange}
//                 />
//                 {errors.remarks && (
//                   <div className="error-message col">{errors.remarks}</div>
//                 )}
//               </div>
//               {
//                 (formData.project !== "null" && formData.lettertype !== "null" && formData.workperformedby !== "null" && formData.letter_date !== "null") &&
//                 <div className="flex-column">
//                   <label
//                     htmlFor="names"
//                     className="form-labels font-weight500 announce-date font-weight400 font-size-heading">
//                     Associated Letters
//                   </label>
//                   <Select
//                     options={options}
//                     isMulti
//                     onChange={handleChangecc}
//                     styles={{
//                       control: (provided) => ({
//                         ...provided,
//                         width: "34vw",
//                         height: "50px",
//                         borderRadius: "10px",
//                         border: "1px solid #e3e3e3",
//                         margin: "10px 0px 20px 0px",
//                         color: "#4a4a4a",
//                         backgroundColor: "#f7f8fa",
//                         padding: "0px 10px",
//                       }),
//                       placeholder: (provided) => ({
//                         ...provided,
//                         color: "#4a4a4a",
//                       }),
//                       menu: (provided) => ({
//                         ...provided,
//                         width: "33vw",
//                         borderRadius: "10px",
//                         marginTop: "0",
//                       }),
//                       singleValue: (provided) => ({
//                         ...provided,
//                         color: "#4a4a4a",
//                       }),
//                       input: (provided) => ({
//                         ...provided,
//                         color: "#4a4a4a",
//                       }),
//                     }}
//                   />
//                   {errors.associated_letters && (
//                     <span className="error-message font-size-text">
//                       {errors.associated_letters}
//                     </span>
//                   )}
//                 </div>
//               }

//               {/* Show status options if associated letters are selected */}
//               {formData.associated_letters &&
//                 formData.associated_letters.length > 0 && (
//                   <>
//                     <div className="form-column">
//                       <RenderSelectField
//                         title="Update Status of Associated Letters"
//                         name="associated_letters_status"
//                         required={true}
//                         options={[
//                           { value: "pending", label: "Pending" },
//                           { value: "close", label: "Close" },
//                         ]}
//                         placeholder="Select Status"
//                         formData={formData}
//                         errors={errors}
//                         inputState={inputState}
//                         handleInputChange={handleInputChange}
//                       />
//                       {errors.associated_letters_status && (
//                         <div className="error-message col">
//                           {errors.associated_letters_status}
//                         </div>
//                       )}
//                     </div>
//                   </>
//                 )}
//             </div>

//             <DocumentSection
//               formData={formData}
//               handleDocInputChange={handleDocInputChange}
//               handleAddDocuments={handleAddDocuments}
//               handleRemoveDocument={handleRemoveDocument}
//               errors={errors}
//               fileNames={fileNames}
//               inputState={inputState}
//             />

//             {/* Upload Progress Bar */}
//             {uploadProgress > 0 && (
//               <div className="progress-bar">
//                 <h6 className="uploading-percentage">
//                   Uploading {uploadProgress}%
//                 </h6>
//                 <div
//                   className="progress-bar-fill"
//                   style={{ width: `${uploadProgress}%` }}></div>
//               </div>
//             )}

//             <div className="button-models">
//               <button
//                 onClick={handleFormSubmit}
//                 className="model-button font-weight500 model-button-submit"
//                 disabled={loading}>
//                 Submit
//               </button>
//             </div>
//             <p className="error-message font-size-text">
//               {isSubmitted &&
//                 Object.keys(errors).length > 0 &&
//                 (Object.keys(errors).length > 5 ? (
//                   <h5 className="text-center">
//                     Please fill all mandatory fields!
//                   </h5>
//                 ) : (
//                   <h6 className="text-center">
//                     {Object.keys(errors)
//                       .map(
//                         (field) =>
//                           field.charAt(0).toUpperCase() + field.slice(1)
//                       )
//                       .join(", ") + " are required!"}
//                   </h6>
//                 ))}
//             </p>
//           </form>
//           <ToastContainer
//             position="top-center"
//             autoClose={1000}
//             hideProgressBar={false}
//             newestOnTop
//             closeOnClick
//             rtl={false}
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };


// Add these to your existing lucide-react import:
// import { FileText, Link2, Paperclip, Hash, Users, Building2, Calendar, Clock, MapPin, Mail, Briefcase, X, ChevronRight, AlertCircle, Save, Loader } from "lucide-react";
// Replace CSSForSelect import usage with CSSForSelectModern (same as AddSiteEmployee).

const AddLetterLinked = ({
  getProjects,
  projectList,
  projectId,
  contractor,
  contractorlist,
  lettertype,
  letterfor,
  letterData,
  LetterTypeOptions,
  siteCode,
  projectName,
  title,
}) => {
  const fileInputRefs = useRef([]);

  const [oldestYear, setOldestYear] = useState("");
  const [previousprogressdata, setPreviousProgressData] = useState([]);
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [inputState, setInputState] = useState({});
  const [fileNames, setFileNames] = useState([]);
  const [trackRecordList, setTrackRecordList] = useState([]);
  const [buffer, setBuffering] = useState(true);
  const [siteDepartmentList, setSiteDepartmentList] = useState([]);
  const [contractorlists, setContractorLists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [eotinputState, seteotInputState] = useState({});
  const [cosinputState, setcosInputState] = useState({});
  const [eotList, setEotList] = useState([]);
  const [mileStoneinputState, setmileStoneInputState] = useState({});
  const [progressInputState, setprogressInputState] = useState({});
  const [mileStoneList, setmileStoneList] = useState([]);
  const [progressList, setprogressList] = useState([]);
  const [mileStoneID, setmileStoneId] = useState("null");
  const [progressID, setprogressID] = useState("null");
  const [cosList, setCosList] = useState([]);
  const [eotID, setEotId] = useState("null");
  const [cosID, setCosId] = useState("null");
  const [contractorData, setContractorData] = useState({});
  const today = new Date().toISOString().split("T")[0];
  const [LetterId, setletterId] = useState("null");

  // ---------- NEW: tab state ----------
  const [activeSection, setActiveSection] = useState("letter");
  const [tabValidationAttempted, setTabValidationAttempted] = useState({});
  const sections = [
    { id: "letter", label: "Letter Details", icon: FileText },
    { id: "associated", label: "Associated Letters", icon: Link2 },
    { id: "documents", label: "Documents", icon: Paperclip },
  ];


  const drawingsIncomplete = () =>
    isDrawingLetterType &&
    (drawingFormData.length === 0 ||
      drawingFormData.some(
        (d) =>
          !d.document_name ||
          d.document_name.trim() === "" ||
          !d.drawingtype ||
          d.drawingtype === "null" ||
          !d.document_file
      ));

  const months = [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 },
  ];

  const handleShow = () => {
    setShow(true);
    getSiteDepartment();
  };

  const handleClose = () => {
    setFileNames("");
    setErrors({});
    setShow(false);
    setActiveSection("letter");
    setTabValidationAttempted({});
    setDrawingFormData([
      { document_name: "", document_file: "", original_filename: "", drawingtype: "null", letterrecord: null }
    ]);
    setFormData({
      project: projectId ? projectId : "null",
      letter_num: "",
      reply_by: "",
      other_type_name: "",
      other_letter_to: "",
      other_letter_from: "",
      subject: "",
      division: "59408e4e-a455-46b6-b3db-8deaa0ae4475",
      letter_date: "null",
      status: "pending",
      workperformedby: letterfor ? letterfor : "null",
      lettertype: lettertype ? lettertype : "null",
      letterExchange:
        sessionStorage.getItem("sitemanagement_role") === "SiteManagement"
          ? "receive"
          : "send",
      is_timebound: false,
      associated_letters: [],
      associated_letters_status: "pending",
      letterdepartment: "",
      letter_from: "null",
      letter_to: "",
      documents: [{ document_name: "", document_file: "" }],
      contractor: contractor ? contractor : "",
      remarks: "",
      select: "",
      tat_duration: 0,
      end_date: null,
    });

    setEOTFormData({
      project: formData.project ? formData.project : "null",
      eot_code: "",
      workperformedby: formData.workperformedby ? formData.workperformedby : "",
      approved_days: "",
      approved_date: "",
      close_letter: "",
      letter: "",
      contractor: "",
      process_initiate_date: "",
      eot_status: "pending",
      days: "",
    });

    setCOSFormData({
      project: formData.project ? formData.project : "null",
      cos_code: "",
      approval_date: "",
      contractor: "",
      process_initiate_date: "",
      cos_status: "pending",
      amount: "",
      workperformedby: formData.workperformedby ? formData.workperformedby : "",
      letter: "",
      approved_amount: "",
      close_letter: "",
      cos_type: "",
      negativeamount: "",
    });

    setmileStoneFormData({
      name: "",
      milestone_date: "",
      milestone_as_per_reschedule: "",
      milestone_as_per_actual: "",
      day: "",
      rescedule_gap_days: "",
      actual_gap_days: "",
      workperformedby: "contractor",
      project: formData.project ? formData.project : "null",
      reschedule_letter: "",
      contractor: "",
      actual_letter: "",
    });

    setProgressErrors("");
  };


  const [drawingFormData, setDrawingFormData] = useState([
    { document_name: "", document_file: "", original_filename: "", drawingtype: "null", letterrecord: null, project: null, miscellaneous_docs: null }
  ])

  const [formData, setFormData] = useState({
    project: projectId ? projectId : "null",
    letter_num: "",
    reply_by: "",
    subject: "",
    division: "59408e4e-a455-46b6-b3db-8deaa0ae4475",
    letter_date: "null",
    status: "pending",
    workperformedby: letterfor
      ? letterfor
      : sessionStorage.getItem("sitemanagement_role") === "SiteManagement"
        ? "contractor"
        : "consultant",
    lettertype: lettertype ? lettertype : "null",
    letterExchange: "receive",
    associated_letters: [],
    associated_letters_status: "pending",
    letterdepartment: "",
    letter_from: "",
    letter_to: "",
    other_letter_from: "",
    other_letter_to: "",
    documents: [{ document_name: "", document_file: "", original_filename: "", drawingtype: "null" }],
    contractor: contractor ? contractor : "",
    remarks: "",
    select: "",
    tat_duration: 0,
    end_date: null,
    other_type_name: "",
    is_timebound: false,
  });
  const DRAWING_LETTER_TYPES = [
    "Design & Drawing (Highway)",
    "Design & Drawing (Structure)",
  ];

  const isDrawingLetterType = DRAWING_LETTER_TYPES.includes(formData.lettertype);

  const [filteredData, setFilteredData] = useState([]);
  const [cosFilteredData, setcosFilteredData] = useState([]);
  const [mileStoneFilteredData, setmileStoneFilteredData] = useState([]);
  const [progressfilterData, setprogressfilterData] = useState([]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      project: projectId,
    }));
  }, [projectId]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      workperformedby: letterfor,
    }));
  }, [letterfor]);

  const [eotFormData, setEOTFormData] = useState({
    project: formData.project ? formData.project : "null",
    eot_code: "",
    workperformedby: "",
    approved_days: "",
    approved_date: "",
    close_letter: "",
    letter: "",
    contractor: "",
    process_initiate_date: "",
    eot_status: "pending",
    days: "",
  });

  const [cosFormData, setCOSFormData] = useState({
    project: formData.project ? formData.project : "null",
    cos_code: "",
    approval_date: "",
    contractor: "",
    process_initiate_date: "",
    cos_status: "pending",
    amount: "",
    workperformedby: "",
    letter: "",
    approved_amount: "",
    close_letter: "",
    cos_type: "",
    negativeamount: "",
  });
  const [mileStoneFormData, setmileStoneFormData] = useState({
    name: "",
    milestone_date: "",
    milestone_as_per_reschedule: "",
    milestone_as_per_actual: "",
    day: "",
    rescedule_gap_days: "",
    actual_gap_days: "",
    workperformedby: "",
    project: formData.project ? formData.project : "null",
    reschedule_letter: "",
    contractor: "",
    actual_letter: "",
    mile_stone_type: "null",
  });

  const [progressData, setProgressData] = useState({
    project: formData.project ? formData.project : "null",
    submitted_financial_progress: "0",
    submitted_physical_progress: "0",
    month: "",
    year: "",
    submitted_letter: "",
    contractor,
    financial_progress: "0",
    approved_letter: "",
    physical_progress: "0",
    date: "null",
  });

  const calculateActualDays = (commencementDate, letterDate) => {
    if (!commencementDate || !letterDate) return null;
    const startDate = new Date(commencementDate);
    const endDate = new Date(letterDate);
    const timeDifference = endDate - startDate;
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    return daysDifference;
  };

  useEffect(() => {
    setEotId("null");
    seteotInputState({});
    setFormData((prevFormData) => ({
      ...prevFormData,
      letter_date: "null",
    }));
    setErrors({});
    setEOTFormData({
      project: formData.project || "",
      eot_code: "",
      workperformedby: "",
      approved_days: "",
      approved_date: "",
      close_letter: "",
      letter: "",
      contractor: "",
      process_initiate_date: "",
      eot_status: "pending",
      days: "",
    });

    setCosId("null");
    setcosInputState({});

    setCOSFormData({
      project: formData.project || "",
      cos_code: "",
      approval_date: "",
      contractor: "",
      process_initiate_date: "",
      cos_status: "pending",
      amount: "",
      workperformedby: "",
      letter: "",
      approved_amount: "",
      close_letter: "",
      cos_type: "",
      negativeamount: "",
    });

    setmileStoneId("null");
    setmileStoneInputState({});
    setmileStoneFormData({
      name: "",
      milestone_date: "",
      milestone_as_per_reschedule: "",
      milestone_as_per_actual: "",
      day: "",
      rescedule_gap_days: "",
      actual_gap_days: "",
      workperformedby: "",
      project: formData.project || "",
      reschedule_letter: "",
      contractor: "",
      actual_letter: "",
    });
    setprogressID("null");
    setprogressInputState({});
    setProgressData({
      project: formData.project || "",
      submitted_financial_progress: "0",
      submitted_physical_progress: "0",
      month: "",
      year: "",
      submitted_letter: "",
      contractor,
      financial_progress: "0",
      approved_letter: "",
      physical_progress: "0",
    });
  }, [
    formData.workperformedby,
    formData.contractor,
    formData.project,
    formData.select,
    formData.lettertype,
  ]);

  useEffect(() => {
    setEOTFormData({
      approved_days: "",
      eot_status: "",
    });
    setCOSFormData({
      approved_amount: "",
      cos_status: "",
    });
    setProgressData((prev) => ({
      ...prev,
      month: "",
      year: "",
    }));
    setmileStoneFormData({
      mile_stone_type: "null",
    });
    setFormData((prev) => ({
      ...prev,
      letter_date: "null",
    }));
  }, [eotID, cosID, mileStoneID, progressID]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      lettertype: "null",
    }));
  }, [formData.workperformedby, formData.division]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      other_type_name: "",
    }));
  }, [formData.lettertype]);

  useEffect(() => {
    if (
      (Array.isArray(contractorlist) && contractorlist.length < 0) ||
      (Array.isArray(contractorlists) && contractorlists.length < 0)
    ) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        workperformedby: "consultant",
        contractor: contractor ? contractor : "",
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        workperformedby: letterfor ? letterfor : "null",
        contractor: contractor ? contractor : "",
      }));
    }
  }, [formData.project]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      letter_from: null,
      letter_to: null,
      other_letter_from: "",
      other_letter_to: "",
    }));
  }, [formData.letterExchange]);
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      other_letter_from: "",
      other_letter_to: "",
    }));
  }, [formData.letter_from, formData.letter_to]);

  useEffect(() => {
    if (eotID !== "null") {
      const data = eotList.filter((i) => i.id === eotID);
      setFilteredData(data);
    } else if (cosID !== "null") {
      const data = cosList.filter((i) => i.id === cosID);
      setcosFilteredData(data);
    } else if (mileStoneID !== "null") {
      const data = mileStoneList.filter((i) => i.id === mileStoneID);
      setmileStoneFilteredData(data);
    } else if (progressID !== "null") {
      const data = progressList.filter((i) => i.id === progressID);
      setprogressfilterData(data);
    } else {
      setFilteredData([]);
      setcosFilteredData([]);
      setmileStoneFilteredData([]);
      setprogressfilterData([]);
    }
  }, [
    eotID,
    eotList,
    cosID,
    cosList,
    mileStoneID,
    mileStoneList,
    progressID,
    progressList,
  ]);

  useEffect(() => {
    const days = calculateActualDays(
      contractorData.commencement_date,
      formData.letter_date
    );
    if (eotID !== "null") {
      if (filteredData.length > 0) {
        const data = filteredData[0];
        setEOTFormData((prev) => ({
          ...prev,
          project: formData.project,
          workperformedby: formData.workperformedby,
          contractor: formData.contractor,
          approved_date: formData.letter_date,
          process_initiate_date: data?.process_initiate_date,
          eot_code: data?.eot_code,
          letter: data?.letter,
          days: data?.days,
          close_letter: data.close_letter
            ? data?.close_letter
            : formData?.letter,
        }));
      }
    }
    if (cosID !== "null") {
      if (cosFilteredData.length > 0) {
        const data = cosFilteredData[0];
        setCOSFormData((prev) => ({
          ...prev,
          project: formData.project,
          workperformedby: formData.workperformedby,
          contractor: formData.contractor,
          approval_date: formData.letter_date,
          amount: data?.amount,
          process_initiate_date: data?.process_initiate_date,
          cos_code: data?.cos_code,
          letter: data?.letter,
          cos_type: data?.cos_type,
          negativeamount: data?.negativeamount,
          close_letter: data?.close_letter
            ? data?.close_letter
            : formData?.letter,
        }));
      }
    }
    if (progressID !== "null") {
      if (progressfilterData.length > 0) {
        const data = progressfilterData[0];
        setProgressData((prev) => ({
          ...prev,
          project: formData.project,
          submitted_physical_progress: data?.submitted_physical_progress,
          submitted_financial_progress: data?.submitted_financial_progress,
          month: data?.month,
          year: data?.year,
          submitted_letter: data?.submitted_letter,
          approved_letter: formData?.letter,
          contractor: formData.contractor,
          date: formData.date,
        }));
      }
    }
    if (
      mileStoneID !== "null" &&
      mileStoneFormData.mile_stone_type === "actual"
    ) {
      if (mileStoneFilteredData.length > 0) {
        const data = mileStoneFilteredData[0];
        setmileStoneFormData((prev) => ({
          ...prev,
          project: formData.project,
          workperformedby: formData.workperformedby,
          contractor: formData.contractor,
          milestone_as_per_actual: formData.letter_date,
          milestone_as_per_reschedule: null,
          rescedule_gap_days: "",
          actual_gap_days: days,
          milestone_date: data?.milestone_date,
          name: data?.name,
          day: data?.day,
        }));
      }
    }
    if (
      mileStoneID !== "null" &&
      mileStoneFormData.mile_stone_type === "reschedule"
    ) {
      if (mileStoneFilteredData.length > 0) {
        const data = mileStoneFilteredData[0];
        setmileStoneFormData((prev) => ({
          ...prev,
          project: formData.project,
          workperformedby: formData.workperformedby,
          contractor: formData.contractor,
          milestone_as_per_reschedule: formData.letter_date,
          milestone_date: data?.milestone_date,
          rescedule_gap_days: days,
          day: data?.day,
          milestone_as_per_actual: null,
          actual_gap_days: "",
        }));
      }
    }
    if (cosFormData.cos_status === "rejected") {
      setCOSFormData((prev) => ({
        ...prev,
        approved_amount: "",
      }));
    }
    if (formData.lettertype === "eot" && eotID === "null") {
      setEOTFormData((prev) => ({
        ...prev,
        contractor: formData.contractor,
        project: formData.project,
        workperformedby: formData.workperformedby,
        process_initiate_date: formData.letter_date,
        approved_date: null,
        eot_code: "",
        letter: "",
        days: "",
      }));
    }
    if (formData.lettertype === "cos" && cosID === "null") {
      setCOSFormData((prev) => ({
        ...prev,
        contractor: formData.contractor,
        project: formData.project,
        workperformedby: formData.workperformedby,
        process_initiate_date: formData.letter_date,
        approval_date: null,
        cos_code: "",
        letter: "",
        amount: "",
        negativeamount: "",
        cos_type: "",
      }));
    }
    if (formData.lettertype === "SiteProgress" && progressID === "null") {
      setProgressData((prev) => ({
        ...prev,
        contractor: formData.contractor,
        project: formData.project,
        submitted_letter: "",
        financial_progress: "",
        physical_progress: "",
        month: "",
        year: "",
        submitted_physical_progress: "",
        submitted_financial_progress: "",
      }));
    }
  }, [
    formData.project,
    formData.workperformedby,
    formData.contractor,
    formData.letter_date,
    formData.select,
    formData.lettertype,
    eotID,
    eotFormData.eot_status,
    cosID,
    cosFormData.cos_status,
    mileStoneID,
    mileStoneFormData.mile_stone_type,
    contractorData.commencement_date,
    progressID,
  ]);

  function addDaysToLetterDate(letterDate, daysToAdd) {
    const date = new Date(letterDate);
    date.setDate(date.getDate() + daysToAdd);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    if (cosFormData.cos_type === "positivecos") {
      setCOSFormData((prev) => ({
        ...prev,
        negativeamount: "",
      }));
    }
    if (cosFormData.cos_type === "negativecos") {
      setCOSFormData((prev) => ({
        ...prev,
        amount: "",
      }));
    } else {
      setCOSFormData((prev) => ({
        ...prev,
        amount: "",
        negativeamount: "",
      }));
    }
  }, [cosFormData.cos_type]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      letter_date: "null",
    }));

    setmileStoneFormData((prev) => ({
      ...prev,
      actual_gap_days: "",
      rescedule_gap_days: "",
    }));
  }, [mileStoneFormData.mile_stone_type]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      select: "",
      is_timebound: false,
    }));
  }, [formData.lettertype]);

  useEffect(() => {
    const letter_tat = letterData?.find(
      (item) => item?.letter_type_data?.name === formData?.lettertype
    );
    if (letter_tat) {
      setFormData((prev) => ({
        ...prev,
        tat_duration: Number(letter_tat.tat_duration),
        end_date: addDaysToLetterDate(
          formData.letter_date,
          letter_tat.tat_duration
        ),
      }));
    }
  }, [
    formData.lettertype,
    formData.letter_date,
    letterData,
    formData.is_timebound,
  ]);

  useEffect(() => {
    if (formData.is_timebound === false) {
      setFormData((prev) => ({
        ...prev,
        end_date: null,
      }));
    }
  }, [formData.is_timebound]);

  useEffect(() => {
    if (formData.tat_duration) {
      setFormData((prev) => ({
        ...prev,
        end_date: addDaysToLetterDate(
          formData.letter_date,
          Number(formData.tat_duration)
        ),
      }));
    }
  }, [formData.tat_duration, formData.letter_date]);

  // ---------- NEW: field labels + tab-wise validation (same pattern as AddSiteEmployee) ----------
  const fieldLabels = {
    letter_num: "Letter Number",
    project: "Site Project",
    subject: "Subject",
    letter_date: "Letter Date",
    status: "Status",
    lettertype: "Letter Type",
    workperformedby: "Matter Related To",
    contractor: "Contractor Name",
    other_type_name: "Other Letter Name",
    tat_duration: "TAT Duration",
    other_letter_from: "Other Letter From",
    other_letter_to: "Other Letter To",
  };

  const isFieldEmpty = (field, data = formData) => {
    const value = data[field];
    if (Array.isArray(value)) return value.length === 0;
    return (
      value === null ||
      value === undefined ||
      value === "null" ||
      (typeof value === "string" && value.trim() === "")
    );
  };

  const getTabRequiredFields = (tabId, data = formData) => {
    if (tabId === "letter") {
      let fields = [
        "letter_num",
        "project",
        "subject",
        "letter_date",
        "status",
        "lettertype",
        "workperformedby",
      ];
      if (data.workperformedby === "contractor") fields.push("contractor");
      if (data.lettertype === "other") fields.push("other_type_name");
      if (data.is_timebound === true) fields.push("tat_duration");
      if (data.letter_from === "other" && data.letterExchange === "receive")
        fields.push("other_letter_from");
      if (data.letter_to === "other" && data.letterExchange === "send")
        fields.push("other_letter_to");
      return fields;
    }
    return [];
  };

  const documentsIncomplete = () =>
    formData.documents.some(
      (d) => !d.document_name || d.document_name.trim() === "" || !d.document_file
    );

  const tabHasMissingFields = (tabId) => {
    if (tabId === "documents") return documentsIncomplete() || drawingsIncomplete();
    return getTabRequiredFields(tabId).some((field) => isFieldEmpty(field));
  };

  const validateCurrentTab = () => {
    const currentTab = activeSection;
    const fieldsToValidate = getTabRequiredFields(currentTab);
    const newErrors = {};

    fieldsToValidate.forEach((field) => {
      if (isFieldEmpty(field)) {
        newErrors[field] = `${fieldLabels[field] || field} is required!`;
      }
    });

    setErrors((prev) => {
      const updated = { ...prev, ...newErrors };
      fieldsToValidate.forEach((field) => {
        if (!isFieldEmpty(field)) delete updated[field];
      });
      return updated;
    });

    setTabValidationAttempted((prev) => ({ ...prev, [currentTab]: true }));
    return Object.keys(newErrors).length === 0;
  };

  const hasCurrentTabErrors = () =>
    getTabRequiredFields(activeSection).some((field) => errors[field]);

  const getCurrentTabErrorMessage = () => {
    const missingFields = getTabRequiredFields(activeSection)
      .filter((field) => isFieldEmpty(field))
      .map((field) => fieldLabels[field] || field);

    if (missingFields.length === 0) return null;
    if (missingFields.length === 1)
      return `${missingFields[0]} is required to proceed`;

    const tabLabel =
      sections.find((s) => s.id === activeSection)?.label || activeSection;
    return `Please fill all required fields in ${tabLabel} before proceeding`;
  };

  const goToNextTab = () => {
    const currentIndex = sections.findIndex((s) => s.id === activeSection);
    const nextTab = sections[currentIndex + 1]?.id;

    if (!validateCurrentTab()) {
      const formContainer = document.querySelector(".modern-modal-body");
      if (formContainer) formContainer.scrollTop = 0;
      return;
    }

    if (currentIndex < sections.length - 1) {
      setActiveSection(nextTab);
    }
  };

  const goToPreviousTab = () => {
    const idx = sections.findIndex((s) => s.id === activeSection);
    if (idx > 0) {
      setActiveSection(sections[idx - 1].id);
    }
  };

  const validateForm = () => {
    const requiredFields = [
      "letter_num",
      "project",
      "subject",
      "letter_date",
      "status",
      "lettertype",
      "workperformedby",
    ];
    const newErrors = requiredFields.reduce((acc, field) => {
      if (
        !formData[field] ||
        formData[field] === "null" ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        acc[field] = `${fieldLabels[field] || field} is required!`;
      }
      return acc;
    }, {});
    if (formData.workperformedby === "contractor" && !formData.contractor) {
      newErrors["contractor"] = "Contractor Name is required!";
    }
    if (
      formData.lettertype === "other" &&
      (!formData.other_type_name || formData.other_type_name.trim() === "")
    ) {
      newErrors["other_type_name"] = `Other Letter Name is required!`;
    }
    if (
      formData.is_timebound === true &&
      (formData.tat_duration === null ||
        formData.tat_duration === "" ||
        formData.tat_duration === undefined)
    ) {
      newErrors["tat_duration"] = "Letter TAT Duration is required!";
    }

    if (
      formData.letter_from === "other" &&
      formData.letterExchange === "receive" &&
      (!formData.other_letter_from || formData.other_letter_from.trim() === "")
    ) {
      newErrors["other_letter_from"] = `Other Letter From is required!`;
    }
    if (
      formData.letter_to === "other" &&
      formData.letterExchange === "send" &&
      (!formData.other_letter_to || formData.other_letter_to.trim() === "")
    ) {
      newErrors["other_letter_to"] = `Other Letter To is required!`;
    }

    if (
      formData.associated_letters &&
      formData.associated_letters.length > 0 &&
      !formData.associated_letters_status
    ) {
      newErrors["associated_letters_status"] =
        "Status for associated letters is required!";
    }

    formData.documents.forEach((doc, index) => {
      if (!doc.document_name || doc.document_name.trim() === "") {
        newErrors[`document_name_${index}`] = `Letter Name  ${index + 1
          } is required for document ${index + 1}`;
      }
      if (!doc.document_file) {
        newErrors[`document_file_${index}`] = `Document File ${index + 1
          } is required for document ${index + 1}`;
      }
    });


    if (isDrawingLetterType) {
      if (drawingFormData.length === 0) {
        newErrors["drawings"] = "At least one drawing is required!";
      }
      drawingFormData.forEach((d, index) => {
        if (!d.document_name || d.document_name.trim() === "") {
          newErrors[`drawing_name_${index}`] = `Drawing ${index + 1} name is required!`;
        }
        if (!d.drawingtype || d.drawingtype === "null") {
          newErrors[`drawingtype_${index}`] = `Drawing ${index + 1} type is required!`;
        }
        if (!d.document_file) {
          newErrors[`drawing_file_${index}`] = `Drawing ${index + 1} file is required!`;
        }
      });
    }

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const getContractorData = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/contractor/${formData.contractor}/`
      );
      setContractorData(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (formData.contractor) {
      getContractorData();
    }
  }, [formData.contractor]);

  const handleInputChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else {
      newValue = value;
    }

    if (name === "letter_date") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Date cannot be greater than today.",
        }));
        return;
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      }
    }

    if (name === "other_type_name") {
      const charCount = value.trim().length;

      if (charCount > 15) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          other_type_name: "Maximum 15 characters allowed.",
        }));
        return;
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          other_type_name: "",
        }));
      }
    }

    setInputState((prevState) => ({
      ...prevState,
      [name]:
        newValue && (Array.isArray(newValue) ? newValue.length > 0 : newValue)
          ? "success"
          : "",
    }));

    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,

        ...(name === "reply_by" &&
          prevFormData.letterExchange === "send" && {
          letter_from: value,
        }),

        ...(name === "workperformedby" &&
          value === "consultant" && {
          contractor: "",
        }),
      };

      return updatedFormData;
    });

    // clear field error as user fills it
    if (name !== "letter_date" && name !== "other_type_name") {
      setErrors((prevErrors) => {
        const updated = { ...prevErrors };
        if (newValue && !(Array.isArray(newValue) && newValue.length === 0))
          delete updated[name];
        return updated;
      });
    }
  };

  const ProjectListOption = projectList
    ?.sort((a, b) => a.site_prcode.localeCompare(b.site_prcode))
    .map((i) => ({
      value: i.id,
      label: `${i.site_prcode} - ${i.project_short_name}`,
    }));
  const ContractorListOption = contractorlists
    ?.sort((a, b) => a.name.localeCompare(b.name))
    .map((i) => ({
      value: i.name,
      label: `${i.name}`,
    }));

  const extendedLetterOptions = [
    ...ContractorListOption,
    { label: "Other", value: "other" },
  ];

  const handleProjectChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        project: "",
      });
    } else {
      setFormData({
        ...formData,
        project: selectedOption.value,
      });
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  };
  const handleContractorInputChange = (selectedOption) => {
    if (!selectedOption) {
      if (formData.letterExchange === "receive") {
        setFormData({
          ...formData,
          letter_from: "",
        });
      } else if (formData.letterExchange === "send") {
        setFormData({
          ...formData,
          letter_to: "",
        });
      }
    } else {
      if (formData.letterExchange === "receive") {
        setFormData({
          ...formData,
          letter_from: selectedOption.value,
          letter_to: "",
        });
      } else if (formData.letterExchange === "send") {
        setFormData({
          ...formData,
          letter_to: selectedOption.value,
          letter_from: "",
        });
      }
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  };

  const handleLetterTypeOption = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        lettertype: "null",
      });
    } else {
      setFormData({
        ...formData,
        lettertype: selectedOption.value,
      });
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.lettertype;
      return updatedErrors;
    });
  };

  const handleEotInputChange = (e) => {
    const { name, value } = e.target;
    seteotInputState({
      ...eotinputState,
      [name]: value.trim() ? "green" : "",
    });
    setEOTFormData({
      ...eotFormData,
      [name]: value,
    });
  };
  const handleCOSInputChange = (e) => {
    const { name, value } = e.target;
    setcosInputState({
      ...cosinputState,
      [name]: value.trim() ? "green" : "",
    });
    setCOSFormData({
      ...cosFormData,
      [name]: value,
    });
  };
  const handleMilestoneChange = (e) => {
    const { name, value } = e.target;
    setmileStoneInputState({
      ...mileStoneinputState,
      [name]: value.trim() ? "green" : "",
    });
    setmileStoneFormData({
      ...mileStoneFormData,
      [name]: value,
    });
  };

  const [progresserrors, setProgressErrors] = useState({
    submitted_physical_progress: "",
    submitted_financial_progress: "",
  });

  const handleProgressData = (e) => {
    const { name, value } = e.target;
    let errorMessage = "";

    if (name === "submitted_physical_progress") {
      if (
        Number(value) < previousprogressdata.physical_progress ||
        Number(value) > 100
      ) {
        errorMessage = `Value must be between ${previousprogressdata.physical_progress}% - 100%`;
      }
    }
    if (name === "physical_progress") {
      if (
        Number(value) < previousprogressdata.physical_progress ||
        Number(value) > 100
      ) {
        errorMessage = `Value must be between ${previousprogressdata.physical_progress}% - 100%`;
      }
    }

    if (name === "financial_progress") {
      if (
        Number(value) < previousprogressdata.financial_progress ||
        Number(value) > 100
      ) {
        errorMessage = `Value must be between ${previousprogressdata.financial_progress}% - 100%`;
      }
    }
    if (name === "submitted_financial_progress") {
      if (
        Number(value) < previousprogressdata.financial_progress ||
        Number(value) > 100
      ) {
        errorMessage = `Value must be between ${previousprogressdata.financial_progress}% - 100%`;
      }
    }
    setprogressInputState({
      ...progressInputState,
      [name]: value.trim() ? "green" : "",
    });

    setProgressData({
      ...progressData,
      [name]: value,
    });

    setProgressErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };

  const [projectNAmeCode, setProjectNameCode] = useState([]);

  useEffect(() => {
    const projectData = projectList?.filter((i) => i.id === formData.project);

    const projectName = projectData?.map((i) => ({
      code: i.site_prcode,
      name: i.project_short_name,
    }));

    setProjectNameCode(projectName);
  }, [formData.project, projectList]);

  const handleDocInputChange = (index, e) => {
    const { name, value, files } = e.target;

    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData.documents];

      if (files && files[0]) {
        const file = files[0];

        const allowedTypes = [
          "application/pdf",
          "application/zip",
          "application/x-zip-compressed",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
          "image/png",
          "image/gif",
        ];

        if (
          !allowedTypes.includes(file.type) &&
          !file.name.match(/\.(zip|pdf|xls|xlsx|png|gif)$/i)
        ) {
          toast.error("Only ZIP, PDF, PNG, GIF and Excel files are allowed!");
          return prevFormData;
        }

        const symbols = "!@#$%^&*()_-+=";
        const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
        const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const numbers = "0123456789";
        const now = new Date();
        const date = now
          .toLocaleDateString("en-GB")
          .split("/")
          .reverse()
          .join("-");
        const time = now
          .toLocaleTimeString("en-GB", { hour12: false })
          .replace(/:/g, "-");
        const allChars =
          symbols + lowercaseLetters + uppercaseLetters + numbers;

        let randomCode = "";
        for (let i = 0; i < 8; i++) {
          const randomIndex = Math.floor(Math.random() * allChars.length);
          randomCode += allChars[randomIndex];
        }

        const projectPart = projectNAmeCode
          ?.map((i) => `${i.code}-${i.name}`)
          .join("_");

        const aimantraFileName = `${projectName ? `${siteCode}-${projectName}` : projectPart
          }  ${file.name} ${date} ${time}_${randomCode}`;
        const customFile = new File([file], aimantraFileName, {
          type: file.type,
        });

        newDocuments[index] = {
          ...newDocuments[index],
          document_file: customFile,
          original_filename: aimantraFileName,
        };

        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames[index] = aimantraFileName;
          return newFileNames;
        });
      } else {
        newDocuments[index] = {
          ...newDocuments[index],
          [name]: value,
        };
      }

      return { ...prevFormData, documents: newDocuments };
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      const fieldKey = `${name}_${index}`;
      const isValid =
        name === "document_name" ? value.trim() !== "" : files && files[0];
      if (isValid) {
        delete newErrors[fieldKey];
      }
      return newErrors;
    });
  };
  const handleAddDocuments = () => {
    setFormData((prev) => ({
      ...prev,
      documents: [
        ...prev.documents,
        { document_name: "", document_file: null, original_filename: "", drawingtype: "null", is_drawing: false },
      ],
    }));
  };
  const handleAddDrawingDocuments = () => {
    setFormData((prev) => ({
      ...prev,
      documents: [
        ...prev.documents,
        {
          document_name: "",
          document_file: null,
          original_filename: "",
          drawingtype: "null",
          is_drawing: true,
        },
      ],
    }));
  };

  const addNewDocument = () => {
    setDrawingFormData((prevFormData) => [
      ...prevFormData,
      {
        document_name: "", document_file: "", original_filename: "", drawingtype: "null", letterrecord: null
      },
    ]);
  };


  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: prevFormData.documents?.filter((_, i) => i !== index),
    }));
    setFileNames((prevFileNames) => {
      if (!Array.isArray(prevFileNames)) return [];
      return prevFileNames.filter((_, i) => i !== index);
    });
  };

  const createCustomFile = (originalFile) => {
    const randomCode = generateRandomString();
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
    return new File([originalFile], customFileName, {
      type: originalFile.type,
    });
  };

  const generateRandomString = () => {
    const chars =
      "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from(
      { length: 8 },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  };

  const fetchAssociatedLetters = async () => {
    try {
      let url = "";

      if (eotID !== "null") {
        const letterId = eotFormData?.close_letter
          ? eotFormData.close_letter
          : eotFormData?.letter;
        url = `${BASE_URL}/siteproject/letterrecordsbyid/${letterId}/`;
      } else if (progressID !== "null") {
        url = `${BASE_URL}/siteproject/letterrecordsbyid/${progressData?.submitted_letter}/`;
      } else if (cosID !== "null") {
        const letterId = cosFormData?.close_letter
          ? cosFormData.close_letter
          : cosFormData?.letter;
        url = `${BASE_URL}/siteproject/letterrecordsbyid/${letterId}/`;
      } else {
        url = `${BASE_URL}/siteproject/letterrecordbclosestatus/${formData.project || "null"
          }/${formData.workperformedby || "null"}/${formData.lettertype || "null"
          }/`;
      }

      const res = await axios.get(url);
      setTrackRecordList(res.data);
    } catch (err) {
      console.error("Error fetching letters.", err);
    }
  };

  const trackrecordfilter = trackRecordList?.filter(
    (i) => i.letter_date <= formData.letter_date
  );

  const options = trackrecordfilter
    .sort((a, b) => parseInt(a.letter_num) - parseInt(b.letter_num))
    .map((e) => ({
      value: e.id,
      label: `${e.letter_num} - ${e.letter_date}`,
    }));

  const handleChangecc = (selected) => {
    const associated_letters =
      selected.length > 0 ? selected.map((item) => item.value) : "";
    setFormData((prevState) => ({
      ...prevState,
      associated_letters,
    }));
  };

  const getSiteDepartment = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/department/`);
      setSiteDepartmentList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };
  const getProjectContractorDetails = async () => {
    try {
      const contractordetails = await axios.get(
        `${BASE_URL}/siteproject/contractorbyproject/${formData.project}/null/`
      );
      setContractorLists(contractordetails.data);
    } catch (err) {
    } finally {
    }
  };

  const getEot = async () => {
    try {
      let eot = await axios.get(
        `${BASE_URL}/siteproject/eotfilter/${formData.project}/${formData.workperformedby
        }/${formData.contractor ? formData.contractor : null}/pending/`
      );
      setEotList(eot.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
    }
  };
  const getMilestone = async () => {
    try {
      let milestone = await axios.get(
        `${BASE_URL}/siteproject/milestonebycontractor/${formData.contractor}/`
      );
      setmileStoneList(milestone.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
    }
  };
  const getCOS = async () => {
    try {
      let cos = await axios.get(
        `${BASE_URL}/siteproject/cosfilter/${formData.project}/${formData.workperformedby
        }/${formData.contractor ? formData.contractor : null}/pending/`
      );
      setCosList(cos.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
    }
  };
  const { month, year } = progressData;

  useEffect(() => {
    if (
      (formData.project && formData.workperformedby) ||
      eotID !== "null" ||
      cosID !== "null" ||
      progressID !== "null"
    ) {
      fetchAssociatedLetters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formData.project,
    formData.workperformedby,
    formData.lettertype,
    formData.select,
    eotID,
    eotFormData.letter,
    cosFormData.letter,
    progressID,
    progressData.submitted_letter,
    eotFormData.eot_status,
    eotFormData.close_letter,
    cosFormData.close_letter,
  ]);

  useEffect(() => {
    if (!progressData.submitted_letter) {
      if (!progressData.month || !progressData.year) {
        console.error(
          "Both month and year are required to fetch progress data."
        );
        return;
      }
    }

    const fetchProgressData = async () => {
      try {
        if (year < oldestYear) {
          console.warn(
            `Skipping loop: Year (${year}) is not greater than oldestYear (${oldestYear}).`
          );
          return;
        }
        let currentMonth = month - 1 === 0 ? 12 : month - 1;
        let currentYear = month - 1 === 0 ? year - 1 : year;
        let dataFound = false;

        while (!dataFound) {
          const response = await axios.get(
            `${BASE_URL}/siteproject/progressbyproject/${formData.project}/${formData.contractor}/${currentMonth}/${currentYear}/`
          );

          const progressData = response.data;

          if (progressData.length > 0) {
            const { financial_progress, physical_progress } = progressData[0];

            setPreviousProgressData({
              financial_progress,
              physical_progress,
            });

            dataFound = true;
          } else {
            console.warn(
              `No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`
            );

            currentMonth -= 1;
            if (currentMonth === 0) {
              currentMonth = 12;
              currentYear -= 1;
            }

            if (currentYear < year - 1) {
              console.error("No data found for the past year.");
              break;
            }
          }
        }
      } catch (error) {
        console.error("Error fetching progress data:", error);
      }
    };

    fetchProgressData();
  }, [month, year]);

  const getProgress = async () => {
    setBuffering(true);

    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/progressbyproject/${formData.project}/${formData.contractor}/`
      );

      setprogressList(response.data);

      const yearField = response.data.map((item) => ({
        ...item,
        year: item.year || 0,
      }));

      const oldestYear = yearField.reduce(
        (min, item) => (item.year && item.year < min ? item.year : min),
        Infinity
      );
      setOldestYear(oldestYear);
    } catch (err) {
      console.log("Error fetching progress:", err);
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (formData.project !== "null") {
      if (formData.lettertype === "eot") {
        getEot();
      }
      if (formData.lettertype === "cos") {
        getCOS();
      }
      if (formData.contractor !== "" && formData.lettertype === "Milestone") {
        getMilestone();
      }

      if (
        formData.contractor !== "" &&
        formData.lettertype === "SiteProgress"
      ) {
        getProgress();
      }
    }
  }, [
    formData.project,
    formData.workperformedby,
    formData.contractor,
    formData.lettertype,
    formData.select,
    eotID,
    cosID,
    mileStoneID,
    progressID,
  ]);

  // *******************************Contractor Linking*******************************

  const [ContractorDataList, setContractorDataList] = useState({
    schedule_construction_completion_date_with_eot: null,
    EOT_Days: "null",
  });

  const [contractorList, setContractorList] = useState({});

  const getContractorDataa = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/EOTCOSContractorbyid/${formData.contractor}/`
      );
      setContractorList(res.data);
      return res.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  useEffect(() => {
    if (!DRAWING_LETTER_TYPES.includes(formData.lettertype)) {
      setDrawingFormData([
        { document_name: "", document_file: "", original_filename: "", drawingtype: "null", letterrecord: null },
      ]);
    }
  }, [formData.lettertype]);
  const [letterNumberList, setLetterNumberList] = useState([]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const filterNum = letterNumberList.filter(
      (i) => i.letter_num === formData.letter_num
    );
    if (filterNum.length > 0) {
      toast.error(
        `Letter number ${formData.letter_num} already exists. Please use a different number.`
      );
      setActiveSection("letter");
      return;
    }

    if (validateForm()) {
      setLoading(true);

      try {
        const formDataToSend = new FormData();

        const formDataToSendDrawingAdd = new FormData();

        Object.keys(formData).forEach((key) => {
          if (key !== "documents" && formData[key]) {
            if (key === "associated_letters") {
              formDataToSend.append(key, JSON.stringify(formData[key]));
            } else {
              formDataToSend.append(key, formData[key]);
            }
          }
        });

        let fileIndex = 0;
        for (let doc of formData.documents) {
          if (doc.document_file) {
            const fileId = await uploadFileInChunks(
              doc.document_file,
              doc.document_name,
              setUploadProgress
            );
            if (!fileId) {
              console.error(`❌ Failed to upload file: ${doc.document_name}`);
              continue;
            }
            formDataToSend.append("file_ids", fileId);
            formDataToSend.append(
              `documents[${fileIndex}][document_name]`,
              doc.document_name
            );
            formDataToSend.append(
              `documents[${fileIndex}][original_filename]`,
              doc.document_file.name
            );
            formDataToSend.append(
              `documents[${fileIndex}][file]`,
              doc.document_file
            );

            formDataToSend.append(
              `documents[${fileIndex}][drawingtype]`,
              doc.drawingtype
            );
            fileIndex++;
          }
        }

        if (!formDataToSend.has("file_ids")) {
          console.error("❌ No valid files were uploaded.");
          setLoading(false);
          return;
        }

        const res = await axiosInstance2.post(
          `/siteproject/documentbulkwithletter-new/`,
          formDataToSend,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            },
          }
        );
        if (res.status === 200) {
          const generatedId = res.data.letter.id;
          const generatedProject = res.data.letter.project;


          setletterId(generatedId);
          try {
            const letteremail = await axios.post(
              `${BASE_URL}/siteproject/sendletternotificationtoauthorityengineeronNewLetter/`,
              { letter_id: generatedId }
            );

            if (letteremail.status === 200) {
              if (res.data.letter.lettertype === "Design & Drawing (Highway)" || res.data.letter.lettertype === "Design & Drawing (Structure)") {
                let drawingIndex = 0; // naya counter, fileIndex reuse mat karo

                for (let doc of drawingFormData) {
                  if (doc.document_file) {
                    const fileId = await uploadFileInChunks(
                      doc.document_file,
                      doc.document_name,
                      setUploadProgress
                    );
                    if (!fileId) {
                      console.error(`❌ Failed to upload file: ${doc.document_name}`);
                      continue;
                    }

                    formDataToSendDrawingAdd.append("file_ids", fileId);
                    formDataToSendDrawingAdd.append(`documents[${drawingIndex}].document_name`, doc.document_name);
                    formDataToSendDrawingAdd.append(`documents[${drawingIndex}].original_filename`, doc.document_file.name);
                    formDataToSendDrawingAdd.append(`documents[${drawingIndex}].document_file`, doc.document_file);
                    formDataToSendDrawingAdd.append(`documents[${drawingIndex}].drawingtype`, doc.drawingtype);
                    formDataToSendDrawingAdd.append(`documents[${drawingIndex}].letterrecord`, generatedId);
                    formDataToSendDrawingAdd.append(`documents[${drawingIndex}].project`, generatedProject);
                    formDataToSendDrawingAdd.append(`documents[${drawingIndex}].miscellaneous_docs`, generatedProject);
                    drawingIndex++;
                  }
                }

                if (!formDataToSendDrawingAdd.has("file_ids")) {
                  console.error("❌ No valid files were uploaded.");
                  setLoading(false);
                  return;
                }
                try {
                  const response = await axiosInstance2.post(
                    `/siteproject/documentbulk/`,
                    formDataToSendDrawingAdd,
                    {
                      onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                      }
                    },
                    { headers: { "Content-Type": "multipart/form-data" } }
                  );
                  if (response.status >= 200) {
                    toast.success("Letter Documents uploaded successfully!");
                    handleClose();
                  }
                } catch (error) {
                  console.error("Error uploading documents", error);
                }
              }
              await getProjects();
              if (!isDrawingLetterType) handleClose();

            }
          } catch (error) {
            console.error(error);
          }
        } else {
          throw new Error("Document upload failed");
        }
      } catch (err) {
        toast.error("Error uploading documents");
        console.error("Error uploading documents", err);
      } finally {
        setLoading(false);
        setUploadProgress(0);
      }
    } else {
      const firstErrorTab = sections.find((s) =>
        tabHasMissingFields(s.id)
      )?.id;
      if (firstErrorTab) {
        setActiveSection(firstErrorTab);
        setTabValidationAttempted((prev) => ({
          ...prev,
          [firstErrorTab]: true,
        }));
      }
    }
  };

  // Enter key on non-final tab => go next instead of submitting
  const handleFormSubmitWrapper = (e) => {
    if (activeSection !== "documents") {
      e.preventDefault();
      goToNextTab();
      return;
    }
    handleFormSubmit(e);
  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractor: letterfor === "contractor" ? contractor : "",
    }));
  }, [contractor]);
  useEffect(() => {
    if (formData.project !== "null") {
      getProjectContractorDetails();
    }
  }, [formData.project]);

  const [isLetterNumLoaded, setIsLetterNumLoaded] = useState(false);

  const fetchLetterNumber = async () => {
    try {
      setIsLetterNumLoaded(false);

      const res = await axios.get(
        `${BASE_URL}/siteproject/letterrecordfilterletter/${formData.project}/null/null/null/null/null/`
      );

      if (res.status === 200) {
        setLetterNumberList(res.data);
        setIsLetterNumLoaded(true);
      }
    } catch (error) {
      console.error(error);
      setIsLetterNumLoaded(false);
    }
  };

  useEffect(() => {
    if (show === true && formData.project !== "null") {
      fetchLetterNumber();
    }
  }, [formData.project, show]);

  useEffect(() => {
    const filterNum = letterNumberList.filter(
      (i) => i.letter_num === formData.letter_num
    );
    if (filterNum.length > 0) {
      toast.warning(
        `Letter already exist change letter number ${formData.letter_num}`
      );
    }
  }, [formData.letter_num, letterNumberList]);

  const [lettertypeList, setlettertype] = useState([]);

  useEffect(() => {
    if (letterfor === "contractor") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        workperformedby: "contractor",
      }));
    }
  }, [letterfor]);

  useEffect(() => {
    if (formData.workperformedby === "consultant") {
      const lettertypeOptionss = LetterTypeOptions.filter(
        (i) =>
          i.work_performed_by === "consultant" ||
          i.work_performed_by === "For Both"
      );
      setlettertype(lettertypeOptionss);
    } else if (formData.workperformedby === "contractor") {
      const lettertypeOptionss = LetterTypeOptions.filter(
        (i) =>
          i.work_performed_by === "contractor" ||
          i.work_performed_by === "For Both"
      );
      setlettertype(lettertypeOptionss);
    }
  }, [formData.workperformedby, LetterTypeOptions]);

  const sityeProjectCode = sessionStorage.getItem(
    "sitemanagement_project_site_prcode"
  );
  const siteProjectName = sessionStorage.getItem(
    "sitemanagement_project_short_name"
  );

  const letterExchangeOptions = [
    { value: "receive", label: "Received" },
    { value: "send", label: "Send" },
  ];
  const replyByOptions = [
    { value: "HO", label: "Head Office" },
    { value: "SO", label: "Site Office" },
  ];
  const matterOptions = [
    ...(formData.project &&
      ((Array.isArray(contractorlist) && contractorlist.length > 0) ||
        (Array.isArray(contractorlists) && contractorlists.length > 0))
      ? [{ value: "contractor", label: "Contractor" }]
      : []),
    { value: "consultant", label: "Consultant" },
  ];
  const statusOptions = [
    { value: "pending", label: "Pending" },
    ...(formData.letterExchange === "receive"
      ? []
      : [{ value: "close", label: "Close" }]),
  ];
  const assocStatusOptions = [
    { value: "pending", label: "Pending" },
    { value: "close", label: "Close" },
  ];
  const contractorSelectOptions = [...(contractorlists || [])]
    .sort((a, b) =>
      a.name?.localeCompare(b.name, "en", { ignorePunctuation: true })
    )
    .map((i) => ({ value: i.id, label: i.name }));

  const fromToValue =
    formData.letterExchange === "receive"
      ? formData.letter_from === "null" || !formData.letter_from
        ? null
        : extendedLetterOptions.find((o) => o.value === formData.letter_from)
      : formData.letter_to === "null" || !formData.letter_to
        ? null
        : extendedLetterOptions.find((o) => o.value === formData.letter_to);

  const fromToError =
    formData.letterExchange === "send" ? errors.letter_to : errors.letter_from;

  // ---------------------------- SECTIONS ----------------------------

  const renderLetterSection = () => (
    <div className="form-section">
      <div className="section-title">
        <FileText size={18} />
        <h4>Letter Details</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label>
            <MapPin size={14} /> Site Project{" "}
            <span className="required">
              {projectId !== "null" ? "(Read-Only)" : "*"}
            </span>
          </label>
          <Select
            options={ProjectListOption}
            onChange={handleProjectChange}
            value={
              formData.project === "null" || formData.project === undefined
                ? null
                : ProjectListOption?.find(
                  (option) => option.value === formData.project
                )
            }
            placeholder={
              siteCode
                ? `${siteCode}-${projectName}`
                : siteProjectName
                  ? `${sityeProjectCode}-${siteProjectName}`
                  : "Select a Project"
            }
            isSearchable
            isClearable
            noOptionsMessage={() => "No other options"}
            styles={CSSForSelectModern}
            isDisabled={projectId !== "null"}
          />
          {errors.project && (
            <span className="error-message">{errors.project}</span>
          )}
        </div>

        <div className="form-field">
          <label>
            <Mail size={14} /> Letter Exchange<span className="required">*</span>
          </label>
          <Select
            options={letterExchangeOptions}
            isSearchable
            value={
              letterExchangeOptions.find(
                (o) => o.value === formData.letterExchange
              ) || null
            }
            onChange={(selected) =>
              handleInputChange({
                target: {
                  name: "letterExchange",
                  value: selected ? selected.value : "",
                },
              })
            }
            styles={CSSForSelectModern}
          />
          {errors.letterExchange && (
            <span className="error-message">{errors.letterExchange}</span>
          )}
        </div>

        {formData.letterExchange === "send" && (
          <div className="form-field">
            <label>
              <Building2 size={14} /> Reply By<span className="required">*</span>
            </label>
            <Select
              options={replyByOptions}
              isSearchable
              isClearable
              placeholder="Select a Reply By"
              value={
                replyByOptions.find((o) => o.value === formData.reply_by) ||
                null
              }
              onChange={(selected) =>
                handleInputChange({
                  target: {
                    name: "reply_by",
                    value: selected ? selected.value : "",
                  },
                })
              }
              styles={CSSForSelectModern}
            />
            {errors.reply_by && (
              <span className="error-message">{errors.reply_by}</span>
            )}
          </div>
        )}

        {!isLetterNumLoaded ? (
          <div className="form-field">
            <div className="spinner center">
              {[...Array(12)].map((_, i) => (
                <div key={i} className="spinner-blade"></div>
              ))}
            </div>
          </div>
        ) : (
          <div className="form-field">
            <label>
              <Hash size={14} />{" "}
              {formData.letterExchange === "null"
                ? ""
                : toTitleCase(formData.letterExchange)}{" "}
              Letter Number<span className="required">*</span>
            </label>
            <input
              type="text"
              name="letter_num"
              placeholder="Enter Letter Number"
              value={formData.letter_num}
              onChange={handleInputChange}
              className={
                errors.letter_num
                  ? "error"
                  : inputState.letter_num
                    ? "success"
                    : ""
              }
            />
            {errors.letter_num && (
              <span className="error-message">{errors.letter_num}</span>
            )}
          </div>
        )}

        {!letterfor && (
          <div className="form-field">
            <label>
              <Users size={14} /> Matter Related To
              <span className="required">*</span>
            </label>
            <Select
              options={matterOptions}
              isSearchable
              isClearable
              placeholder="Select Option"
              value={
                matterOptions.find(
                  (o) => o.value === formData.workperformedby
                ) || null
              }
              onChange={(selected) =>
                handleInputChange({
                  target: {
                    name: "workperformedby",
                    value: selected ? selected.value : "",
                  },
                })
              }
              styles={CSSForSelectModern}
            />
            {errors.workperformedby && (
              <span className="error-message">{errors.workperformedby}</span>
            )}
          </div>
        )}

        {formData.workperformedby === "contractor" && (
          <div className="form-field">
            <label>
              <Briefcase size={14} /> Contractor Name
              <span className="required">*</span>
            </label>
            <Select
              options={contractorSelectOptions}
              isSearchable
              isClearable
              isDisabled={!!contractor}
              placeholder="Select a Contractor"
              value={
                contractorSelectOptions.find(
                  (o) => o.value === formData.contractor
                ) || null
              }
              onChange={(selected) =>
                handleInputChange({
                  target: {
                    name: "contractor",
                    value: selected ? selected.value : "",
                  },
                })
              }
              styles={CSSForSelectModern}
            />
            {errors.contractor && (
              <span className="error-message">{errors.contractor}</span>
            )}
          </div>
        )}

        {!lettertype && formData.division !== "null" && (
          <div className="form-field">
            <div
              className="flex-row justify-between"
              style={{ alignItems: "center" }}
            >
              <label>
                <FileText size={14} /> Select LetterType
                <span className="required">*</span>
              </label>
              {formData.lettertype !== "null" && (
                <div className="">
                  <label className="custom-checkbox font-weight500 font-size-subheading">
                    <input
                      type="checkbox"
                      name="is_timebound"
                      checked={formData.is_timebound || false}
                      onChange={handleInputChange}
                    />
                    <span className="checkmark"></span>
                    Time Bound
                  </label>
                </div>
              )}
            </div>
            <Select
              options={lettertypeList}
              onChange={handleLetterTypeOption}
              value={
                formData.lettertype === "null" ||
                  formData.lettertype === undefined
                  ? null
                  : lettertypeList.find(
                    (option) => option.value === formData.lettertype
                  )
              }
              placeholder="Select Letter-Type"
              isSearchable
              isClearable
              noOptionsMessage={() => "No other options"}
              styles={CSSForSelectModern}
            />
            {errors.lettertype && (
              <span className="error-message">{errors.lettertype}</span>
            )}
          </div>
        )}

        {formData.lettertype === "other" && (
          <div className="form-field">
            <label>
              <FileText size={14} /> Other Letter Type Name{" "}
              <span className="required">* (only 15 Character Allowed)</span>
            </label>
            <input
              type="text"
              name="other_type_name"
              placeholder="Use Short Form"
              value={formData.other_type_name}
              onChange={handleInputChange}
              className={
                errors.other_type_name
                  ? "error"
                  : inputState.other_type_name
                    ? "success"
                    : ""
              }
            />
            {errors.other_type_name && (
              <span className="error-message">{errors.other_type_name}</span>
            )}
          </div>
        )}

        <div className="form-field">
          <label>
            <Calendar size={14} />{" "}
            {formData.letterExchange === "null"
              ? ""
              : toTitleCase(formData.letterExchange)}{" "}
            Letter Date<span className="required">*</span>
          </label>
          <input
            type="date"
            name="letter_date"
            max={today}
            value={formData.letter_date === "null" ? "" : formData.letter_date}
            onChange={handleInputChange}
            className={
              errors.letter_date
                ? "error"
                : inputState.letter_date
                  ? "success"
                  : ""
            }
          />
          {errors.letter_date && (
            <span className="error-message">{errors.letter_date}</span>
          )}
        </div>

        <div className="form-field">
          <label>
            <Clock size={14} /> Tat Duration{" "}
            <span className="required">
              {formData.is_timebound === false ? "(Read-Only)" : "*"}
            </span>
          </label>
          <input
            type="number"
            name="tat_duration"
            placeholder="Enter Tat Duration"
            value={formData.tat_duration}
            onChange={handleInputChange}
            disabled={formData.is_timebound === false}
            className={
              errors.tat_duration
                ? "error"
                : inputState.tat_duration
                  ? "success"
                  : ""
            }
          />
          {errors.tat_duration && (
            <span className="error-message">{errors.tat_duration}</span>
          )}
        </div>

        <div className="form-field">
          <label>
            <Building2 size={14} /> Letter{" "}
            {formData.letterExchange === "send" ? "To" : "From"}{" "}
            <span className="required">*</span>
          </label>
          <Select
            options={extendedLetterOptions}
            onChange={handleContractorInputChange}
            value={fromToValue}
            placeholder={
              formData.letterExchange === "send"
                ? "Select Letter To"
                : "Select Letter From"
            }
            isSearchable
            isClearable
            noOptionsMessage={() => "No other options"}
            styles={CSSForSelectModern}
          />
          {fromToError && <span className="error-message">{fromToError}</span>}
        </div>

        {formData.letterExchange === "receive" &&
          formData.letter_from === "other" ? (
          <div className="form-field">
            <label>
              <Building2 size={14} /> Other Letter From{" "}
              <span className="required">*</span>
            </label>
            <input
              type="text"
              name="other_letter_from"
              placeholder="Enter Other Letter From"
              value={formData.other_letter_from}
              onChange={handleInputChange}
              className={
                errors.other_letter_from
                  ? "error"
                  : inputState.other_letter_from
                    ? "success"
                    : ""
              }
            />
            {errors.other_letter_from && (
              <span className="error-message">{errors.other_letter_from}</span>
            )}
          </div>
        ) : formData.letterExchange === "send" &&
          formData.letter_to === "other" ? (
          <div className="form-field">
            <label>
              <Building2 size={14} /> Other Letter To{" "}
              <span className="required">*</span>
            </label>
            <input
              type="text"
              name="other_letter_to"
              placeholder="Enter Other Letter To"
              value={formData.other_letter_to}
              onChange={handleInputChange}
              className={
                errors.other_letter_to
                  ? "error"
                  : inputState.other_letter_to
                    ? "success"
                    : ""
              }
            />
            {errors.other_letter_to && (
              <span className="error-message">{errors.other_letter_to}</span>
            )}
          </div>
        ) : null}

        <div className="form-field">
          <label>
            <Activity size={14} /> Status<span className="required">*</span>
          </label>
          <Select
            options={statusOptions}
            isSearchable
            value={
              statusOptions.find((o) => o.value === formData.status) || null
            }
            onChange={(selected) =>
              handleInputChange({
                target: {
                  name: "status",
                  value: selected ? selected.value : "",
                },
              })
            }
            styles={CSSForSelectModern}
          />
          {errors.status && (
            <span className="error-message">{errors.status}</span>
          )}
        </div>

        <div className="form-field">
          <label>
            <FileText size={14} /> Remarks
          </label>
          <input
            type="text"
            name="remarks"
            maxLength={100}
            placeholder="Write only 5 words"
            value={formData.remarks}
            onChange={handleInputChange}
            className={
              errors.remarks ? "error" : inputState.remarks ? "success" : ""
            }
          />
          {errors.remarks && (
            <span className="error-message">{errors.remarks}</span>
          )}
        </div>

        <div className="form-field full-width">
          <label>
            <FileText size={14} /> Subject<span className="required">*</span>
          </label>
          <textarea
            name="subject"
            rows={2}
            placeholder="Write only the bold part in the subject of the letter...."
            value={formData.subject}
            onChange={handleInputChange}
            className={
              errors.subject ? "error" : inputState.subject ? "success" : ""
            }
          />
          {errors.subject && (
            <span className="error-message">{errors.subject}</span>
          )}
        </div>
      </div>

      <div className="section-navigation-buttons nav-buttons-wrapper">
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        <button
          type="button"
          className="btn-next"
          onClick={goToNextTab}
          disabled={tabHasMissingFields("letter")}
        >
          Next: Associated Letters <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  const renderAssociatedSection = () => (
    <div className="form-section">
      <div className="section-title">
        <Link2 size={18} />
        <h4>Associated Letters</h4>
      </div>
      <div className="form-grid">
        {formData.project !== "null" &&
          formData.lettertype !== "null" &&
          formData.workperformedby !== "null" &&
          formData.letter_date !== "null" ? (
          <div className="form-field full-width">
            <label>
              <Link2 size={14} /> Associated Letters
            </label>
            <Select
              options={options}
              isMulti
              isClearable
              placeholder="Select Associated Letters"
              value={
                Array.isArray(formData.associated_letters)
                  ? formData.associated_letters
                    .map((id) => options.find((o) => o.value === id))
                    .filter(Boolean)
                  : []
              }
              onChange={handleChangecc}
              noOptionsMessage={() => "No other options"}
              styles={CSSForSelectModern}
            />
            {errors.associated_letters && (
              <span className="error-message">{errors.associated_letters}</span>
            )}
          </div>
        ) : (
          <div className="form-field full-width">
            <span className="error-message" style={{ color: "inherit" }}>
              Fill project, letter type, matter related to and letter date in
              Letter Details to link associated letters.
            </span>
          </div>
        )}

        {formData.associated_letters &&
          formData.associated_letters.length > 0 && (
            <div className="form-field">
              <label>
                <Activity size={14} /> Update Status of Associated Letters
                <span className="required">*</span>
              </label>
              <Select
                options={assocStatusOptions}
                isSearchable
                placeholder="Select Status"
                value={
                  assocStatusOptions.find(
                    (o) => o.value === formData.associated_letters_status
                  ) || null
                }
                onChange={(selected) =>
                  handleInputChange({
                    target: {
                      name: "associated_letters_status",
                      value: selected ? selected.value : "",
                    },
                  })
                }
                styles={CSSForSelectModern}
              />
              {errors.associated_letters_status && (
                <span className="error-message">
                  {errors.associated_letters_status}
                </span>
              )}
            </div>
          )}
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
          <button type="button" className="btn-next" onClick={goToNextTab}>
            Next: Documents <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  const renderDocumentsSection = () => (
    <div className="form-section">
      <div className="section-title">
        <Paperclip size={18} />
        <h4>Documents</h4>
      </div>

      <DocumentSection
        formData={formData}
        handleDocInputChange={handleDocInputChange}
        handleAddDocuments={handleAddDocuments}
        handleAddDrawingDocuments={addNewDocument}
        drawingFormData={drawingFormData}
        setDrawingFormData={setDrawingFormData}
        handleRemoveDocument={handleRemoveDocument}
        errors={errors}
        fileNames={fileNames}
        inputState={inputState}
      />

      {uploadProgress > 0 && (
        <div className="progress-bar">
          <h6 className="uploading-percentage">Uploading {uploadProgress}%</h6>
          <div
            className="progress-bar-fill"
            style={{ width: `${uploadProgress}%` }}
          ></div>
        </div>
      )}

      <div className="form-actions">
        <button type="button" className="btn-prev" onClick={goToPreviousTab}>
          <ChevronRight size={16} className="rotate-left" /> Previous:
          Associated Letters
        </button>
        <div className="submit-buttons">
          <button type="button" className="btn-secondaryy" onClick={handleClose}>
            Cancel
          </button>
          <button
            type="submit"
            className="btn-primaryy"
            disabled={loading || documentsIncomplete() || drawingsIncomplete()}
          >
            {loading ? (
              <Loader size={18} className="spinning" />
            ) : (
              <Save size={18} />
            )}
            <span>{loading ? "Submitting..." : "Submit"}</span>
          </button>
        </div>
      </div>

      {isSubmitted && Object.keys(errors).some((k) => errors[k]) && (
        <div className="tab-error-message" style={{ marginTop: "12px" }}>
          <AlertCircle size={14} />
          <span>Please fill all mandatory fields!</span>
        </div>
      )}
    </div>
  );

  const renderCurrentSection = () => {
    switch (activeSection) {
      case "letter":
        return renderLetterSection();
      case "associated":
        return renderAssociatedSection();
      case "documents":
        return renderDocumentsSection();
      default:
        return renderLetterSection();
    }
  };

  return (
    <>
      <button
        className="clearbutton"
        title={`Add ${title} Details`}
        onClick={handleShow}
        style={{ padding: title === "Bulk Documents" && "7px" }}
      >
        <span className="transition"></span>
        <span className="gradient"></span>
        <span className="label">
          <AddwithWhiteCircle />
          {""} {title}
        </span>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="modern-project-modal"
        size="xl"
      >
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div style={{ color: "white" }}>
              <FileText size={24} />
            </div>
            <div>
              <Modal.Title>Add {title}</Modal.Title>
              <p className="header-subtitle" style={{ color: "white" }}>
                Fill in the details to add a new letter
              </p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">
          <div className="section-navigation">
            {sections.map((section) => {
              const Icon = section.icon;
              const hasMissing = tabHasMissingFields(section.id);
              return (
                <button
                  type="button"
                  key={section.id}
                  className={`section-nav-btn ${activeSection === section.id ? "active" : ""
                    } ${hasMissing && section.id !== activeSection ? "has-warning" : ""}`}
                  onClick={() => {
                    if (activeSection !== section.id) {
                      if (validateCurrentTab()) {
                        setActiveSection(section.id);
                      } else {
                        const formContainer =
                          document.querySelector(".modern-modal-body");
                        if (formContainer) formContainer.scrollTop = 0;
                      }
                    }
                  }}
                >
                  <Icon size={16} />
                  <span>{section.label}</span>
                  {hasMissing && section.id !== activeSection && (
                    <div className="warning-dot" title="Missing required fields" />
                  )}
                  {activeSection === section.id && (
                    <ChevronRight size={14} className="nav-arrow" />
                  )}
                </button>
              );
            })}
          </div>

          <form onSubmit={handleFormSubmitWrapper} className="project-form">
            {renderCurrentSection()}
          </form>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
const DashboardLetterTatTypeModel = ({ }) => {
  const [toggle, setToggle] = useState("toogle1");
  const [show, setShow] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [lettertatdata, setLettertatData] = useState([]);
  const [projectcontdata, setProjectCountData] = useState([]);
  const [toggleCompany, setToggleCompany] = useState("null");
  const [project, setProject] = useState("null");
  const handleClose = () => {
    setShow(false);
  };
  // const navigate = useNavigate();

  const [selectedLetter, setSelectedLetter] = useState(null);

  const handleRowClick = (letter) => {
    // console.log('letter', letter)
    setSelectedLetter(letter); // Store selected letter in state
    // navigate(`/admin/letterTracking`, { state: { letter } });
    // Pass state while navigating
  };

  useEffect(() => {
    getLettertatdetails();
    // console.log(toggle, 'toggle', toggle === "toogle1", lettertatdata)
    // console.log('useEffect')
  }, [toggle, project]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const getLettertatdetails = async (selectedToggle) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/letter_tat_alert_details/${project ? project : "null"
        }/`
      );

      setLettertatData(res.data);
    } catch (err) {
      console.error(err); // Handle error if needed
    }
  };

  const [filterData, setFilterData] = useState([]);

  const applyFilters = () => {
    let filteredData = lettertatdata;
    // console.log('aaa')
    if (searchQuery !== "") {
      if (toggle === "toogle1") {
        filteredData = filteredData?.filter(
          (employee) =>
            lettertatdata?.about_to_due?.letter_type.toLowerCase() ===
            searchQuery.toLowerCase()
        );
      } else {
        filteredData = filteredData?.filter(
          (employee) =>
            lettertatdata?.letter_due?.letter_type.toLowerCase() ===
            searchQuery.toLowerCase()
        );
      }
    }

    setFilterData(filteredData);
  };

  useEffect(() => {
    console.log("useffect data");
    applyFilters();
  }, [searchQuery, lettertatdata, project]);

  const handleToggleChange = (e) => {
    // console.log(e.target.value)
    setToggle(e.target.value); // Get the value of the clicked radio button
  };
  // console.log(toggle, 'toggle', toggle === "toogle1", lettertatdata)
  const [groupedData, setGroupedData] = useState({});
  const [groupedDataletterdue, setGroupedDataletterdue] = useState({});
  // useEffect(() => {
  //   console.log('groupdatas');

  //   if (lettertatdata?.about_to_due?.length > 0) {
  //     console.log('group start--------------');
  //     const grouped = {};

  //     lettertatdata.about_to_due.forEach((category) => {
  //       category.letters.forEach((letter) => {
  //         const projectName = letter.project_short_name;

  //         if (!grouped[projectName]) {
  //           grouped[projectName] = {};
  //         }

  //         const letterNum = letter.letter_num;

  //         if (!grouped[projectName][letterNum]) {
  //           grouped[projectName][letterNum] = { ...letter, count: 1 };
  //         } else {
  //           grouped[projectName][letterNum].count += 1;
  //         }
  //       });
  //     });

  //     // Convert nested object to array format
  //     const finalGrouped = Object.keys(grouped).reduce((acc, project) => {
  //       acc[project] = Object.values(grouped[project]);
  //       return acc;
  //     }, {});

  //     console.log('final', finalGrouped);
  //     setGroupedData(finalGrouped);
  //     console.log('group end--------------');
  //   }
  // }, [lettertatdata]);

  useEffect(() => {
    if (lettertatdata) {
      console.log(lettertatdata, "lettertatadata");
      const processData = (data) => {
        const grouped = {};

        data.forEach((category) => {
          category.letters.forEach((letter) => {
            const { project_short_name, site_prcode, lettertype } = letter;

            // Initialize project if not exists
            if (!grouped[site_prcode]) {
              grouped[site_prcode] = {
                site_prcode,
                project_short_name,
                project_letters: {},
              };
            }

            // Initialize letter type if not exists
            if (!grouped[site_prcode].project_letters[lettertype]) {
              grouped[site_prcode].project_letters[lettertype] = {
                letter_type: lettertype,
                letter_count: 0,
                letters: [],
              };
            }

            // Add letter to respective letter type
            grouped[site_prcode].project_letters[lettertype].letters.push(
              letter
            );
            grouped[site_prcode].project_letters[lettertype].letter_count += 1;
          });
        });

        // Convert to structured array format
        return Object.values(grouped).map((project) => ({
          ...project,
          project_letters: Object.values(project.project_letters), // Convert letter types to array
        }));
      };

      // Process 'about_to_due' category
      if (lettertatdata) {
        // Initialize empty arrays for both categories
        const aboutToDue =
          lettertatdata?.about_to_due?.length > 0
            ? processData(lettertatdata.about_to_due)
            : [];
        const letterDue =
          lettertatdata?.letter_due?.length > 0
            ? processData(lettertatdata.letter_due)
            : [];

        // Set the grouped data state
        setGroupedData({ about_to_due: aboutToDue, letter_due: letterDue });
      } else {
        // If 'lettertatdata' is undefined or null, set both categories to empty arrays
        setGroupedData({ about_to_due: [], letter_due: [] });
      }

      console.log("groupedData:after project", groupedData);
    }
  }, [lettertatdata, project]);

  const handleShow = () => {
    setShow(true);
  };
  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName="model-width80vw">
        <Modal.Header closeButton>
          <Modal.Title>Letter Tat Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex-row justify-between">
            <div className="leave-duration-tabs">
              <label htmlFor="toggle1" className="leave-tab">
                About to Due
              </label>
              <input
                type="radio"
                id="toggle1"
                name="leave-type"
                value="toogle1"
                defaultChecked
                onClick={handleToggleChange}
              />

              <label htmlFor="toggle2" className="leave-tab">
                Letter Due
                {/* <span className="leave-balance-duration">
                  :{" "}{projectcontdata?.lead_count}
                </span> */}
              </label>
              <input
                type="radio"
                id="toggle2"
                name="leave-type"
                value="toogle2"
                onClick={handleToggleChange}
              />

              <span
                className="leave-tab-glider2"
                style={{
                  left: toggle === "toogle1" ? "-35%" : "-110%",
                }}></span>
            </div>

            <div className="flex-row">
              {/* <div className="table-searchh">
                <div>
                  <SearchSmall />
                </div>
                <div>
                  <input
                    placeholder=""
                    className="navbar-inputt font-weight400 font-size-text"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </div>
              </div> */}
              <div className="letter-del">
                <Projects
                  usedFor="filter"
                  value="id"
                  toggleProject={project}
                  setToggleProject={setProject}
                  subcompany={toggleCompany}
                />
              </div>
            </div>
          </div>

          <div className="table-container">
            <table className="custom-table">
              <thead className="heading">
                <tr className="custom-table-head-tr global-table-tr">
                  <th className="table-heading-text">Sno.</th>
                  <th className="table-heading-text">Project Name</th>
                  <th className="table-heading-text">Letter Type</th>
                  <th className="table-heading-text">Letter Count</th>
                  <th className="table-heading-text">Letter Details</th>
                </tr>
              </thead>
              <tbody>
                {toggle === "toogle1" &&
                  groupedData?.about_to_due?.map((project, index) => (
                    <React.Fragment key={project.site_prcode}>
                      {/* Project Row */}
                      <tr
                        className="project-header"
                        style={{ borderTop: "1px solid black" }}>
                        <td
                          className="table-bodyy"
                          style={{ fontSize: "12px" }}>
                          {index + 1}
                        </td>
                        <td className="table-bodyy">
                          <strong className="tat-table">
                            {project.project_short_name} ({project.site_prcode})
                          </strong>
                        </td>
                      </tr>

                      {/* Loop through letter types */}
                      {project.project_letters?.map((letterGroup) => (
                        <React.Fragment key={letterGroup.letter_type}>
                          {/* Letter Type Row */}
                          <tr className="letter-type-header">
                            <td className="table-bodyy"></td>
                            <td className="table-bodyy"></td>
                            <td className="table-bodyy">
                              <strong className="tat-table">
                                {letterGroup.letter_type}
                              </strong>
                            </td>
                            <td className="table-bodyy">
                              <strong className="tat-table">
                                {letterGroup.letter_count}
                              </strong>
                            </td>
                            <td className="table-bodyy">
                              {letterGroup.letters?.map(
                                (letter, letterIndex) => (
                                  <React.Fragment key={letter.id}>
                                    {/* Letter Details Row */}
                                    <tr className="custom-table-head-td global-table-td">
                                      <td className="table-bodyy">
                                        <table className="nested-table">
                                          <thead>
                                            <tr>
                                              <th>Letter Number</th>
                                              <th>Letter Date</th>
                                              <th>Assigned TAT Days</th>
                                              <th>Elapsed Days</th>
                                              <th>Exceeded By</th>
                                              <th>Alert</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr style={{ cursor: "pointer" }}>
                                              <td
                                                onClick={() =>
                                                  handleRowClick(
                                                    letter.letter_num
                                                  )
                                                }>
                                                {letter.letter_num}
                                              </td>
                                              <td>{letter.letter_date}</td>
                                              <td>
                                                {letter.assigned_tat_days}
                                              </td>
                                              <td>{letter.elapsed_days}</td>
                                              <td
                                                className={
                                                  parseFloat(
                                                    letter.exceeded_by
                                                  ) > 0
                                                    ? "error-alert"
                                                    : ""
                                                }>
                                                {letter.exceeded_by}
                                              </td>
                                              <td>{letter.alert}</td>
                                            </tr>

                                            {/* Show sub-letter types if they exist */}
                                            {letter.sub_letter_types?.map(
                                              (subLetter, subIndex) => (
                                                <tr
                                                  key={subIndex}
                                                  className="sub-letter-row">
                                                  <td colSpan="2">
                                                    <strong>
                                                      Sub Letter Type:
                                                    </strong>{" "}
                                                    {subLetter.lettertype}
                                                  </td>
                                                  <td>
                                                    {subLetter.letter_num}
                                                  </td>
                                                  <td>
                                                    {subLetter.letter_date}
                                                  </td>
                                                  <td>
                                                    {
                                                      subLetter.assigned_tat_days
                                                    }
                                                  </td>
                                                  <td>
                                                    {subLetter.elapsed_days}
                                                  </td>
                                                  <td
                                                    className={
                                                      parseFloat(
                                                        subLetter.exceeded_by
                                                      ) > 0
                                                        ? "error-alert"
                                                        : ""
                                                    }>
                                                    {subLetter.exceeded_by}
                                                  </td>
                                                  <td>{subLetter.alert}</td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                )
                              )}
                            </td>
                          </tr>

                          {/* Loop through letters under this letter type */}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ))}

                {toggle === "toogle2" &&
                  groupedDataletterdue?.letter_due?.map((project, index) => (
                    <React.Fragment key={project.site_prcode}>
                      {/* Project Row */}
                      <tr
                        className="project-header"
                        style={{ borderTop: "1px solid black" }}>
                        <td
                          className="table-bodyy"
                          style={{ fontSize: "12px" }}>
                          {index + 1}
                        </td>
                        <td className="table-bodyy">
                          <strong className="tat-table">
                            {project.project_short_name} ({project.site_prcode})
                          </strong>
                        </td>
                      </tr>

                      {/* Loop through letter types */}
                      {project.project_letters?.map((letterGroup) => (
                        <React.Fragment key={letterGroup.letter_type}>
                          {/* Letter Type Row */}
                          <tr className="letter-type-header">
                            <td className="table-bodyy"></td>
                            <td className="table-bodyy"></td>
                            <td className="table-bodyy">
                              <strong className="tat-table">
                                {letterGroup.letter_type}
                              </strong>
                            </td>
                            <td className="table-bodyy">
                              <strong className="tat-table">
                                {letterGroup.letter_count}
                              </strong>
                            </td>
                            <td className="table-bodyy">
                              {letterGroup.letters?.map(
                                (letter, letterIndex) => (
                                  <React.Fragment key={letter.id}>
                                    {/* Letter Details Row */}
                                    <tr className="custom-table-head-td global-table-td">
                                      <td className="table-bodyy">
                                        <table className="nested-table">
                                          <thead>
                                            <tr>
                                              <th>Letter Number</th>
                                              <th>Letter Date</th>
                                              <th>Assigned TAT Days</th>
                                              <th>Elapsed Days</th>
                                              <th>Exceeded By</th>
                                              <th>Alert</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr style={{ cursor: "pointer" }}>
                                              <td
                                                onClick={() =>
                                                  handleRowClick(
                                                    letter.letter_num
                                                  )
                                                }>
                                                {letter.letter_num}
                                              </td>
                                              <td>{letter.letter_date}</td>
                                              <td>
                                                {letter.assigned_tat_days}
                                              </td>
                                              <td>{letter.elapsed_days}</td>
                                              <td
                                                className={
                                                  parseFloat(
                                                    letter.exceeded_by
                                                  ) > 0
                                                    ? "error-alert"
                                                    : ""
                                                }>
                                                {letter.exceeded_by}
                                              </td>
                                              <td>{letter.alert}</td>
                                            </tr>

                                            {/* Show sub-letter types if they exist */}
                                            {letter.sub_letter_types?.map(
                                              (subLetter, subIndex) => (
                                                <tr
                                                  key={subIndex}
                                                  className="sub-letter-row">
                                                  <td colSpan="2">
                                                    <strong>
                                                      Sub Letter Type:
                                                    </strong>{" "}
                                                    {subLetter.lettertype}
                                                  </td>
                                                  <td>
                                                    {subLetter.letter_num}
                                                  </td>
                                                  <td>
                                                    {subLetter.letter_date}
                                                  </td>
                                                  <td>
                                                    {
                                                      subLetter.assigned_tat_days
                                                    }
                                                  </td>
                                                  <td>
                                                    {subLetter.elapsed_days}
                                                  </td>
                                                  <td
                                                    className={
                                                      parseFloat(
                                                        subLetter.exceeded_by
                                                      ) > 0
                                                        ? "error-alert"
                                                        : ""
                                                    }>
                                                    {subLetter.exceeded_by}
                                                  </td>
                                                  <td>{subLetter.alert}</td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                )
                              )}
                            </td>
                          </tr>

                          {/* Loop through letters under this letter type */}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const LetterTracking = () => {
  const tableRef = useRef(null);
  const siteSubCompany = sessionStorage.getItem("sitemanagement_project_sub_company");
  const [toggleCompany, setToggleCompany] = useState(siteSubCompany || "null");

  const [toggleAe, setToggleAe] = useState("null");
  const { PERMISSION_AUTHORITY, projectID } = usePermission();
  const siteRole = sessionStorage.getItem("sitemanagement_role");

  const [project, setProject] = useState(projectID ? projectID : "null");
  const [contractorid, setContractorId] = useState("null");
  const [coordinatorId, setCoordinatorId] = useState("null");

  const [Letter_number, setLetter_number] = useState("null");

  const [workperformedby, setWorkperformedby] = useState("null");

  const [lettertype, setLetterType] = useState("null");

  const role = sessionStorage.getItem("sitemanagement_role");
  const [resultData, setResultdata] = useState("");

  const [projectList, setProjectList] = useState([]);
  const [projectbyID, setProjectByID] = useState([]);

  const [filteredData, setFilteredData] = useState([]);
  const [excelData, setExcelData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusExchnage, SetStatusexchange] = useState("null");
  const [selectDate, setSelectDate] = useState("null");
  const [selectedNo, setNo] = useState("");
  const [selectedFromDate, setFromDate] = useState(null);
  const [selectedToDate, setToDate] = useState(null);
  const [selectedFromcreatedat, setFromcreatedat] = useState(null);
  const [selectedToCreatedAt, setToCreatedAt] = useState(null);
  const [selectedLetterStatus, setLetterStatus] = useState("null");
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const [aeList, setAeList] = useState([]);
  const [trackRecordList, setTrackRecordList] = useState([]);


  const [buffer, setBuffering] = useState(true); //buffering logic
  const [animation1, setAnimation1] = useState(true);

  const [pendingLetters, setPendingLetters] = useState(0);

  const getProjectById = async () => {
    setBuffering(true);
    try {
      const project = await axios.get(
        `${BASE_URL}/siteproject/projectbyid/${projectID}/`
      );
      setProjectByID(project.data);
    } catch (error) { }
  };

  const [createdQuickFilter, setCreatedQuickFilter] = useState("none");

  useEffect(() => {
    if (createdQuickFilter === "none") return;

    let today = new Date();
    let from;

    if (createdQuickFilter === "today") {
      from = new Date(today);
    }
    else if (createdQuickFilter === "last_day") {
      from = new Date(today);
      from.setDate(today.getDate() - 1);
    }
    else if (createdQuickFilter === "week") {
      from = new Date(today);
      from.setDate(today.getDate() - 7);
    }
    else if (createdQuickFilter === "month") {
      from = new Date(today);
      from.setMonth(today.getMonth() - 1);
    }

    if (createdQuickFilter !== "Select Month") {
      const fromDate = from.toISOString().slice(0, 10);
      const toDate = today.toISOString().slice(0, 10);

      setFromcreatedat(fromDate);
      setToCreatedAt(toDate);
    }



  }, [createdQuickFilter]);



  useEffect(() => {
    if (projectID) {
      getProjectById();
    } else {
      getProjects();
    }
  }, [projectID, toggleCompany]);

  function calculateDaysBetweenDates(targetDate) {
    if (!targetDate) return "-";

    const today = new Date();
    const givenDate = new Date(targetDate);

    // Remove time portion for accurate difference
    today.setHours(0, 0, 0, 0);
    givenDate.setHours(0, 0, 0, 0);

    const diffTime = Math.abs(givenDate.getTime() - today.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  const [letterData, setLetterData] = useState([]);


  const getProjects = async () => {
    // setBuffering(true); //buffering logic // Start Buffering
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
      // const pro = await axios.get(`${BASE_URL}/siteproject/projectfilterbysubcompany/${toggleCompany}/`);
      const pro = await axios.get(
        sessionStorage.getItem("sitemanagement_role") === "AuthorityEngineer"
          ? `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem(
            "sitemanagement_emp_id"
          )}/${toggleCompany}/null/null/`
          : sessionStorage.getItem("sitemanagement_role") ===
            "DataEntryOperator"
            ? `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${toggleAe}/null/${sessionStorage.getItem(
              "sitemanagement_emp_id"
            )}/null/`
            : `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${toggleAe}/${toggleCompany}/null/null/`
      );
      const sortedList = sortProjects(pro.data, "site_prcode");
      setProjectList(sortedList);

      // const res = await axios.get(`${BASE_URL}/siteproject/letterrecord/`);
      // setTrackRecordList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    getProjects();
  }, [toggleAe, toggleCompany]);

  const getAeList = async () => {
    try {
      const sub = await axios.get(
        `${BASE_URL}/siteproject/employeefilterbyproject/null/${toggleCompany}/`
      );
      setAeList(sub.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // setBuffering(false);// End Buffering
    }
  };

  console.log(projectList);

  useEffect(() => {
    applyFilters();
  }, [selectedNo, trackRecordList]);

  useEffect(() => {
    getAeList();
  }, [toggleCompany]);

  const applyFilters = () => {
    let filteredData = trackRecordList;

    if (selectedNo !== "") {
      const lowercaseSelectedName = selectedNo.toLowerCase();

      filteredData = filteredData?.filter((employee) => {
        if (!employee || !employee.letter_num) {
          console.log(
            "Skipping undefined or missing letter_num for employee:",
            employee
          );
        }

        const lid =
          employee?.letter_num
            .toString()
            ?.toLowerCase()
            .includes(lowercaseSelectedName) ||
          employee?.subject?.toLowerCase()?.includes(lowercaseSelectedName) ||
          employee?.remarks?.toLowerCase()?.includes(lowercaseSelectedName);
        return lid;
      });
    }
    console.log(">>>>>>>>>>>>>>>>>>>>>>filteredData1-", filteredData);
    setFilteredData(filteredData);
  };
  console.log(">>>>>>>>>>>>>>>>>>>>>>filteredDataout2-", filteredData);

  const location = useLocation();
  const letter = location.state?.letter;
  console.log("letter", location.state);

  const rowRefs = useRef([]);

  useEffect(() => {
    if (letter && filteredData.length > 0) {
      const matchingIndex = filteredData.findIndex(
        (item) => item.project === letter.project
      );

      if (matchingIndex !== -1 && rowRefs.current[matchingIndex]) {
        rowRefs.current[matchingIndex].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [letter, filteredData]);

  const itemsPerPage = 50; // Fixed items per page
  const [currentPage, setCurrentPage] = useState(1);
  const [pageData, setPageData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const [pendencys, setPendencys] = useState({});

  useEffect(() => {
    const newTotalPages = Math.ceil(resultData / itemsPerPage);
    setTotalPages(newTotalPages);
  }, [resultData]);

  console.log("filteredData.length");
  console.log(filteredData.length);
  useEffect(() => {
    const newTotalPages = Math.ceil(resultData / itemsPerPage);

    // Optional: reset only if filteredData shrinks AND page is now invalid
    if (currentPage > newTotalPages && newTotalPages > 0) {
      setTotalPages(newTotalPages);
    }
  }, [filteredData]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    // Scroll to top of table when page changes
    if (tableRef && tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const renderPaginationButtons = () => {
    const buttons = [];

    // Always show first page
    buttons.push(
      <button
        key="first"
        className={`pagination-button ${currentPage === 1 ? "active" : ""}`}
        onClick={() => handlePageChange(1)}>
        1
      </button>
    );

    if (totalPages > 7) {
      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      if (currentPage <= 3) {
        // Near start, show 2,3,4
        startPage = 2;
        endPage = 4;
      } else if (currentPage >= totalPages - 2) {
        // Near end, show last 3 pages before the final page
        startPage = totalPages - 3;
        endPage = totalPages - 1;
      }

      // Show ellipsis before middle range if needed
      if (startPage > 2) {
        buttons.push(
          <span key="ellipsis1" className="pagination-ellipsis">
            ...
          </span>
        );
      }

      // Add middle range
      for (let i = startPage; i <= endPage; i++) {
        buttons.push(
          <button
            key={i}
            className={`pagination-button ${currentPage === i ? "active" : ""}`}
            onClick={() => handlePageChange(i)}>
            {i}
          </button>
        );
      }

      // Show ellipsis after middle range if needed
      if (endPage < totalPages - 1) {
        buttons.push(
          <span key="ellipsis2" className="pagination-ellipsis">
            ...
          </span>
        );
      }

      // Always show last page
      buttons.push(
        <button
          key="last"
          className={`pagination-button ${currentPage === totalPages ? "active" : ""
            }`}
          onClick={() => handlePageChange(totalPages)}>
          {totalPages}
        </button>
      );
    } else {
      // Less than 7 pages, show all page buttons
      for (let i = 2; i <= totalPages; i++) {
        buttons.push(
          <button
            key={i}
            className={`pagination-button ${currentPage === i ? "active" : ""}`}
            onClick={() => handlePageChange(i)}>
            {i}
          </button>
        );
      }
    }

    return buttons;
  };

  const UserID = sessionStorage.getItem("sitemanagement_emp_id");
  const [letterTypeCounts, setLetterTypeCounts] = useState();
  const [bufferingLetter, setBufferingLetter] = useState(false);
  const [categoryCounts, setCategoryCounts] = useState({});
  const [loadings, setLoadings] = useState(false);
  const getLetters = async () => {
    setBufferingLetter(true);
    try {




      const res = await axios.get(
        `${BASE_URL}/siteproject/letterrecordtable/page${currentPage}/${itemsPerPage}/${showFilters.letterstatus}/${showFilters.fromDate}/${showFilters.todate}/${showFilters.letter_num}/${showFilters.project}/${showFilters.matterRelatedTo}/${showFilters.letterType}/null/null/${showFilters.contractorName}/null/${showFilters.toggleAe}/${role === "DataEntryOperator" ? UserID : showFilters.coordinator_name}/${showFilters.ExchangeType}/${showFilters.fromAddDate}/${showFilters.toAddDate}/${toggleCompany}/null/null/`
      );
      setResultdata(res.data.count);
      setLetterTypeCounts(res.data.letter_type_counts);
      setCategoryCounts(res.data.category_counts);
      setLoadings(false);
      // Apply filters on API page data directly
      let filtered = res.data.results;

      if (selectedNo) {
        const lowercaseSelectedName = selectedNo.toLowerCase();
        filtered = filtered.filter(
          (item) =>
            item?.letter_num
              ?.toString()
              ?.toLowerCase()
              .includes(lowercaseSelectedName) ||
            item?.subject?.toLowerCase().includes(lowercaseSelectedName) ||
            item?.remarks?.toLowerCase().includes(lowercaseSelectedName)
        );
      }

      if (statusExchnage) {
        const lowercaseStatus = statusExchnage.toLowerCase();
        filtered = filtered.filter((item) =>
          item?.letterExchange?.toLowerCase()?.includes(lowercaseStatus)
        );
      }

      const pendingLetters = Object.values(res.data.letter_type_counts).reduce(
        (sum, value) => sum + value,
        0
      );

      setPendingLetters(pendingLetters);

      setPendencys(res.data.letter_type_counts);

      console.log(">>>>>>>>>>>>>>>>>>>>>>filteredData5-", filtered);
      setFilteredData(filtered); // Use filtered data directly
      setExcelData(res.data.results);
      setTrackRecordList(res.data.results); // Keep unfiltered for reference if needed
    } catch (error) {
      handleErrorToast(error);
    } finally {
      setAnimation1(false);
      setBufferingLetter(false)
    }
  };

  const [showFilters, setShowFilters] = useState({
    project: projectID ? projectID : "null",
    company: "null",
    toggleAe: "null",
    letterType: "null",
    ExchangeType: "null",
    matterRelatedTo: "null",
    contractorName: "null",
    letterstatus: "null",
    coordinator_name: "null",
    fromDate: null,
    todate: null,
    fromAddDate: null,
    toAddDate: null,
    letter_num: "null"
  });

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (show === true) {
      getLetters();
      setShow(false);
    }
  }, [show]);




  const handleShowFilters = () => {
    setShowFilters((prevState) => ({
      ...prevState,
      project: project,
      company: toggleCompany,
      toggleAe: toggleAe,
      letterType: lettertype,
      ExchangeType: statusExchnage,
      matterRelatedTo: workperformedby,
      contractorName: contractorid,
      letterstatus: selectedLetterStatus,
      coordinator_name: coordinatorId,
      fromDate: selectedFromDate,
      todate: selectedToDate,
      fromAddDate: selectedFromcreatedat,
      toAddDate: selectedToCreatedAt,
      letter_num: Letter_number
    }))

    setShow(true);
    setDefaultData(false);
  }

  useEffect(() => {

    setShowFilters((prevState) => ({
      ...prevState,
      project: project
    }))

  }, [project])





  const [showdefaultData, setDefaultData] = useState(false);
  const handleClearAllFilter = () => {
    setLetterType("null");
    setLetterStatus("null");
    setFromDate("null");
    setToDate("null");
    setProject("null");
    setWorkperformedby("null");
    setToggleCompany("null");
    setNo("");
    SetStatusexchange("null");
    setToggleAe("null");

    setDefaultData(true);
  };
  useEffect(() => {
    setDefaultData(true);

    getLetters();

  }, [showdefaultData, currentPage, itemsPerPage])

  console.log(showdefaultData, "showdefaultData")
  const handleStatusCardClick = (e) => {
    setLoadings(true);
    setLetterType(e);
    setExpanded(true);
  };

  const handleClosee = () => {
    setLetterType("null")
    setExpanded(false);

  }

  const [expanded, setExpanded] = useState(false);
  const handleExpandOpen = () => {
    setExpanded(true);
  }
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [showAdvanced, SetShowAdvanced] = useState(false);
  // *******************************Letter Type And Division Functionality*****************************//

  const [lettertypelist, setLettertypeList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [toggleStatus, setToggleStatus] = useState(siteSubCompany === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ? "48cb62b4-9b60-4305-b6b4-b9da5d1baaf5" : "59408e4e-a455-46b6-b3db-8deaa0ae4475");
  // 0b6fa5d0-6de9-459b-b2c5-4a799c309713

  const getDivision = async () => {
    setBuffering(true); // Start Buffering
    let url;
    try {
      url = `${BASE_URL}/siteproject/divisionfilter/${toggleCompany}/`;

      const sub = await axios.get(url);

      setDivisionList(sub.data);
    } catch (err) {
      handleErrorToast(err); // Toast Logic
    } finally {
      setBuffering(false); // End Buffering
    }
  };
  const getLetterTypeData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/LetterHeadingfilter/${toggleStatus}/`
      );
      setLettertypeList(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const [projectListdata, setProjectListdata] = useState([]);

  const getfilterdata = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/projectfiltered/`
      );
      setProjectListdata(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getDivision();
  }, []);
  useEffect(() => {
    getfilterdata();
  }, []);
  const [project_short_name, setProjectShortname] = useState("null");
  const [pr_code, setprcode] = useState("null");
  const [AUTHORITY_NAME, setAuthorityName] = useState("null");

  useEffect(() => {
    const filterproject = projectListdata.filter(i => i.id === project);

    if (filterproject.length > 0) {
      setProjectShortname(filterproject[0].project_short_name);
      setprcode(filterproject[0].site_prcode);
      setAuthorityName(filterproject[0].authority_engineer_name);
    } else {
      // Optional: Reset or handle not-found case
      setProjectShortname(null);
      setprcode(null);
      setAuthorityName(null);
    }
  }, [project, projectListdata]);


  useEffect(() => {
    getLetterTypeData();
  }, [toggleStatus]);

  const LetterTypeOptions = lettertypelist
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((i) => ({
      value: i.name,
      label: i.name,
      work_performed_by: i.work_performed_by
    }));
  const extendedLetterTypeOptions = [
    ...LetterTypeOptions,
    { label: "Other", value: "other", work_performed_by: "For Both" },
  ];

  const handleLetterTypeOption = (selectedOption) => {
    if (!selectedOption) {
      setLetterType("null");
    } else {
      setLetterType(selectedOption.value);
    }
  };

  // **************************End of Functionality*************************//

  const [aeName, setAeName] = useState("null");

  const handleAeChange = (e) => {
    const selectedId = e.target.value;
    const selectedOption = aeList.authority_engineers?.find(
      (ae) => ae.id === selectedId
    );

    setToggleAe(selectedId);
    setAeName(selectedOption?.name || "");
  };

  console.log("toggleAe");
  console.log(toggleAe);
  console.log("toggleAe");
  console.log(aeName);
  console.log(pendencys, "pendencys");

  const sortingTableRef = useRef();

  const handleButtonClick = () => {
    if (sortingTableRef.current) {
      sortingTableRef.current.exportToExcel();
    }
  };


  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");

  useEffect(() => {
    if (!selectedMonth || !selectedYear) return;

    const monthNum = Number(selectedMonth);

    const firstDay = `${selectedYear}-${selectedMonth}-01`;

    const lastDateObj = new Date(selectedYear, monthNum, 0);

    const yyyy = lastDateObj.getFullYear();
    const mm = String(lastDateObj.getMonth() + 1).padStart(2, "0");
    const dd = String(lastDateObj.getDate()).padStart(2, "0");

    const lastDay = `${yyyy}-${mm}-${dd}`;

    setFromcreatedat(firstDay);
    setToCreatedAt(lastDay);
  }, [selectedMonth, selectedYear]);



  const currentYear = new Date().getFullYear();
  const yearOptions = [];

  for (let y = 2017; y <= currentYear; y++) {
    yearOptions.push({ value: y.toString(), label: y.toString() });
  }

  yearOptions.reverse();



  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" }
  ];


  const monthOptions = months.map((m) => ({
    value: m.value,
    label: `Letter added on ${m.label}`,
  }));

  const quickFilters = [
    { value: "none", label: "Letter added filter" },
    { value: "today", label: "Letter added today" },
    { value: "last_day", label: "Letter added last day" },
    { value: "week", label: "Letter added a Week Ago" },
    { value: "month", label: "Letter added a month ago" },
    { value: "Select Month", label: "Letter added for selected month" }
  ];


  const getLetterTat = async () => {
    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/siteproject/tatdurationfilter/${toggleStatus}/`);
      setLetterData(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getLetterTat();
  }, [toggleStatus]);


  useEffect(() => {
    if (createdQuickFilter === "none") {
      setFromcreatedat("null");
      setToCreatedAt("null");
    }
  }, [createdQuickFilter]);

  return (
    <>
      <Dashboardnavbar name={"Letter Tracking"} url="Letter Tracking" />
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="content-tabs">
        <div className="attendance-history-cont">
          <>
            <div>
              <div className="attendance-heading  font-weight500    font-size-heading">
                {" "}
              </div>
              <div className="attendance-subcontainer">
                <div className="field-cont" style={{ width: "100%" }}>
                  {role !== "SiteManagement" ? (
                    <>
                      {/* {siteSubCompany !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" &&
                        <div title="Company Filter" className="field-cont-div">
                          <SubCompany toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} />
                        </div>
                      } */}
                      <div title="Division Filter" className="field-cont-div">
                        <CircularGrid />
                        <select
                          onChange={(e) => setToggleStatus(e.target.value)}
                          style={{ cursor: 'pointer' }}
                          value={toggleStatus}
                          className="attendance-input-field width-10vw   date-field"
                        >
                          <option value="null">Select Division</option>
                          {divisionList.map((company) => (
                            <option value={company.id}>{company.name}</option>
                          ))}
                          ;
                        </select>

                        <hr className="field-cont-hr" />
                      </div>
                    </>


                  ) : null}


                  {siteRole === "SiteManagement" ? (
                    ""
                  ) : (
                    <Projects
                      usedFor="filter"
                      value="id"
                      toggleProject={project}
                      setToggleProject={setProject}
                      subcompany={toggleCompany}
                      authority={toggleAe}
                    />
                  )}
                  {role === "AuthorityEngineer" || role === "SiteManagement" ? (
                    ""
                  ) : (
                    <div title="Ae Filter" className="field-cont-div">
                      <Authority />
                      <select
                        onChange={handleAeChange}
                        style={{ cursor: "pointer" }}
                        value={toggleAe}
                        className="attendance-input-field   date-field"
                      >
                        <option value="null">Authority Engineer</option>
                        {aeList.filter(i => i.emp_role === "AuthorityEngineer").map((authority) => (
                          <option value={authority.id}>{authority.name}</option>
                        ))}
                        ;
                      </select>

                      <hr className="field-cont-hr" />
                    </div>
                  )}

                  <ContractorFilter
                    toggleContractor={contractorid}
                    settoggleContractor={setContractorId}
                    project={project}
                    value="id"
                    subcompany={toggleCompany}
                  />
                  <div title="Status Filter" className="field-cont-div">
                    <Status />
                    <select
                      id="status"
                      name="status"
                      placeholder="Status"
                      value={selectedLetterStatus}
                      style={{ cursor: "pointer" }}
                      onChange={(e) => setLetterStatus(e.target.value)}
                      className={`attendance-input-field `}>
                      <option value="null">All</option>
                      <option value="pending">Pending</option>

                      <option value="close">Close</option>
                    </select>
                    <hr className="field-cont-hr" />
                  </div>
                  <CoordinatorFilter
                    toggleCoordinator={coordinatorId}
                    settoggleCoordinator={setCoordinatorId}
                    value="id"
                    subcompany={toggleCompany}

                  />

                  <LetterType
                    setLetterType={setLetterType}
                    lettertype={lettertype}
                    LetterTypeOptions={extendedLetterTypeOptions}
                    handleChange={handleLetterTypeOption}
                  />
                  <div title="Exchange Type" className="field-cont-div">
                    <ExchangeTypee />
                    <select
                      onChange={(e) => SetStatusexchange(e.target.value)}
                      value={statusExchnage}
                      style={{ cursor: "pointer" }}
                      className="attendance-input-field   date-field">
                      <option value="null">Exchange Type</option>
                      <option value="receive">Recieve</option>
                      <option value="send">Send</option>
                    </select>

                    <hr className="field-cont-hr" />
                  </div>

                  <div title="Matter Related To" className="field-cont-div">
                    <CircularGrid />
                    <select
                      onChange={(e) => setWorkperformedby(e.target.value)}
                      value={workperformedby}
                      style={{ cursor: "pointer" }}
                      className="attendance-input-field   date-field"
                    // className="dropdown font-size-subheading  "
                    >
                      <option className="" value="null">
                        Matter Related To
                      </option>
                      <option value="contractor">Contractor</option>
                      <option value="consultant">Consultant</option>
                    </select>

                    <hr className="field-cont-hr" />
                  </div>



                  <LetterNumberFilter
                    toggleLetter={Letter_number}
                    settoggleLetter={setLetter_number}
                    project={project}
                    workperformedby={workperformedby}
                    lettertype={lettertype}
                    status={selectedLetterStatus}
                    value="id"
                    subCompany={toggleCompany}
                  />


                  <div title="Date Type" className="field-cont-div">
                    <CircularGrid />
                    <select
                      onChange={(e) => setSelectDate(e.target.value)}
                      value={selectDate}
                      style={{ cursor: "pointer" }}
                      className="attendance-input-field   date-field">
                      <option value="">Select Date Filter</option>
                      <option value="letterDate">Letter Date</option>
                    </select>

                    <hr className="field-cont-hr" />
                  </div>
                  {selectDate === "letterDate" ?
                    <>
                      <div title="Date Range Filter" className="field-cont-div">
                        <Year />

                        <DateRangePicker
                          startDate={selectedFromDate}
                          endDate={selectedToDate}
                          placeHolder1="From Date"
                          placeHolder2="To Date"
                          onChange={(start, end) => {
                            setFromDate(start);
                            setToDate(end);
                          }}
                        />

                      </div>

                    </>


                    : ""
                  }

                  <div className="field-cont-div ">
                    <div className="field-cont-div">
                      <CircularGrid />

                      <Select
                        options={quickFilters}
                        value={quickFilters.find((q) => q.value === createdQuickFilter)}
                        onChange={(selected) => setCreatedQuickFilter(selected.value)}
                        placeholder="Letter added filter"
                        isSearchable={true}
                        styles={CSSForFilterDropdown}
                        className="attendance-input-field  date-field"
                        style={{ cursor: 'pointer' }}
                      />
                      <hr className="field-cont-hr" />

                    </div>
                    {createdQuickFilter === "Select Month" &&
                      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                        <div className="field-cont-div">
                          <CircularGrid />

                          <Select
                            options={monthOptions}
                            value={monthOptions.find((opt) => opt.value === selectedMonth) || null}
                            onChange={(opt) => setSelectedMonth(opt.value)}
                            placeholder="Select Month"
                            isSearchable={true}
                            styles={CSSForFilterDropdown}
                            className="attendance-input-field  date-field"
                            style={{ cursor: 'pointer' }}
                          />
                          <hr className="field-cont-hr" />

                        </div>

                        <div className="field-cont-div">
                          <CircularGrid />

                          <Select
                            options={yearOptions}
                            value={yearOptions.find(y => y.value === selectedYear)}
                            onChange={(e) => setSelectedYear(e.value)}
                            placeholder="Select Year"
                            isSearchable={true}
                            styles={CSSForFilterDropdown}
                            className="attendance-input-field  date-field"
                            style={{ cursor: 'pointer' }}

                          />
                          <hr className="field-cont-hr" />

                        </div>

                      </div>
                    }
                  </div>






                  <div style={{ display: "flex", justifyContent: 'space-between', width: "8vw" }}>









                  </div>
                </div>

              </div>
            </div>


            <div className="filter-showing flex-row justify-between">
              <div style={{ fontsSize: "18px", fontWeight: 500 }}>
                <button
                  onClick={() => SetShowAdvanced(!showAdvanced)}
                  style={{ color: "#2576bc" }}>
                  {!showAdvanced
                    ? "▲ Show Advanced Stats"
                    : "▼ Hide Advanced Stats"}
                </button>
              </div>

              <div className="flex-row justify-between" style={{ width: "75%" }}>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    alignItems: "center",
                  }}
                >
                  {
                    role !== "ViewAccess" &&

                    <>




                      {siteRole === "BD" ? (
                        ""
                      ) : (
                        <>
                          {/* <AddTrackRecordDetails getProjects={getLetters} projectList={projectList} projectId={project} title={"Letters"} /> */}
                          <AddLetterLinked
                            letterData={letterData}
                            getProjects={getLetters}
                            projectList={projectList}
                            toggleAE={toggleAe}
                            projectId={project}
                            title={"Letters"}
                            letterTypeList={lettertypelist}
                            LetterTypeOptions={extendedLetterTypeOptions}
                          />
                          {siteRole === "Admin" &&
                            <>
                              <DownloadAllLetters project={project}
                                letter_status={selectedLetterStatus}
                                fromDate={selectedFromDate}
                                toDate={selectedToDate}
                                letterFrom="null"
                                letterTo='null'
                                letter_num={Letter_number}
                                workperformedby={workperformedby}
                                letter_type={lettertype}
                                letterExchange={statusExchnage}
                                authority={toggleAe}
                                created_from={selectedFromcreatedat}
                                created_to={selectedToCreatedAt}
                                contractor={contractorid}
                                coordinator={coordinatorId}
                                subCompany={toggleCompany}

                              />

                            </>
                          }



                        </>
                      )}

                      <UploadLetterBulk
                        getLetters={getLetters}
                        site_prcode={projectbyID.site_prcode}
                      />

                      <DashboardLetterTatTypeModel project={project} />
                    </>

                  }

                  {
                    role !== "ViewAccess" && role !== "SiteManagement" &&
                    <DocumentModel projectsList={projectList} title="Bulk Documents" getDocument={getLetters} />
                  }
                  <button
                    className="clearbutton"
                    onClick={handleClearAllFilter}
                    style={{
                      padding: "10px"
                    }}
                  >
                    <span className="transition"></span>
                    <span className="gradient"></span>
                    <span className="label">Clear All</span>
                  </button>
                  <button
                    className="clearbutton"
                    onClick={handleShowFilters}
                    style={{
                      padding: "10px"
                    }}
                  >
                    <span className="transition"></span>
                    <span className="gradient"></span>
                    <span className="label">Show Data</span>
                  </button>
                </div>


                {isOverflowing && (

                  <div
                    className="toggle-button-status-card"
                    style={{ marginLeft: "20px" }}
                    onClick={handleExpandOpen}>
                    {expanded ? "▲ Collapse" : "▼ Expand"}
                  </div>
                )}
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    marginLeft: "auto",
                    display: "flex",
                    gap: "20px",
                  }}>
                  {siteRole === "Admin" && (
                    <div
                      className="toggle-button-status-card"
                      style={{ marginLeft: "20px" }}>
                      {" "}

                    </div>
                  )}
                  Showing{" "}
                  {Math.min((currentPage - 1) * itemsPerPage + 1, resultData)} -{" "}
                  {Math.min(currentPage * itemsPerPage, resultData)} of{" "}
                  {resultData} records
                </div>
              </div>


            </div>

            <div
              className="category-counts-box flex-row justify-between"
              style={{ position: "relative" }}
            >
              <div className="category-grid" style={{ width: "80%" }}>
                {/* <div className="category-item non-timebound">
                  <span>Non-Timebound:</span>
                  <span>{categoryCounts?.non_timebound}</span>
                </div>
                <div className="category-item newly-added">
                  <span>Newly Added:</span>
                  <span>{categoryCounts?.newly_added}</span>
                </div>
                <div className="category-item due-soon">
                  <span>Due in Next 3 Days:</span>
                  <span>{categoryCounts?.due_in_next_3_days}</span>
                </div>
                <div className="category-item overdue">
                  <span>Overdue:</span>
                  <span>{categoryCounts?.overdue}</span>
                </div> */}

                {siteSubCompany !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" &&
                  <>
                    <div className="overdue flex-row" style={{ width: "20%" }}>
                      {/* <StatusBar
                        isOverflowing={isOverflowing}
                        expanded={expanded}
                        closemodal={handleClosee}
                        setIsOverflowing={setIsOverflowing}
                        onClick={handleStatusCardClick}

                        loading={loadings}
                        data={[
                          // { title: "All Letters", label: resultData, value: "null" },
                          {
                            title: "BBS",
                            label: letterTypeCounts?.BBS?.count,
                            value: "BBS",
                          },
                          {
                            title: "BILLING",
                            label: letterTypeCounts?.BILLING?.count,
                            value: "billing",
                          },
                          {
                            title: "Billing",
                            label: letterTypeCounts?.Billing?.count,
                            value: "billing",
                          },
                          {
                            title: "COS",
                            label: letterTypeCounts?.COS?.count,
                            value: "cos",
                          },
                          {
                            title: "DESIGN AND DRAWING",
                            label: letterTypeCounts?.DESIGN_AND_DRAWING?.count,
                            value: "Design & Drawing",
                          },
                          {
                            title: "DRAIN",
                            label: letterTypeCounts?.DRAIN?.count,
                            value: "Drain",
                          },
                          {
                            title: "Design",
                            label: letterTypeCounts?.Design.count,
                            value: "Design",
                          },
                          {
                            title: "EOT",
                            label: letterTypeCounts?.EOT?.count,
                            value: "eot",
                          },
                          {
                            title: "HYDROLOGY",
                            label: letterTypeCounts?.HYDROLOGY?.count,
                            value: "Hydrology",
                          },
                          {
                            title: "Informative",
                            label: letterTypeCounts?.Informative?.count,
                            value: "informative",
                          },
                          {
                            title: "Milestone",
                            label: letterTypeCounts?.Milestone?.count,
                            value: "Milestone",
                          },
                          {
                            title: "NCR",
                            label: letterTypeCounts?.NCR?.count,
                            value: "ncr",
                          },
                          {
                            title: "NOC",
                            label: letterTypeCounts?.NOC?.count,
                            value: "noc",
                          },
                          {
                            title: "Others",
                            label: letterTypeCounts?.Others?.count,
                            value: "other",
                          },
                          {
                            title: "P AND P",
                            label: letterTypeCounts?.P_AND_P?.count,
                            value: "P&P",
                          },
                          {
                            title: "QAP",
                            label: letterTypeCounts?.QAP?.count,
                            value: "QAP",
                          },
                          {
                            title: "Q AND ME",
                            label: letterTypeCounts?.Q_AND_ME?.count,
                            value: "Q & ME",
                          },
                          {
                            title: "Query",
                            label: letterTypeCounts?.Query?.count,
                            value: "query",
                          },
                          {
                            title: "ROAD SAFETY",
                            label: letterTypeCounts?.ROAD_SAFETY?.count,
                            value: "Road Safety",
                          },
                          {
                            title: "STRUCTURE",
                            label: letterTypeCounts?.STRUCTURE?.count,
                            value: "Structure",
                          },
                          {
                            title: "SURVEY",
                            label: letterTypeCounts?.SURVEY?.count,
                            value: "Survey",
                          },
                          {
                            title: "Show Cause",
                            label: letterTypeCounts?.ShowCause?.count,
                            value: "show-cause",
                          },
                          {
                            title: "Site Progress",
                            label: letterTypeCounts?.SiteProgress?.count,
                            value: "SiteProgress",
                          },
                          {
                            title: "WORK PLAN",
                            label: letterTypeCounts?.WORK_PLAN.count,
                            value: "Work Plan",
                          },
                        ]}
                        categoryCounts={categoryCounts}
                      /> */}
                    </div>
                  </>

                }
              </div>
              {
                role === "Admin" &&
                <div>
                  <BulkLetterDelete projectList={projectList} subcompany={toggleCompany} LetterTypeOptions={extendedLetterTypeOptions} getData={getLetters} />

                </div>

              }






            </div>

            {showAdvanced && (
              <Advancedstats
                showAdvanced={showAdvanced}
                SetShowAdvanced={SetShowAdvanced}
                AEname={aeName}
              />
            )}
            { }

            <SortingTable
              ref={sortingTableRef}
              excelData={excelData}
              error={error}
              buffer={bufferingLetter}
              siteRole={siteRole}
              projectID={project}
              filteredData={filteredData}
              rowRefs={rowRefs}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              calculateDaysBetweenDates={calculateDaysBetweenDates}
              formattedDateLong={formattedDateLong}
              getLetters={getLetters}
              project={project}
              projectList={projectList}
              letterData={letterData}
              extendedLetterTypeOptions={extendedLetterTypeOptions}
            />

            {totalPages > 1 && (
              <div className="pagination-controls">
                <button
                  className="pagination-nav-button"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                  Prev
                </button>

                <div className="pagination-buttons">
                  {renderPaginationButtons()}
                </div>

                <button
                  className="pagination-nav-button"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}>
                  Next
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            )}
          </>
        </div>
      </div >
    </>
  );



  // return (
  //   <LetterTrackingDashboard />
  // )
};



export { LetterTracking, AddLetterLinked };
